// GENERATED by tools/gen_protocol.py from metin3/net/schema.py. Do not edit.
//
// Every message on the wire, for the client side. The Python server is
// generated from the same schema in the same run.

import { ChangeMask, Reader, Writer } from "./codec";

export const PROTOCOL_VERSION = 2;
export const SCHEMA_HASH = 0x0C681748;

/**
 * One entity's change since the client's last acknowledged snapshot. Unchanged fields cost one bit, so a standing player is a few bytes.

**An absent field means unchanged, never zero.** Every optional field below is gated by a change-mask bit, and a reader that folds a missing one into a default has invented world state: a player whose `x_mm` did not change this tick is not a player at the origin, and one whose `weapon` did not change is not a player who just dropped his sword. `tools/prodcheck.py` had exactly that bug against `x_mm` once. The reference decoder is `server/snapshot.py`'s `apply_delta`, and the only place a default is legitimate is the first sight of an entity, where there is no previous value to keep.
 */
export class EntityDelta {
  id: number = 0;
  x_mm: number | null = null;
  y_mm: number | null = null;
  heading: number | null = null;
  gait: number | null = null;
  name: string | null = null;
  kind: number | null = null;
  hp: number | null = null;
  max_hp: number | null = null;
  level: number | null = null;
  flags: number | null = null;
  item_kind: number | null = null;
  weapon: number | null = null;
  armour: number | null = null;
  race: number | null = null;
  polymorph: string | null = null;
  mount: number | null = null;
  horse_vnum: number | null = null;
  building_vnum: number | null = null;
  item_owner: string | null = null;
  item_public_at_tick: number | null = null;
  item_socket: number | null = null;
  item_socket1: number | null = null;
  item_socket2: number | null = null;
  hair: number | null = null;
  footprint_x0_mm: number | null = null;
  footprint_y0_mm: number | null = null;
  footprint_x1_mm: number | null = null;
  footprint_y1_mm: number | null = null;
  guild_id: number | null = null;
  gm_level: number | null = null;
  mob_vnum: number | null = null;
  affect_flags: number | null = null;

  encode(w: Writer): void {
    const mask = new ChangeMask();
    if (this.x_mm !== null) mask.set(1);
    if (this.y_mm !== null) mask.set(2);
    if (this.heading !== null) mask.set(3);
    if (this.gait !== null) mask.set(4);
    if (this.name !== null) mask.set(5);
    if (this.kind !== null) mask.set(6);
    if (this.hp !== null) mask.set(7);
    if (this.max_hp !== null) mask.set(8);
    if (this.level !== null) mask.set(9);
    if (this.flags !== null) mask.set(10);
    if (this.item_kind !== null) mask.set(11);
    if (this.weapon !== null) mask.set(12);
    if (this.armour !== null) mask.set(13);
    if (this.race !== null) mask.set(14);
    if (this.polymorph !== null) mask.set(15);
    if (this.mount !== null) mask.set(16);
    if (this.horse_vnum !== null) mask.set(17);
    if (this.building_vnum !== null) mask.set(18);
    if (this.item_owner !== null) mask.set(19);
    if (this.item_public_at_tick !== null) mask.set(20);
    if (this.item_socket !== null) mask.set(21);
    if (this.item_socket1 !== null) mask.set(22);
    if (this.item_socket2 !== null) mask.set(23);
    if (this.hair !== null) mask.set(24);
    if (this.footprint_x0_mm !== null) mask.set(25);
    if (this.footprint_y0_mm !== null) mask.set(26);
    if (this.footprint_x1_mm !== null) mask.set(27);
    if (this.footprint_y1_mm !== null) mask.set(28);
    if (this.guild_id !== null) mask.set(29);
    if (this.gm_level !== null) mask.set(30);
    if (this.mob_vnum !== null) mask.set(31);
    if (this.affect_flags !== null) mask.set(32);
    w.varint(this.id);
    mask.write(w);
    if (this.x_mm !== null) w.svarint(this.x_mm);
    if (this.y_mm !== null) w.svarint(this.y_mm);
    if (this.heading !== null) w.bits(this.heading, 12);
    if (this.gait !== null) w.u8(this.gait);
    if (this.name !== null) w.string(this.name);
    if (this.kind !== null) w.varint(this.kind);
    if (this.hp !== null) w.varint(this.hp);
    if (this.max_hp !== null) w.varint(this.max_hp);
    if (this.level !== null) w.varint(this.level);
    if (this.flags !== null) w.varint(this.flags);
    if (this.item_kind !== null) w.u8(this.item_kind);
    if (this.weapon !== null) w.varint(this.weapon);
    if (this.armour !== null) w.varint(this.armour);
    if (this.race !== null) w.u8(this.race);
    if (this.polymorph !== null) w.string(this.polymorph);
    if (this.mount !== null) w.varint(this.mount);
    if (this.horse_vnum !== null) w.varint(this.horse_vnum);
    if (this.building_vnum !== null) w.varint(this.building_vnum);
    if (this.item_owner !== null) w.string(this.item_owner);
    if (this.item_public_at_tick !== null) w.varint(this.item_public_at_tick);
    if (this.item_socket !== null) w.varint(this.item_socket);
    if (this.item_socket1 !== null) w.varint(this.item_socket1);
    if (this.item_socket2 !== null) w.varint(this.item_socket2);
    if (this.hair !== null) w.varint(this.hair);
    if (this.footprint_x0_mm !== null) w.svarint(this.footprint_x0_mm);
    if (this.footprint_y0_mm !== null) w.svarint(this.footprint_y0_mm);
    if (this.footprint_x1_mm !== null) w.svarint(this.footprint_x1_mm);
    if (this.footprint_y1_mm !== null) w.svarint(this.footprint_y1_mm);
    if (this.guild_id !== null) w.varint(this.guild_id);
    if (this.gm_level !== null) w.varint(this.gm_level);
    if (this.mob_vnum !== null) w.varint(this.mob_vnum);
    if (this.affect_flags !== null) w.varint(this.affect_flags);
  }

  static decode(r: Reader): EntityDelta {
    const self = new EntityDelta();
    self.id = r.varint();
    const mask = ChangeMask.read(r);
    if (mask.has(1)) self.x_mm = r.svarint();
    if (mask.has(2)) self.y_mm = r.svarint();
    if (mask.has(3)) self.heading = r.bits(12);
    if (mask.has(4)) self.gait = r.u8();
    if (mask.has(5)) self.name = r.string();
    if (mask.has(6)) self.kind = r.varint();
    if (mask.has(7)) self.hp = r.varint();
    if (mask.has(8)) self.max_hp = r.varint();
    if (mask.has(9)) self.level = r.varint();
    if (mask.has(10)) self.flags = r.varint();
    if (mask.has(11)) self.item_kind = r.u8();
    if (mask.has(12)) self.weapon = r.varint();
    if (mask.has(13)) self.armour = r.varint();
    if (mask.has(14)) self.race = r.u8();
    if (mask.has(15)) self.polymorph = r.string();
    if (mask.has(16)) self.mount = r.varint();
    if (mask.has(17)) self.horse_vnum = r.varint();
    if (mask.has(18)) self.building_vnum = r.varint();
    if (mask.has(19)) self.item_owner = r.string();
    if (mask.has(20)) self.item_public_at_tick = r.varint();
    if (mask.has(21)) self.item_socket = r.varint();
    if (mask.has(22)) self.item_socket1 = r.varint();
    if (mask.has(23)) self.item_socket2 = r.varint();
    if (mask.has(24)) self.hair = r.varint();
    if (mask.has(25)) self.footprint_x0_mm = r.svarint();
    if (mask.has(26)) self.footprint_y0_mm = r.svarint();
    if (mask.has(27)) self.footprint_x1_mm = r.svarint();
    if (mask.has(28)) self.footprint_y1_mm = r.svarint();
    if (mask.has(29)) self.guild_id = r.varint();
    if (mask.has(30)) self.gm_level = r.varint();
    if (mask.has(31)) self.mob_vnum = r.varint();
    if (mask.has(32)) self.affect_flags = r.varint();
    return self;
  }
}

/**
 * Which item one thing lying on the ground is, carried by the snapshot that brings it into view.

`CItem::EncodeInsertPacket` sends `TPacketGCItemGroundAdd` with the item's vnum each time it enters a viewer's sight (`item.cpp:118-137`, `packet.h:1113-1119`), and `RecvItemGroundAddPacket` hands that vnum to `CPythonItem::CreateItem`, which draws the item's drop model (`PythonNetworkStreamPhaseGameItem.cpp:296-311`, `PythonItem.cpp:290-294`). **An array on `Snapshot` rather than a field on `EntityDelta` or a frame of its own**: `mob_vnum` on `EntityDelta` is a character's race number, not an item's, and every server-to-client opcode is taken or reserved. The snapshot is this wire's insert packet, so the vnum travels in the same frame as the first sight it belongs to. The vnum is a key into `dropmodels/index.json`, the models the client ships, and reads no item table.
 */
export class GroundItemVnum {
  entity_id: number = 0;
  vnum: number = 0;

  encode(w: Writer): void {
    w.varint(this.entity_id);
    w.varint(this.vnum);
  }

  static decode(r: Reader): GroundItemVnum {
    const self = new GroundItemVnum();
    self.entity_id = r.varint();
    self.vnum = r.varint();
    return self;
  }
}

/**
 * A body in view began a skill motion this tick: 2014's move packet with a skill function, which the server relays to everyone around the mover but the mover (`input_main.cpp:1285-1334`, `char_state.cpp:1095`, `BlueDragon.cpp:126`) and every observer turns into the motion (`InstanceBase.cpp:1464-1492`, `:1524-1554`).
 */
export class SkillMotionBegun {
  entity_id: number = 0;
  motion: number = 0;
  grade: number = 0;

  encode(w: Writer): void {
    w.varint(this.entity_id);
    w.varint(this.motion);
    w.u8(this.grade);
  }

  static decode(r: Reader): SkillMotionBegun {
    const self = new SkillMotionBegun();
    self.entity_id = r.varint();
    self.motion = r.varint();
    self.grade = r.u8();
    return self;
  }
}

/**
 * One occupied slot, in the bag or on the character.

The same shape for both, because they carry the same facts and a second struct would be a second place to forget a field. In `worn` the `slot` is a `WearSlot` rather than a bag index.

The name and the icon travel with the slot rather than being looked up client-side, because the alternative is shipping the item table to the client -- five hundred rows of balance data, downloaded by everyone, so that forty-five slots can be labelled. A bag changes a few times a minute and this is the message that carries it.
 */
export class BagSlot {
  slot: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  sell_value: number = 0;
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;
  bonuses: ItemBonus[] = [];

  encode(w: Writer): void {
    w.varint(this.slot);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.sell_value);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
  }

  static decode(r: Reader): BagSlot {
    const self = new BagSlot();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.sell_value = r.varint();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * One shelf on a dealer's counter.

`slot` is a cell in the shop's own five-by-nine grid, not an index into this array. The two differ as soon as two items have different heights -- in the weapon shop, at the fifth shelf -- because the server lays the stock out exactly as `CShop::SetShopItems` does and a purchase names the cell. A client that sent back its own list position would buy a different sword than the one it drew.

`price` is what the whole shelf costs, already multiplied by `count` server-side: a shelf is a bundle -- the general store sells Red Potion(S) as 5, as 20 and as 200 -- and the `COUNT_PER_1GOLD` items invert the arithmetic entirely. The same rule `BagSlot.sell_value` follows, for the same reason: a price a client computed is a price the server would then have to refuse.
 */
export class ShopSlot {
  slot: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  price: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;

  encode(w: Writer): void {
    w.varint(this.slot);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.price);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
  }

  static decode(r: Reader): ShopSlot {
    const self = new ShopSlot();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.price = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    return self;
  }
}

/**
 * One entry on the skill bar, as the server holds it.

Everything a bar needs to draw itself and nothing it could use to decide anything. The name and the icon travel with the slot for the same reason a bag slot carries them: the alternative is shipping the skill table to the client, which is seventy-seven rows of balance data downloaded by everyone so that five buttons can be labelled.

`cooldown_left` is a *duration*, never an absolute tick. A tick number would be a number from the server's clock that the client would have to subtract from its own, and the two do not agree -- which is the same reason `Welcome` sends `respawn_ticks` rather than a deadline. The client counts this down locally and the next frame corrects it.
 */
export class SkillSlot {
  slot: number = 0;
  vnum: number = 0;
  level: number = 0;
  max_level: number = 0;
  sp_cost: number = 0;
  cooldown_ticks: number = 0;
  cooldown_left: number = 0;
  name: string = "";
  icon: string = "";
  flags: number = 0;

  encode(w: Writer): void {
    w.varint(this.slot);
    w.varint(this.vnum);
    w.varint(this.level);
    w.varint(this.max_level);
    w.varint(this.sp_cost);
    w.varint(this.cooldown_ticks);
    w.varint(this.cooldown_left);
    w.string(this.name);
    w.string(this.icon);
    w.u8(this.flags);
  }

  static decode(r: Reader): SkillSlot {
    const self = new SkillSlot();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.level = r.varint();
    self.max_level = r.varint();
    self.sp_cost = r.varint();
    self.cooldown_ticks = r.varint();
    self.cooldown_left = r.varint();
    self.name = r.string();
    self.icon = r.string();
    self.flags = r.u8();
    return self;
  }
}

/**
 * One live timed modifier on the recipient. See `server/affects.py`.

Carries what applied it rather than a display string, so the client can match it to the skill bar entry it already has a name for.
 */
export class AffectSlot {
  source: number = 0;
  apply: number = 0;
  value: number = 0;
  remaining: number = 0;

  encode(w: Writer): void {
    w.varint(this.source);
    w.u8(this.apply);
    w.svarint(this.value);
    w.varint(this.remaining);
  }

  static decode(r: Reader): AffectSlot {
    const self = new AffectSlot();
    self.source = r.varint();
    self.apply = r.u8();
    self.value = r.svarint();
    self.remaining = r.varint();
    return self;
  }
}

/**
 * One line of what an NPC is saying.

A `kind` rather than a colour, which is where this deliberately parts from the original. There, `say_title` and `say_reward` are `say` with `color256(255,230,186)` and `color256(255,200,200)` wrapped round the text (`questlib.lua:91-92`), and an item is an `[INSERT_IMAGE ...]` tag the client parses back out of the sentence. Both mean the server ships markup and the client is obliged to understand a tag language to render a conversation. This ships the meaning and lets the client choose the ink -- which is also the only way a line survives being read aloud, logged, or drawn by a client that has no such palette.
 */
export class QuestLine {
  kind: number = 0;
  item_vnum: number = 0;
  text: string = "";

  encode(w: Writer): void {
    w.u8(this.kind);
    w.varint(this.item_vnum);
    w.string(this.text);
  }

  static decode(r: Reader): QuestLine {
    const self = new QuestLine();
    self.kind = r.u8();
    self.item_vnum = r.varint();
    self.text = r.string();
    return self;
  }
}

/**
 * One option the player may pick, as the server worded it.

A struct rather than a bare string array because the codec's repeated fields carry structs or varints and nothing else -- and because an option is a thing that will grow a disabled flag before it grows a second string.
 */
export class QuestChoice {
  text: string = "";

  encode(w: Writer): void {
    w.string(this.text);
  }

  static decode(r: Reader): QuestChoice {
    const self = new QuestChoice();
    self.text = r.string();
    return self;
  }
}

/**
 * One row of the quest log: what a quest is called and what it wants next.

`index` is the quest's position in the server's own load order, and it is what a `QuestInfo` names. Deliberately not the quest's *name*: a name on the wire is a string a client could invent, and the server would then be matching untrusted text against its script table. An index out of range selects nothing.
 */
export class QuestEntry {
  index: number = 0;
  title: string = "";
  counter_name: string = "";
  counter: number = 0;
  clock_name: string = "";
  clock_seconds: number = 0;
  target_id: number = 0;
  target_desc: string = "";

  encode(w: Writer): void {
    w.varint(this.index);
    w.string(this.title);
    w.string(this.counter_name);
    w.svarint(this.counter);
    w.string(this.clock_name);
    w.varint(this.clock_seconds);
    w.varint(this.target_id);
    w.string(this.target_desc);
  }

  static decode(r: Reader): QuestEntry {
    const self = new QuestEntry();
    self.index = r.varint();
    self.title = r.string();
    self.counter_name = r.string();
    self.counter = r.svarint();
    self.clock_name = r.string();
    self.clock_seconds = r.varint();
    self.target_id = r.varint();
    self.target_desc = r.string();
    return self;
  }
}

/**
 * One entry of the map screen's NPC roster: `TNPCPosition` (`packet.h:1917-1923`).

`InsertNPCPosition` records the *midpoint of the regen row's rectangle* rather than the entity's live position (`regen.cpp:677-687`), and no later movement updates it, so this is where the map was authored to put that NPC and not where it is standing now. The client draws it on the atlas and on nothing else.
 */
export class NpcMarker {
  kind: number = 0;
  name: string = "";
  x_mm: number = 0;
  y_mm: number = 0;

  encode(w: Writer): void {
    w.varint(this.kind);
    w.string(this.name);
    w.svarint(this.x_mm);
    w.svarint(this.y_mm);
  }

  static decode(r: Reader): NpcMarker {
    const self = new NpcMarker();
    self.kind = r.varint();
    self.name = r.string();
    self.x_mm = r.svarint();
    self.y_mm = r.svarint();
    return self;
  }
}

/**
 * One ingredient of a refinement, and how close the player is to having it.

`have` travels with `need` because the alternative is the client counting its own bag. It could -- the bag is already there -- and it would be wrong the moment a material is one the client cannot see, such as a stack split across slots or an item the shard's table names differently. `refine.py` counts with `Bag.count_of` across every slot, and this is that number rather than a second one.
 */
export class RefineMaterial {
  vnum: number = 0;
  name: string = "";
  need: number = 0;
  have: number = 0;
  kind: number = 0;

  encode(w: Writer): void {
    w.varint(this.vnum);
    w.string(this.name);
    w.u8(this.need);
    w.varint(this.have);
    w.u8(this.kind);
  }

  static decode(r: Reader): RefineMaterial {
    const self = new RefineMaterial();
    self.vnum = r.varint();
    self.name = r.string();
    self.need = r.u8();
    self.have = r.varint();
    self.kind = r.u8();
    return self;
  }
}

/**
 * One item as a window that is not the bag draws it.

Everything a `BagSlot` carries except `sell_value`, because neither a trade window nor a storeroom cell has a dealer behind it and a price shown where nothing is being sold is a number that invites a click. Everything *else* is shared word for word -- the identifying five, the rolled `bonuses` and `item_facts()`'s stat block -- and shared by construction rather than by copy, because two shapes carrying the same facts is two places to forget a field. One struct for both windows, for the reason `BagSlot` is one struct for the bag and the body.

`slot` is whatever index the window it belongs to addresses -- a bag slot in an exchange offer, a cell in a storeroom -- and it is what the matching request names. Never this row's position in the array: the arrays are sparse, so the two differ as soon as anything is withdrawn.
 */
export class ItemView {
  slot: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;
  bonuses: ItemBonus[] = [];

  encode(w: Writer): void {
    w.varint(this.slot);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
  }

  static decode(r: Reader): ItemView {
    const self = new ItemView();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * One occupied cell of the account storeroom.

This is deliberately separate from `ItemView`: a trade offer is not a storage flow. `CSafebox::Add` sends the live item's sockets with the item (`safebox.cpp:57-61`; `TPacketGCItemSet` in `packet.h`), so all three instance values travel here, but changing this shape does not silently widen the exchange wire.
 */
export class SafeboxSlot {
  slot: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;
  bonuses: ItemBonus[] = [];

  encode(w: Writer): void {
    w.varint(this.slot);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
  }

  static decode(r: Reader): SafeboxSlot {
    const self = new SafeboxSlot();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * One positive party bonus shown on a member's board. These are the seven positional values from `TPacketGCPartyUpdate.affects`, made sparse so zero-value icons do not travel. The server chooses both the slot and value from the live party (`char.cpp:5536-5561`); the client only draws the supplied badge.
 */
export class PartyAffect {
  kind: number = 0;
  value: number = 0;

  encode(w: Writer): void {
    w.u8(this.kind);
    w.svarint(this.value);
  }

  static decode(r: Reader): PartyAffect {
    const self = new PartyAffect();
    self.kind = r.u8();
    self.value = r.svarint();
    return self;
  }
}

/**
 * One player in a party, as the roster panel draws them.

`level` is here because it is the only number that decides what a member is paid: `party.py`'s split weighs each share by `party_exp_distribute_table[level]`, which is neither the level nor anything a client could derive from it -- the ratio between level 1 and level 90 is 880 to 1, not 90 to 1. So the level travels and the table stays server-side, because a client that reconstructed the weight would be inventing the one rule players check against each other.

`near` is whether this member is standing with the leader, which is what the headcount bonus is counted from (`party.cpp:1311-1337`). Sent rather than computed: the client knows where entities in view are, and a member two hundred metres away is not in view at all, so a client working it out would draw everyone it cannot see as absent. Note the collapse the module keeps -- when only one member is near, nobody is (`party.cpp:1331-1337`), so a lone leader's own row reads false.
 */
export class PartyMember {
  entity_id: number = 0;
  name: string = "";
  level: number = 0;
  leader: boolean = false;
  near: boolean = false;
  role: number = 0;
  role_bonus: number = 0;
  hp_percent: number = 0;
  affects: PartyAffect[] = [];

  encode(w: Writer): void {
    w.varint(this.entity_id);
    w.string(this.name);
    w.varint(this.level);
    w.boolean(this.leader);
    w.boolean(this.near);
    w.u8(this.role);
    w.varint(this.role_bonus);
    w.u8(this.hp_percent);
    w.varint(this.affects.length);
    for (const item of this.affects)
      item.encode(w);
  }

  static decode(r: Reader): PartyMember {
    const self = new PartyMember();
    self.entity_id = r.varint();
    self.name = r.string();
    self.level = r.varint();
    self.leader = r.boolean();
    self.near = r.boolean();
    self.role = r.u8();
    self.role_bonus = r.varint();
    self.hp_percent = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.affects.push(PartyAffect.decode(r));
    }
    return self;
  }
}

/**
 * One player in a guild, as the roster panel draws them.

The difference from `PartyMember` is the whole of what a guild is: these rows outlive the sessions that created them. A party is keyed by entity and dies with its leader's connection; guild membership is a row that survives a logout (`CGuild::LogoutMember` removes the character from the *online* set and pointedly leaves `m_member` alone, `guild.cpp:296-315`). So `online` is a field here and `near` is not: the useful question about a guildmate is whether they are here at all, and a distance to somebody who may be on another map is not a number either side can produce.

There is no id on this row, of either kind, and both absences are deliberate. Not the persistent player identity, which is the key to everything that player owns and would be sitting on thirty-two other people's wires as a label. Not the entity id either: nothing in this build acts on a guild member by id -- expulsion and promotion have no message this round -- and an id nothing consumes is a handle for somebody the recipient may not be able to see, handed out for free. `PartyMember` carries one because the party's own rules are distances between the members it names.

`grade` and `grade_name` travel together because one is the rule and the other is the label: permissions hang off the number (`CGuild::HasGradeAuth`, `guild.h:232`), and the name is editable per guild (`guild.cpp:783-829`) so a client with a hardcoded table would print the wrong word for every guild that renamed a rank. Grade 1 is the master and is the same fact as `Guild.master` -- see `guild.py`'s module docstring on why the original stores that twice and this build does not.

`is_general` is the server-owned selected-general marker, persisted on the roster and refreshed with the whole guild frame. The original broadcasts the changed pid and byte (`guild.cpp:1088-1127`); this roster uses its stable row order instead of putting a persistent pid on the wire.
 */
export class GuildMember {
  name: string = "";
  level: number = 0;
  grade: number = 0;
  grade_name: string = "";
  online: boolean = false;
  is_general: boolean = false;
  job: number = 0;
  offer: number = 0;

  encode(w: Writer): void {
    w.string(this.name);
    w.varint(this.level);
    w.varint(this.grade);
    w.string(this.grade_name);
    w.boolean(this.online);
    w.boolean(this.is_general);
    w.u8(this.job);
    w.varint(this.offer);
  }

  static decode(r: Reader): GuildMember {
    const self = new GuildMember();
    self.name = r.string();
    self.level = r.varint();
    self.grade = r.varint();
    self.grade_name = r.string();
    self.online = r.boolean();
    self.is_general = r.boolean();
    self.job = r.u8();
    self.offer = r.varint();
    return self;
  }
}

/**
 * One durable guild-board row. The id, author name and text are all server-authored (`CGuild::RefreshCommentForce`, guild.cpp:1048-1050); clients never provide the guild identity or author when posting.
 */
export class GuildComment {
  id: number = 0;
  name: string = "";
  content: string = "";

  encode(w: Writer): void {
    w.varint(this.id);
    w.string(this.name);
    w.string(this.content);
  }

  static decode(r: Reader): GuildComment {
    const self = new GuildComment();
    self.id = r.varint();
    self.name = r.string();
    self.content = r.string();
    return self;
  }
}

/**
 * One guild this guild is at war with, for the Guild Information page's own list of them.

The page has `ENEMY_GUILD_SLOT_MAX_COUNT` = 6 slots (`PythonGuild.h:11`), filled by `RefreshGuildInfoPage` from `CPythonGuild`'s enemy table and kept in step by `OnStartGuildWar` and `OnEndGuildWar` (`uiguild.py:1497-1505,1953-1981`). The original maintains that table from `BINARY_GuildWar_OnStart`/`OnEnd` events; this sends the whole list with the war frame for `Guild`'s own reason -- six short rows that change a handful of times a day, and a list built from events is a list that can drift.

Carries the name as well as the id because a guild you are at war with is not necessarily a guild whose name you have been told: `GuildName` arrives only for a guild whose members you can see.
 */
export class GuildWarEnemy {
  guild_id: number = 0;
  name: string = "";

  encode(w: Writer): void {
    w.varint(this.guild_id);
    w.string(this.name);
  }

  static decode(r: Reader): GuildWarEnemy {
    const self = new GuildWarEnemy();
    self.guild_id = r.varint();
    self.name = r.string();
    return self;
  }
}

/**
 * One challenge the server is willing to accept right now. `token` is an opaque, session-bound name for this exact candidate; it is consumed on the first answer. The remaining fields are human-readable display only, never request identity.
 */
export class GuildWarChoice {
  token: number = 0;
  name: string = "";
  opponent: string = "";
  mode: string = "";
  summary: string = "";

  encode(w: Writer): void {
    w.varint(this.token);
    w.string(this.name);
    w.string(this.opponent);
    w.string(this.mode);
    w.string(this.summary);
  }

  static decode(r: Reader): GuildWarChoice {
    const self = new GuildWarChoice();
    self.token = r.varint();
    self.name = r.string();
    self.opponent = r.string();
    self.mode = r.string();
    self.summary = r.string();
    return self;
  }
}

/**
 * One of an account's character slots, filled or empty.

Empty slots are sent too, and that is the reason this is a struct rather than a list of the characters that exist: a creation screen has to draw the hole it is about to fill, and a client that inferred 'slot 2 is free because no row mentions it' would be inferring it from an array whose length it also has to trust. `filled` says so outright, and every other field on an empty slot is zero or blank.

`race` and `job` both travel, which looks redundant and is not. The race is what was *chosen* -- one of eight, a class and a sex together (`char.h:36-46`) -- and the job is what the server *derived* from it through `RaceToJob` (`input_login.cpp:312-353`). The client needs the race to pick a body to draw and the job to name a class, and the map between them is not one a client should carry: it is neither `race // 2` nor anything else with an arithmetic shape, and a client that guessed would label four of the eight bodies with the wrong class. Sending both is four bytes to make that disagreement impossible.

The four statistics are here because they are the only thing that visibly differs between two level-one characters, and because the creation screen has to show what a class *is* before it is chosen. They are the server's -- `JobInitialPoints[job]` and nothing else (`input_login.cpp:388-391`) -- so a slot list is also the answer to 'what did I actually get'. The original's own slot record carries the same four (`TSimplePlayer`, `common/tables.h:297-313`).

No entity id and no database id. A slot is a row on a screen the player is looking at before there is a world, and an id that named the character in storage would be an id a later message could be made to name. Every message that acts on a slot names the *slot*.
 */
export class CharacterSlot {
  slot: number = 0;
  filled: boolean = false;
  name: string = "";
  race: number = 0;
  job: number = 0;
  level: number = 0;
  st: number = 0;
  ht: number = 0;
  dx: number = 0;
  iq: number = 0;
  playtime: number = 0;
  main_part: number = 0;
  hair_part: number = 0;

  encode(w: Writer): void {
    w.u8(this.slot);
    w.boolean(this.filled);
    w.string(this.name);
    w.u8(this.race);
    w.u8(this.job);
    w.varint(this.level);
    w.varint(this.st);
    w.varint(this.ht);
    w.varint(this.dx);
    w.varint(this.iq);
    w.varint(this.playtime);
    w.varint(this.main_part);
    w.varint(this.hair_part);
  }

  static decode(r: Reader): CharacterSlot {
    const self = new CharacterSlot();
    self.slot = r.u8();
    self.filled = r.boolean();
    self.name = r.string();
    self.race = r.u8();
    self.job = r.u8();
    self.level = r.varint();
    self.st = r.varint();
    self.ht = r.varint();
    self.dx = r.varint();
    self.iq = r.varint();
    self.playtime = r.varint();
    self.main_part = r.varint();
    self.hair_part = r.varint();
    return self;
  }
}

/**
 * One of the four classes, as a creation screen has to describe it.

Sent rather than shipped with the client, and that is `BagSlot`'s argument in a place where it is easier to get wrong. A creation screen has to say what a warrior *is* before anybody is one -- six strength, 760 health -- and the client's alternatives are to carry a copy of `JobInitialPoints` (`constants.cpp:16-22`) or to draw four bars with no numbers behind them. The first is a balance table downloaded by everyone so that four cards can be labelled, and it is a copy free to fall behind the server's; the second is a screen that lies decoratively. Forty bytes, once, at the one moment a player is actually reading them.

`male_race` and `female_race` are the two values `CreateCharacter.race` may take for this class. They travel because the mapping is `RaceToJob` inverted (`input_login.cpp:312-353`) and it is neither `job * 2` nor `job + 4` nor anything else a client can compute: the warrior's two are 0 and 4, the assassin's are 5 and 1, and the pairing is a switch statement rather than a formula. A client that derived them would create a shaman when the player clicked the warrior.

`max_hp` and `max_sp` are the level-one values, already through `char.cpp:2172-2173` -- `job.max_hp + CON * job.hp_per_ht` and `job.max_sp + INT * job.sp_per_iq`. Computed server-side for the reason `BagSlot.sell_value` is: a client multiplying the parts would be reimplementing an arithmetic it has no way to check, and the number on the card would stop matching the number on the character sheet the moment either changed.

There is no description text here. What a class is *like* to play is prose, it is the client's to write, and it is the one thing on this card that does not go stale when the table does.
 */
export class ClassOffer {
  job: number = 0;
  name: string = "";
  male_race: number = 0;
  female_race: number = 0;
  st: number = 0;
  ht: number = 0;
  dx: number = 0;
  iq: number = 0;
  max_hp: number = 0;
  max_sp: number = 0;

  encode(w: Writer): void {
    w.u8(this.job);
    w.string(this.name);
    w.u8(this.male_race);
    w.u8(this.female_race);
    w.varint(this.st);
    w.varint(this.ht);
    w.varint(this.dx);
    w.varint(this.iq);
    w.varint(this.max_hp);
    w.varint(this.max_sp);
  }

  static decode(r: Reader): ClassOffer {
    const self = new ClassOffer();
    self.job = r.u8();
    self.name = r.string();
    self.male_race = r.u8();
    self.female_race = r.u8();
    self.st = r.varint();
    self.ht = r.varint();
    self.dx = r.varint();
    self.iq = r.varint();
    self.max_hp = r.varint();
    self.max_sp = r.varint();
    return self;
  }
}

/**
 * One rolled bonus on one item instance -- what makes two swords of the same vnum different swords.

`itemattr.py` has rolled these on every drop since the `item_attr` tables arrived, `itemstore.py` persists them in a `bonuses` column and `equipment.combat_for` applies them; until this struct existed none of it reached the player, so a rolled sword looked exactly like a plain one.

**The type and the value, never a sentence.** The obvious shortcut is to format the line server-side and send the finished string -- the server already knows which bonus this is -- and it is the wrong trade: a rendered string cannot be localised by a client that speaks another language, cannot be restyled, cannot be compared against what is already worn, and cannot be coloured by sign without being parsed back apart. The original ships the pair too (`TPlayerItemAttribute { BYTE bType; short sValue; }`, `common/tables.h:332-336`) and formats it in `uitooltip.py`'s `AFFECT_DICT`. So does this: `client/src/ui/itembonus.ts` is that table.

At most seven of these travel with one item -- `ITEM_ATTRIBUTE_MAX_NUM` (`common/item_length.h:13`), five ordinary slots plus the two rare ones -- and a drop puts at most three (`item.cpp:1139-1187`). The overwhelming majority of items carry none, which is why this is a length-prefixed array and not five fixed pairs: an ordinary potion costs one byte to say 'nothing'.
 */
export class ItemBonus {
  apply: number = 0;
  value: number = 0;

  encode(w: Writer): void {
    w.varint(this.apply);
    w.svarint(this.value);
  }

  static decode(r: Reader): ItemBonus {
    const self = new ItemBonus();
    self.apply = r.varint();
    self.value = r.svarint();
    return self;
  }
}

/**
 * One line of what a seller is putting on their own stall.

`TShopItemTable`'s three PC-shop fields and no others -- `pos`, `price` and `display_pos`, the three whose comments in `common/tables.h:553-555` say they are used by a PC shop. What is *not* here is the whole of the anti-cheat: there is no vnum and no count.

**No vnum**, for `MoveItem`'s reason. A client that could say "cell three holds a Sword+9" is a client that can sell a sword it does not own; the server reads whatever is in the named cell and lists that, or drops the line. The original agrees: `CShop::SetShopItems` fetches `m_pkPC->GetItem(pTable->pos)` and never reads the `vnum` column at all for a PC shop (`shop.cpp:93-105`).

**No count**, and the original left a comment on the line saying so -- `item.count = pkItem->GetCount()` at `shop.cpp:162`, annotated in Korean that for a PC shop the count must be the real item's count. A seller who could name a count could sell twenty potions out of a stack of one.

`price` is the one number that is genuinely the seller's, because it is the only one that is a *choice* rather than a fact (`shop.cpp:163`). It is bounded rather than trusted: a listing priced at nothing or above `MAX_GOLD` is dropped, and `Stalls.open` refuses the whole stall when the sum of every asking price plus the gold already held would overflow the purse (`char.cpp:576-590`).
 */
export class StallListing {
  source_slot: number = 0;
  display_pos: number = 0;
  price: number = 0;

  encode(w: Writer): void {
    w.varint(this.source_slot);
    w.varint(this.display_pos);
    w.varint(this.price);
  }

  static decode(r: Reader): StallListing {
    const self = new StallListing();
    self.source_slot = r.varint();
    self.display_pos = r.varint();
    self.price = r.varint();
    return self;
  }
}

/**
 * One shelf of somebody's stall, as a buyer's window draws it.

`ItemView` plus a price, and a separate struct rather than a sixth field on that one for the reason `ShopSlot` is separate too: a trade offer and a storeroom cell have no price, and a field that is meaningless in two windows out of three is a field somebody eventually draws in them.

It carries `bonuses` where `ShopSlot` does not, and the difference is real rather than cosmetic. A dealer's shelf is not an item yet -- the original mints it inside `CShop::Buy` (`shop.cpp:249`) and the magic-item roll happens there -- whereas a stall shelf *is* one particular sword sitting in one particular bag cell, already rolled. A buyer looking at a stall is looking at the instance they will get, which is exactly why the original copies the sockets and the attributes off the live item into the frame (`shop.cpp:437-441`).

`slot` is the display cell, which is what `BuyFromStall` names. Never this row's position in the array: a stall's cells are sparse by construction -- the seller picks them -- and a sold-out shelf is left out of the frame entirely (`shop.cpp:422`, `if (m_pkPC && !item.pkItem) continue;`), so the two differ constantly.
 */
export class StallSlot {
  slot: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  price: number = 0;
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;
  bonuses: ItemBonus[] = [];

  encode(w: Writer): void {
    w.varint(this.slot);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.price);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
  }

  static decode(r: Reader): StallSlot {
    const self = new StallSlot();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.price = r.varint();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * One thing a cube counter knows how to build, as the panel has to draw it.

The whole list is sent unprompted-but-once, in answer to `CubeInfo`, and it is what `Cube_request_result_list` and `Cube_request_material_info` send in the original -- two chat-command replies (`/cube r_list`, `/cube m_info`, `cmd_general.cpp:2160-2183`) that between them carry exactly these fields as slash-and-comma delimited text.

There is no index on this row, and that is deliberate rather than an omission. `FN_find_cube` (`cube.cpp:145-160`) walks the recipe list in file order and takes the **first** one this NPC owns whose materials are all present in the tray -- a player never names a recipe, they fill a counter and the table decides. An index here would be an index `CubeMake` could carry back, and a client that names a recipe is a client that picks the most valuable one its tray happens to satisfy. So the list is a description of what the counter can do and nothing on it is an argument to anything.

`ready` is `RefineOffer.affordable`'s twin and has its job: it greys a row out, it never permits a build. The server re-reads the tray, the recipe and the purse when `CubeMake` arrives, out of the same table.
 */
export class CubeRecipe {
  reward_vnum: number = 0;
  reward_name: string = "";
  reward_count: number = 0;
  reward_kind: number = 0;
  gold: number = 0;
  chance: number = 0;
  ready: boolean = false;
  materials: RefineMaterial[] = [];

  encode(w: Writer): void {
    w.varint(this.reward_vnum);
    w.string(this.reward_name);
    w.varint(this.reward_count);
    w.u8(this.reward_kind);
    w.varint(this.gold);
    w.u8(this.chance);
    w.boolean(this.ready);
    w.varint(this.materials.length);
    for (const item of this.materials)
      item.encode(w);
  }

  static decode(r: Reader): CubeRecipe {
    const self = new CubeRecipe();
    self.reward_vnum = r.varint();
    self.reward_name = r.string();
    self.reward_count = r.varint();
    self.reward_kind = r.u8();
    self.gold = r.varint();
    self.chance = r.u8();
    self.ready = r.boolean();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.materials.push(RefineMaterial.decode(r));
    }
    return self;
  }
}

/**
 * One stat a dragon soul rolled, and how much of it.

`apply` is the literal token out of `dragon_soul_table.txt` -- `RESIST_ICE`, `ATT_BONUS_TO_WARRIOR` -- and not an `EApplyTypes` ordinal, which is `dragonsoul.py`'s own decision and its docstring gives the reason at length: the original resolves the name to an integer once at load through `FN_get_apply_type` (`dragon_soul_table.cpp:196`), nothing in this port yet turns any of the thirty-odd names this table uses into a `Point`, and assigning ordinals here would be a made-up number indistinguishable from a real one. The client draws the token; the day the names resolve, this field gains a sibling rather than changing meaning.

`basic` separates the two or fewer stats every soul of a type has (`BasicApplys`, in table order, truncated to the grade's `basis`) from the ones it drew (`AdditionalApplys`, a weighted draw without replacement). A panel that ran them together would be a panel where the interesting half of a Legendary soul is invisible.
 */
export class SoulApply {
  apply: string = "";
  value: number = 0;
  basic: boolean = false;

  encode(w: Writer): void {
    w.string(this.apply);
    w.varint(this.value);
    w.boolean(this.basic);
  }

  static decode(r: Reader): SoulApply {
    const self = new SoulApply();
    self.apply = r.string();
    self.value = r.varint();
    self.basic = r.boolean();
    return self;
  }
}

/**
 * One dragon soul, wherever it is sitting.

The cell address space is the original's own: 0 to 959 is the storage window (`DRAGON_SOUL_INVENTORY_MAX_NUM`, `item_length.h:152-155`) and 960 to 971 is the deck (`DRAGON_SOUL_EQUIP_SLOT_START` onwards, `length.h:681-682`), which is why one `DragonSoulMove` covers moving, equipping and unequipping rather than three messages: they are the same `TItemPos`-to-`TItemPos` operation there too (`char_item.cpp:5333-5356`).

`name` is the server's, and it is assembled rather than looked up. The English item table names a soul by its **type and grade only** -- all five steps of a grade share one row, so every Normal-grade White soul is a `Rough Dragon Diamond` -- where the Korean proto name spells the step out. So the step goes in front and the `+N` goes on the end, which is what the original does with the strength anyway. The three axes travel as numbers as well, because a client that wanted to sort or group by grade would otherwise be parsing English.

`remaining_seconds` only moves while the soul is *active*: the original's timer is billed in arrears (`item.cpp:1415-1470`), so a soul in storage or in the inactive deck does not age. Zero deactivates and never destroys (`item.cpp:1428-1429`), which is why there is no `expired` field -- a soul at zero is a soul at zero, and it is still there.
 */
export class SoulSlot {
  cell: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  grade: number = 0;
  step: number = 0;
  strength: number = 0;
  remaining_seconds: number = 0;
  active: boolean = false;
  sell_value: number = 0;
  applies: SoulApply[] = [];

  encode(w: Writer): void {
    w.varint(this.cell);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.grade);
    w.u8(this.step);
    w.u8(this.strength);
    w.varint(this.remaining_seconds);
    w.boolean(this.active);
    w.varint(this.sell_value);
    w.varint(this.applies.length);
    for (const item of this.applies)
      item.encode(w);
  }

  static decode(r: Reader): SoulSlot {
    const self = new SoulSlot();
    self.cell = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.grade = r.u8();
    self.step = r.u8();
    self.strength = r.u8();
    self.remaining_seconds = r.varint();
    self.active = r.boolean();
    self.sell_value = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.applies.push(SoulApply.decode(r));
    }
    return self;
  }
}

/**
 * One outstanding, server-issued marriage question addressed to this player.

A struct rather than three fields on `MarriageStatus` because a player can hold two at once -- an engaged pair can be asked to complete the ceremony by one partner while a divorce confirmation from the other is still standing -- and because the array's length is the honest way to spell "nobody is asking you anything".

`token` is the whole of what an answer names. It is minted by `marriage.Marriages` and never derived from a name, so an `AnswerMarriage` cannot be aimed at a question nobody asked; see that message.
 */
export class MarriageAskRow {
  token: number = 0;
  kind: number = 0;
  from_name: string = "";
  seconds: number = 0;

  encode(w: Writer): void {
    w.varint(this.token);
    w.u8(this.kind);
    w.string(this.from_name);
    w.varint(this.seconds);
  }

  static decode(r: Reader): MarriageAskRow {
    const self = new MarriageAskRow();
    self.token = r.varint();
    self.kind = r.u8();
    self.from_name = r.string();
    self.seconds = r.varint();
    return self;
  }
}

/**
 * One name on this player's own friend list, and whether they are connected.

`MessengerManager::SendList` writes exactly this pair per row -- a `connected` byte and a length-prefixed name (`messenger_manager.cpp:295-321`) -- and the pair is the whole of what the original's panel draws for a friend (`uimessenger.py:141-166`, `MessengerMemberItem.Online`/`Offline`).

**`online` is answerable only because both sides agreed.** Every row here got onto this list through `AddFriend` and the other side's `AnswerFriend`, so a presence bit in this frame is presence somebody consented to publish. There is no message on this protocol that asks whether an arbitrary name is connected: `AddFriend` answers a stranger and a name nobody has with one sentence, and whisper does the same.
 */
export class FriendRow {
  name: string = "";
  online: boolean = false;

  encode(w: Writer): void {
    w.string(this.name);
    w.boolean(this.online);
  }

  static decode(r: Reader): FriendRow {
    const self = new FriendRow();
    self.name = r.string();
    self.online = r.boolean();
    return self;
  }
}

/**
 * One outstanding friend request *addressed to this player*.

Named `FriendAskRow` rather than `FriendRequest` deliberately: `messenger.py` already has a `FriendRequest`, and `tools/audit_wire.py` decides a frame is emitted by looking for its name being constructed in a server file -- two things with one name and the audit answers yes for a frame nothing sends. `StallWindow` carries the same scar.

Carried inside `FriendList` rather than sent as its own frame, which is the opposite of what `MarriageAskRow` earns and for a reason from the original: a friend request **has no timeout**. `m_set_requestToAdd` (`messenger_manager.h:47`) has no sweep and `AuthToAdd` honours a request issued arbitrarily long ago, so a pending request is *state* -- it belongs in the frame that describes the panel. A marriage proposal expires in thirty seconds and is an *event*.
 */
export class FriendAskRow {
  token: number = 0;
  name: string = "";

  encode(w: Writer): void {
    w.varint(this.token);
    w.string(this.name);
  }

  static decode(r: Reader): FriendAskRow {
    const self = new FriendAskRow();
    self.token = r.varint();
    self.name = r.string();
    return self;
  }
}

/**
 * One lot on the auction board, as the browsing panel draws it.

`TAuctionItemInfo` (`common/auction_table.h:29-49`) is the original's own row and this is that row plus the three things it forces every client to work out for itself -- the minimum a raise must clear, how long is left, and what *this* viewer is owed. All three are computed server-side and sent, for the reason `item_facts()` gives about shipping balance data: the alternative is every client reimplementing `(double)bid * 1.05` and a wall clock, and two clients that round differently are two players disagreeing about what a legal bid is.

`claim` is the load-bearing one. It says what `ClaimLot` would do for the viewer *and nothing else does*: the panel labels its button from this field, the server derives the same answer again when the click arrives, and a client that lied about it would only ever lie to its own user. See `ClaimLot` for why a role is never on the wire.

The bidder's name is deliberately absent. `TAuctionItemInfo` carries `bidder_id` and a `shown_name` for the *seller* only (`auction_table.h:35-44`), and knowing who is bidding against you is worth money in an auction -- `winning` says whether it is you, which is the whole of what a viewer can act on.
 */
export class AuctionLot {
  id: number = 0;
  seller_name: string = "";
  mine: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  current_bid: number = 0;
  minimum_bid: number = 0;
  buy_now_price: number = 0;
  seconds_left: number = 0;
  your_escrow: number = 0;
  winning: number = 0;
  claim: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;
  bonuses: ItemBonus[] = [];

  encode(w: Writer): void {
    w.varint(this.id);
    w.string(this.seller_name);
    w.varint(this.mine);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.current_bid);
    w.varint(this.minimum_bid);
    w.varint(this.buy_now_price);
    w.varint(this.seconds_left);
    w.varint(this.your_escrow);
    w.varint(this.winning);
    w.varint(this.claim);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
  }

  static decode(r: Reader): AuctionLot {
    const self = new AuctionLot();
    self.id = r.varint();
    self.seller_name = r.string();
    self.mine = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    self.current_bid = r.varint();
    self.minimum_bid = r.varint();
    self.buy_now_price = r.varint();
    self.seconds_left = r.varint();
    self.your_escrow = r.varint();
    self.winning = r.varint();
    self.claim = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * One cell of this account's item mall.

`ItemView` with a cell number, and no price of any kind. That absence is the whole product decision and it is not an omission: `CHARACTER::LoadMall` (`char.cpp:5475-5516`) is handed a vnum, a count, sockets and attributes for an item that has *already been paid for*, by a system this source tree does not contain. It never asks what anything cost. `data/db/mall_items.json`'s `price` in `"CASH"` or `"MILEAGE"` is a payment website's catalogue -- what a browser shows *before* a purchase -- and this build has no payment system and does not pretend to. See `mall.py`'s own docstring, which shows the work.

So this frame describes a container, in the shape `SafeboxSlot` already uses, and the only verb on it is `MallCheckout`.
 */
export class MallSlot {
  cell: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;
  bonuses: ItemBonus[] = [];

  encode(w: Writer): void {
    w.varint(this.cell);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
  }

  static decode(r: Reader): MallSlot {
    const self = new MallSlot();
    self.cell = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * One persistent building on the guild's land, as the land panel draws it.

Every field is resolved from the server's owner/object tables: the id is the durable object id, the vnum is the shipped prototype, and the position and rotation are the values that survived the server's footprint and collision checks. The client never sends this row back; placement and upgrade messages name only a requested prototype/location or object id.

This is the response-side counterpart of the legacy object load path: `CManager::LoadObject` resolves each stored object and calls `Show` and `RegenNPC` (`building.cpp:816-884`), while `RequestCreateObject` validates the footprint before committing it (`building.cpp:502-576`).
 */
export class GuildBuilding {
  object_id: number = 0;
  vnum: number = 0;
  x: number = 0;
  y: number = 0;
  rotation: number = 0;

  encode(w: Writer): void {
    w.varint(this.object_id);
    w.varint(this.vnum);
    w.svarint(this.x);
    w.svarint(this.y);
    w.svarint(this.rotation);
  }

  static decode(r: Reader): GuildBuilding {
    const self = new GuildBuilding();
    self.object_id = r.varint();
    self.vnum = r.varint();
    self.x = r.svarint();
    self.y = r.svarint();
    self.rotation = r.svarint();
    return self;
  }
}

/**
 * One guild plot on the map being entered, as `TLandPacketElement` carries it (`packet.h`, filled at `building.cpp:971-976`): the shipped plot's id and rectangle in map-local units and the id of the guild that owns it, zero when unowned. The client draws plot outlines and owners from these rows; it never sends one back.
 */
export class LandPlot {
  id: number = 0;
  x: number = 0;
  y: number = 0;
  width: number = 0;
  height: number = 0;
  guild_id: number = 0;

  encode(w: Writer): void {
    w.varint(this.id);
    w.svarint(this.x);
    w.svarint(this.y);
    w.varint(this.width);
    w.varint(this.height);
    w.varint(this.guild_id);
  }

  static decode(r: Reader): LandPlot {
    const self = new LandPlot();
    self.id = r.varint();
    self.x = r.svarint();
    self.y = r.svarint();
    self.width = r.varint();
    self.height = r.varint();
    self.guild_id = r.varint();
    return self;
  }
}

/**
 * One rank in a guild's own table of fifteen (`guild.h:73-77`).

**There is no grade number on it.** The rank *is* its position in the array -- element 0 is grade 1, the master's -- and that is deliberate rather than a saving. `GRADE_COUNT` is 15 (`guild.h:11`) and every one of them exists from the moment the guild does; there is no add-a-rank and no delete-a-rank, so the table is always exactly fifteen long and an index is a complete name for a row. A number on the row would be a second copy of that index, free to disagree with it, and a client editing rank 4 would then have two answers to which row it meant.

**Every permission column travels, one named boolean each.** `Auth` has four bits (`guild.h:92-98`): `ADD_MEMBER`, `REMOVE_MEMBER`, `NOTICE` and `USE_SKILL`, and the grade page draws a column for each (`guildwindow_gradepage.py:23-38`). All four are carried so the master can read a rank's whole authority off this row and the client can reflect every checkbox: `may_invite` (`Guilds.invite`, `guild.cpp:1930`), `may_kick` (`Guilds.expel`, `input_main.cpp:2292`), `may_notice` (guild-board announcements, `guild.cpp:1016`) and `may_skill` (guild-skill use, `guild.cpp:1235`). They are named booleans, not a raw flag byte: an undefined fifth bit has no field to ride in, unlike the original's raw `auth` byte (`guild.cpp:846`).

Sent to every member rather than to the master alone. A rank table is not a secret -- `GuildMember.grade_name` already puts one row of it on every screen -- and a member who can read the whole table can read what the guild expects of the rank above them.
 */
export class GuildGrade {
  name: string = "";
  may_invite: boolean = false;
  may_kick: boolean = false;
  may_notice: boolean = false;
  may_skill: boolean = false;

  encode(w: Writer): void {
    w.string(this.name);
    w.boolean(this.may_invite);
    w.boolean(this.may_kick);
    w.boolean(this.may_notice);
    w.boolean(this.may_skill);
  }

  static decode(r: Reader): GuildGrade {
    const self = new GuildGrade();
    self.name = r.string();
    self.may_invite = r.boolean();
    self.may_kick = r.boolean();
    self.may_notice = r.boolean();
    self.may_skill = r.boolean();
    return self;
  }
}

/**
 * One of the three public throne rows shown by `minfo`. The legacy command walks empires 1 through 3 and prints each cached ruler name (`cmd_general.cpp:1664-1690`); no candidacy, vote total or election state exists in that output, so none is invented here.
 */
export class MonarchSeat {
  empire: number = 0;
  name: string = "";

  encode(w: Writer): void {
    w.u8(this.empire);
    w.string(this.name);
  }

  static decode(r: Reader): MonarchSeat {
    const self = new MonarchSeat();
    self.empire = r.u8();
    self.name = r.string();
    return self;
  }
}

/**
 * One occupied quick slot, exactly as the original's `TQuickslot` holds it: a `type` and a `pos` (`common/tables.h:353-357`).

The whole table is thirty-six entries (`QUICKSLOT_MAX_NUM = 36`, `common/length.h:31`) and lives on the character, not the client: `CHARACTER::m_quickslot` (`char.h:887`) is copied into the player row on save (`char.cpp:1190`) and read back on load (`input_db.cpp:435`). Only the non-empty entries are sent, so a fresh character's frame is one byte.

`pos` is an **index, not an identity**, and which index depends on `type`. `CHARACTER::SetQuickslot` (`char_quickslot.cpp:65-84`) reads it three ways: for `ITEM` it is an inventory cell (`TItemPos srcCell(INVENTORY, rSlot.pos)`, `:63`), for `SKILL` a skill index below `SKILL_MAX_NUM` (`:74`), for `COMMAND` an emotion number the client turns into `BINARY_ActEmotion` (`PythonPlayer.cpp:832-836`). This build's skill book is keyed by vnum rather than by a fixed 255-entry array, so a `SKILL` entry carries the skill vnum -- the same identity `UseSkill` already names on this wire.

Because `pos` is a cell, the server -- not the client -- is what keeps a hotkey pointing at the right item: `SyncQuickslot` (`char_quickslot.cpp:12-34`) re-points or clears a slot whenever the item under it moves, and `ChainQuickslotItem` (`:138-155`) follows a stack that merged into another cell.
 */
export class QuickSlotEntry {
  pos: number = 0;
  type: number = 0;
  target: number = 0;

  encode(w: Writer): void {
    w.u8(this.pos);
    w.u8(this.type);
    w.varint(this.target);
  }

  static decode(r: Reader): QuickSlotEntry {
    const self = new QuickSlotEntry();
    self.pos = r.u8();
    self.type = r.u8();
    self.target = r.varint();
    return self;
  }
}

/**
 * First frame on a new connection. Nothing else is accepted before it.
 */
export class Hello {
  static readonly OPCODE = 0x01;
  protocol_version: number = 0;
  schema_hash: number = 0;
  build: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x01);
    w.varint(this.protocol_version);
    w.u32(this.schema_hash);
    w.string(this.build);
    return w.bytes();
  }

  static decode(r: Reader): Hello {
    const self = new Hello();
    self.protocol_version = r.varint();
    self.schema_hash = r.u32();
    self.build = r.string();
    return self;
  }
}

/**
 * Enter the world as a guest, without an account. Kept for the unauthenticated demo path and for tests that have no business standing up an account store; `Login` is the real entry point.
 */
export class Join {
  static readonly OPCODE = 0x02;
  name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x02);
    w.string(this.name);
    return w.bytes();
  }

  static decode(r: Reader): Join {
    const self = new Join();
    self.name = r.string();
    return self;
  }
}

/**
 * Authenticate and enter the world. The reply is Welcome on success or Reject on failure, and Reject deliberately does not say which of the username or the password was wrong -- an error that distinguishes them enumerates accounts.
 */
export class Login {
  static readonly OPCODE = 0x07;
  username: string = "";
  password: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x07);
    w.string(this.username);
    w.string(this.password);
    return w.bytes();
  }

  static decode(r: Reader): Login {
    const self = new Login();
    self.username = r.string();
    self.password = r.string();
    return self;
  }
}

/**
 * Choose the kingdom for a new account before its first character.

This is the one client-authored value that must become an account fact before `CreateCharacter`: the legacy login phase receives `HEADER_CG_EMPIRE` (90 / `0x5A`) in `CInputLogin::Empire` and persists `bEmpire` only while the account has no character (`input_login.cpp:749-779`). This branch keeps that ordering but makes the choice explicit in the authenticated session.

Only the empire number crosses the wire. The account id, whether the account is still eligible, and the resulting character spawn are server-owned. The host validates 1..3, atomically writes the previously-zero account row, reloads it, and advances to character select only after the write succeeds. A replay is out of order once the phase advances; a modified client cannot replace the persisted choice or attach it to another account.
 */
export class SelectEmpire {
  static readonly OPCODE = 0x76;
  empire: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x76);
    w.u8(this.empire);
    return w.bytes();
  }

  static decode(r: Reader): SelectEmpire {
    const self = new SelectEmpire();
    self.empire = r.u8();
    return self;
  }
}

/**
 * One input frame, sent every tick. Note the absence of a position field: the client states intent, never state.
 */
export class Input {
  static readonly OPCODE = 0x03;
  seq: number = 0;
  heading: number = 0;
  gait: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x03);
    w.varint(this.seq);
    w.bits(this.heading, 12);
    w.u8(this.gait);
    return w.bytes();
  }

  static decode(r: Reader): Input {
    const self = new Input();
    self.seq = r.varint();
    self.heading = r.bits(12);
    self.gait = r.u8();
    return self;
  }
}

/**
 * One line of chat, and which channel it was typed into.

`channel` is a `CHAT_*` code, and it is the only thing this message adds to the text. The original's client sends the same byte (`TPacketCGChat.type`, `packet.h:615-622`) and picks it from the prefix the player typed -- `#` party, `%` guild, `!` shout, nothing at all for the area around you (`uichat.py:194-205`, dispatched at `:338-361`) -- so in both builds the channel is a client-side reading of the sender's intent.

What it is not, in either build, is a *reach*. `CInputMain::Chat` switches on the byte (`input_main.cpp:745-802`) and then works out for itself who hears the line, and that is why there is nothing else on this message: no recipient list, no party id, no guild id, no position. A client that named its own audience could speak into a guild it does not belong to; one that carried its own position could be heard across the map. Both are read off the sender -- `ch->GetParty()` at `:778` and `ch->GetGuild()` at `:795` -- and never out of the packet.

Nor is there a sender name. The original composes `"%s : %s"` from `ch->GetName()` before it looks at the channel at all (`input_main.cpp:682-683`), and this build puts the name on the echo for the same reason: a line whose author is supplied by its author is a forgery with a text field.

Only the four channels a player can type into are accepted: `CHAT_SAY`, `CHAT_PARTY`, `CHAT_GUILD` and `CHAT_SHOUT`. `CHAT_INFO` and `CHAT_NOTICE` are the server talking, `CHAT_COMMAND` is not speech at all (see that constant), and `CHAT_WHISPER` has its own message because it names somebody. Anything else is dropped rather than answered, which is the original's own reading of an unknown type -- `:800-802` logs it and sends nothing.
 */
export class Chat {
  static readonly OPCODE = 0x04;
  text: string = "";
  channel: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x04);
    w.string(this.text);
    w.u8(this.channel);
    return w.bytes();
  }

  static decode(r: Reader): Chat {
    const self = new Chat();
    self.text = r.string();
    self.channel = r.u8();
    return self;
  }
}

/**
 * Swing at a target. Intent only: the client names who it is hitting and nothing else. Range, cooldown, line of sight and damage are all decided server-side, so there is no number here to inflate.
 */
export class Attack {
  static readonly OPCODE = 0x06;
  seq: number = 0;
  target_id: number = 0;
  combo_step: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x06);
    w.varint(this.seq);
    w.varint(this.target_id);
    w.u8(this.combo_step);
    return w.bytes();
  }

  static decode(r: Reader): Attack {
    const self = new Attack();
    self.seq = r.varint();
    self.target_id = r.varint();
    self.combo_step = r.u8();
    return self;
  }
}

/**
 * Take something off the ground. Names the entity and nothing else: which item that is, whether it is close enough, and whether it is still there are all the server's to decide. There is no slot field here, because a client that chose its own destination slot could choose one that is already occupied.
 */
export class PickUp {
  static readonly OPCODE = 0x08;
  entity_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x08);
    w.varint(this.entity_id);
    return w.bytes();
  }

  static decode(r: Reader): PickUp {
    const self = new PickUp();
    self.entity_id = r.varint();
    return self;
  }
}

/**
 * Use what is in a bag slot. Only potions are usable so far.
 */
export class UseItem {
  static readonly OPCODE = 0x09;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x09);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): UseItem {
    const self = new UseItem();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Put a slot's contents back on the ground. Needed for more than tidiness: without it a full bag is a dead end, and the round trip of dropping and picking up is what the duplication tests exercise.
 */
export class DropItem {
  static readonly OPCODE = 0x0A;
  slot: number = 0;
  count: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x0A);
    w.varint(this.slot);
    w.varint(this.count);
    return w.bytes();
  }

  static decode(r: Reader): DropItem {
    const self = new DropItem();
    self.slot = r.varint();
    self.count = r.varint();
    return self;
  }
}

/**
 * Put some of the sender's purse on the ground.

One amount, and deliberately no purse balance. The original's `TPacketCGItemDrop2` carries `gold` (`packet.h:657-663`) and `CHARACTER::DropGold` compares it with `GetGold()` before anything changes (`char_item.cpp:5234-5237`). This message keeps that request and deletes the packet's unrelated item cell and count: a gold drop cannot name an item, and a client cannot assert what its purse contains or what balance should remain.

The authoritative answer is the ordinary `Bag` frame after the server has placed the money and deducted it. A refused amount therefore leaves the client showing the same server-owned purse, rather than a locally predicted subtraction that has to be rolled back.
 */
export class DropGold {
  static readonly OPCODE = 0x73;
  amount: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x73);
    w.varint(this.amount);
    return w.bytes();
  }

  static decode(r: Reader): DropGold {
    const self = new DropGold();
    self.amount = r.varint();
    return self;
  }
}

/**
 * Move a stack from one bag cell to another, or split part of it off, or merge it into a matching stack.

Three cells' worth of intent in two indices and a count, because there is nothing else the message could say. It names no vnum, no count of what is *there*, and no item id: the server reads the source cell to find out what is being moved, so a client cannot assert that cell 3 holds a sword and have the server believe it. The original's `MoveItem` takes a `TItemPos` pair and a count (`char_item.cpp:5279`) and reads the item out of the source cell the same way, which is the half of that function worth keeping.

**Duplication is what this message is for, from an attacker's point of view.** Every bag exploit in the original's history is a move that added more than it removed. The whole handler is `Bag.move`, which is arithmetic over two slots with no entity, no database and no protocol in it, and `tests/test_inventory.py` asserts conservation over every ordered pair of cells rather than over the cases somebody thought of.

`count` of zero means the whole stack, the same convention `DropItem` uses. A count larger than the source holds moves what is there rather than refusing, because the alternative is a client and a server disagreeing about a stack size by one tick of lag and the player's drag doing nothing.
 */
export class MoveItem {
  static readonly OPCODE = 0x32;
  slot: number = 0;
  dest: number = 0;
  count: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x32);
    w.varint(this.slot);
    w.varint(this.dest);
    w.varint(this.count);
    return w.bytes();
  }

  static decode(r: Reader): MoveItem {
    const self = new MoveItem();
    self.slot = r.varint();
    self.dest = r.varint();
    self.count = r.varint();
    return self;
  }
}

/**
 * Wear what is in a bag slot. Names the bag slot and nothing else: *where* a sword goes is a property of the sword, not a choice, and a message that carried a destination would be a message that could put a helmet in the weapon slot.
 */
export class EquipItem {
  static readonly OPCODE = 0x0B;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x0B);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): EquipItem {
    const self = new EquipItem();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Take a worn piece off and put it back in the bag.
 */
export class Unequip {
  static readonly OPCODE = 0x0C;
  wear: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x0C);
    w.u8(this.wear);
    return w.bytes();
  }

  static decode(r: Reader): Unequip {
    const self = new Unequip();
    self.wear = r.u8();
    return self;
  }
}

/**
 * Sell a bag slot to the dealer whose counter this session has open. The request names only the sender's slot and optional count: the server-owned `Shopping` window supplies the dealer and is checked again for presence, identity and range. This matches the legacy shop packet, whose sell branch carries only `pos`/`count` (`input_main.cpp:1003-1052`) and whose handler first requires an open shop (`shop_manager.cpp:252-266`). A client cannot redirect a sale by changing an NPC id.
 */
export class SellItem {
  static readonly OPCODE = 0x0D;
  slot: number = 0;
  count: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x0D);
    w.varint(this.slot);
    w.varint(this.count);
    return w.bytes();
  }

  static decode(r: Reader): SellItem {
    const self = new SellItem();
    self.slot = r.varint();
    self.count = r.varint();
    return self;
  }
}

/**
 * Buy one shelf from the open shop. The whole message is which shelf.

No dealer, no item vnum, no count and above all no price. Every one of those is already the server's: the dealer is whoever this player last opened a window with, and the rest are columns of the shelf that window is showing. `CShop::Buy` takes exactly this one argument (`shop.cpp:186`) for exactly this reason, and it is the difference between a buy handler that mints what the server decided and one that mints what the client asked for.

`slot` is the cell the `ShopSlot` carried. A cell the shop does not stock buys nothing -- it is not a key in the server's own layout, so there is no shelf for it to name.
 */
export class BuyItem {
  static readonly OPCODE = 0x16;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x16);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): BuyItem {
    const self = new BuyItem();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Shut the open shop window. No fields: there is one window per player and this closes it, whichever it was.

Not load-bearing for safety -- a window left open buys nothing, because every purchase re-checks that the dealer still exists and is still within reach -- but it is what stops a player who walked away and pressed the button from being told a shelf is out of range instead of being told nothing at all.
 */
export class CloseShop {
  static readonly OPCODE = 0x17;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x17);
    return w.bytes();
  }

  static decode(_r: Reader): CloseShop {
    const self = new CloseShop();
    return self;
  }
}

/**
 * Put one earned status point into one statistic.

The whole message is which statistic. Not the new value, not the number of points, not the resulting attack rating -- the same intent-not-state discipline as `Input`, and for a sharper reason than usual. A message carrying a stat *value* would be a message that could carry ninety; a message carrying an *amount* would be a message that could carry a thousand, and the server would then be in the business of deciding how much of a client's number to believe. There is no number here to disbelieve.

Whether the point exists to spend is not asked either. The server recomputes the pool from the level and the four statistics on every request -- see `stats.unspent` -- so a client cannot spend a point it has not earned, and spending one raises a statistic, which is what makes the pool one smaller. There is no counter to decrement twice.

The answer is a `Standing`, always, whether the point was spent or refused: it carries the four statistics and the remaining pool, so a refused request repaints the panel with the truth rather than leaving it showing the click.
 */
export class SpendPoint {
  static readonly OPCODE = 0x0F;
  stat: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x0F);
    w.u8(this.stat);
    return w.bytes();
  }

  static decode(r: Reader): SpendPoint {
    const self = new SpendPoint();
    self.stat = r.u8();
    return self;
  }
}

/**
 * Ask to change whether this character may fight other players.

Intent, like everything else the client sends: it names a mode and the server decides. There is no field here for *who* may be fought, and none for a flag on the character -- a message that carried either would be a message that could declare someone else fair game. The answer comes back as `PvpStatus`, always, including when the mode did not change: a client that assumed its request took effect would draw a peace symbol over a character the server considers fair game, which is the one lie in this whole exchange that gets somebody killed.
 */
export class SetPvpMode {
  static readonly OPCODE = 0x0E;
  mode: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x0E);
    w.u8(this.mode);
    return w.bytes();
  }

  static decode(r: Reader): SetPvpMode {
    const self = new SetPvpMode();
    self.mode = r.u8();
    return self;
  }
}

/**
 * Cast a skill. Intent, and nothing else on the whole message is a number the server has to weigh.

Three fields: which input frame this belongs to, which skill, and what it is pointed at. Not the damage, not the cost, not the cooldown, not whether the caster can afford it -- every one of those is computed server-side from the skill's own formula out of the original's `skill_proto`, and there is nothing here to inflate. The skill *level* is absent for the same reason `SpendPoint` carries no amount: a level on the wire is a level that could say forty.

`target_id` is zero for a skill cast on yourself. A self buff that arrived with a target is not refused for it -- the server ignores the field entirely when the skill is `SELFONLY`, exactly as `CHARACTER::UseSkill` overwrites the victim with `this` (`char_skill.cpp:2473-2474`).
 */
export class UseSkill {
  static readonly OPCODE = 0x10;
  seq: number = 0;
  skill: number = 0;
  target_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x10);
    w.varint(this.seq);
    w.varint(this.skill);
    w.varint(this.target_id);
    return w.bytes();
  }

  static decode(r: Reader): UseSkill {
    const self = new UseSkill();
    self.seq = r.varint();
    self.skill = r.varint();
    self.target_id = r.varint();
    return self;
  }
}

/**
 * Put one earned skill point into one skill.

The same shape as `SpendPoint` and for the same reasons. The whole message is which skill; there is no amount, no resulting level and no assertion that a point is available. The pool is recomputed on every request from the character's level and the levels of the skills they have already raised (`skills.unspent_points`), so a point cannot be spent twice -- spending one raises a skill, which is what makes the pool one smaller.

The answer is a `Skills` frame, always, spent or refused, carrying the whole bar. A client that assumed its request took effect would draw a level the server does not hold.
 */
export class SkillUp {
  static readonly OPCODE = 0x11;
  skill: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x11);
    w.varint(this.skill);
    return w.bytes();
  }

  static decode(r: Reader): SkillUp {
    const self = new SkillUp();
    self.skill = r.varint();
    return self;
  }
}

/**
 * Click one visible NPC. The entity id is the whole request.

The client does not say whether this is a shop or a conversation. `CInputMain::OnClick` reads the NPC's `ON_CLICK` value and dispatches it: `ON_CLICK_SHOP` opens its counter, while `ON_CLICK_NONE` and `ON_CLICK_TALK` fall through to `CQuestManager::Click`. This server does the same lookup from its placed NPC data, so a modified client cannot turn a guard into a dealer or force a dealer through a quest.

The type, shop, quest and range are all server state. An entity that is not a live NPC, or is too far away for its resulting action, has no click effect.
 */
export class ClickNpc {
  static readonly OPCODE = 0x12;
  npc_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x12);
    w.varint(this.npc_id);
    return w.bytes();
  }

  static decode(r: Reader): ClickNpc {
    const self = new ClickNpc();
    self.npc_id = r.varint();
    return self;
  }
}

/**
 * Answer whatever the open conversation asked.

Two numbers, and the first is the interesting one. `token` names *which* question is being answered, and the server refuses a reply whose token is not the token of the page it last sent. Without it, a click queued behind a laggy frame would answer the next question instead of the one the player read -- which, in a conversation whose options are `Yes` and `No`, is a quest abandoned by accident.

`choice` is 1-based, as Lua's `select` returns it. Zero is the 'continue' button on a page with no options, and anything past the end of the list the server offered closes the conversation rather than selecting: the options are the server's, so an index it never wrote cannot name one.
 */
export class QuestReply {
  static readonly OPCODE = 0x13;
  token: number = 0;
  choice: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x13);
    w.varint(this.token);
    w.u8(this.choice);
    return w.bytes();
  }

  static decode(r: Reader): QuestReply {
    const self = new QuestReply();
    self.token = r.varint();
    self.choice = r.u8();
    return self;
  }
}

/**
 * Open a quest from the log -- the original's `button`/`info` event (`questmanager.cpp:560`, `:586`).

Names a row by the index the server put in the `QuestEntry` it sent, so the whole message is a number the server minted. What that row's script says is the server's; this cannot ask for a quest the player does not have, because an index outside the log selects nothing.
 */
export class QuestInfo {
  static readonly OPCODE = 0x14;
  index: number = 0;
  describe: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x14);
    w.varint(this.index);
    w.boolean(this.describe);
    return w.bytes();
  }

  static decode(r: Reader): QuestInfo {
    const self = new QuestInfo();
    self.index = r.varint();
    self.describe = r.boolean();
    return self;
  }
}

/**
 * Answer one server-issued quest text prompt. The token identifies the suspended coroutine; the string is the whole of what the player may choose. There is no quest name, state, NPC, timeout or reward on the message. The original packet likewise carries only its fixed 65-byte text buffer (`packet.h:770-774`) and resumes only a coroutine suspended in `SUSPEND_STATE_INPUT` (`questmanager.cpp:205-235`).
 */
export class QuestInputAnswer {
  static readonly OPCODE = 0x6C;
  token: number = 0;
  text: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x6C);
    w.varint(this.token);
    w.string(this.text);
    return w.bytes();
  }

  static decode(r: Reader): QuestInputAnswer {
    const self = new QuestInputAnswer();
    self.token = r.varint();
    self.text = r.string();
    return self;
  }
}

/**
 * Yes or no to one quest confirmation the server sent. A token names the question and both participants at once, replacing the original's client-chosen requester PID (`packet.h:776-781`; `input_main.cpp:1666-1676`). Thus a client cannot aim yes at a different player, quest or timeout: none is representable.
 */
export class QuestConfirmAnswer {
  static readonly OPCODE = 0x6D;
  token: number = 0;
  accept: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x6D);
    w.varint(this.token);
    w.boolean(this.accept);
    return w.bytes();
  }

  static decode(r: Reader): QuestConfirmAnswer {
    const self = new QuestConfirmAnswer();
    self.token = r.varint();
    self.accept = r.boolean();
    return self;
  }
}

/**
 * Choose one cell of the player's own bag for a suspended quest. Only the server-issued prompt token and the cell cross the wire: no item id, vnum, count or claimed eligibility. The original's `TPacketCGScriptSelectItem` is likewise only one `DWORD selection` (`packet.h:2060-2065`), consumed as a cell by `CQuestManager::SelectItem` (`questmanager.cpp:147-160`).
 */
export class QuestItemAnswer {
  static readonly OPCODE = 0x6E;
  token: number = 0;
  cell: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x6E);
    w.varint(this.token);
    w.varint(this.cell);
    return w.bytes();
  }

  static decode(r: Reader): QuestItemAnswer {
    const self = new QuestItemAnswer();
    self.token = r.varint();
    self.cell = r.varint();
    return self;
  }
}

/**
 * Round-trip probe. **No fields:** a ping is the arrival event, not a client-authored timestamp. The server answers with its current tick, while a client that wants a latency display keeps the local send time beside its socket. Echoing a client clock would make an untrusted number part of the protocol and invites future handlers to mistake it for authoritative timing.
 */
export class Ping {
  static readonly OPCODE = 0x05;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x05);
    return w.bytes();
  }

  static decode(_r: Reader): Ping {
    const self = new Ping();
    return self;
  }
}

/**
 * Ask the blacksmith whose server-owned refine context is open what one bag slot would cost to improve.

The question, not the attempt: nothing here changes a bag, and the answer -- a `RefineOffer` -- is what a player reads before deciding to risk the item. The original has the same split and spends a whole item-handover protocol on it (`ReceiveItem` at `char_item.cpp:6620` then `RefineInformation` at `:1180`); this is the same two questions with the drag-and-drop taken out.

One field, and it is not a number the server has to weigh. The smith decides whether it takes this item at all (`char_item.cpp:6467-6486`), the recipe decides the cost and the odds, and the bag decides whether either can be met -- so a client that asked about somebody else's sword has no field to say it in. The legacy request likewise carries only `pos` (`packet.h:1898-1902`); the server's refine context comes from the blacksmith interaction, not an NPC id in this request.
 */
export class RefineInfo {
  static readonly OPCODE = 0x18;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x18);
    w.u8(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): RefineInfo {
    const self = new RefineInfo();
    self.slot = r.u8();
    return self;
  }
}

/**
 * Risk it at the server-owned blacksmith context. The request carries exactly the slot of `RefineInfo`, and that is the point.

A separate message rather than a flag on `RefineInfo`, because the two differ in the only way that matters -- one of them can destroy an item -- and a boolean is the wrong place to keep that difference. It carries no cost, no chance and no result: those come out of `refine.json` at the moment of the attempt, so the offer the player read is advisory and the recipe is authoritative. A client that showed a stale 90% is a client that gets the real 30.

The roll is the server's, seeded from the entity, the tick, the slot and the item (`refine.seed_for`) -- so it is reproducible from a replay and unpredictable from a client, which is the pair of properties a disputed refinement needs. The legacy packet carries only `pos` and `type` (`packet.h:1891-1902`, `input_main.cpp:2577-2598`); this shard uses slot `255` as the same server-side cancel sentinel.
 */
export class Refine {
  static readonly OPCODE = 0x19;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x19);
    w.u8(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): Refine {
    const self = new Refine();
    self.slot = r.u8();
    return self;
  }
}

/**
 * Ask another player to trade. Names them and nothing else.

Whether they are a player at all, whether either of you is already trading, whether a storeroom is open on either side and how far apart you are standing are all `exchange.Exchanges.open`'s, out of `exchange.cpp:49-111`. There is no field here for what is being traded, because at this point nothing is: the window opens empty on both sides and every item in it arrives through `ExchangeOffer`.

There is deliberately no acceptance step for the *invitation*. The original has one (`HEADER_CG_EXCHANGE` sub-header `START`, answered by the target's own client) and it buys nothing here: an open window transfers nothing, holds nothing and is cancelled by either side at any time, so the thing worth agreeing to is the trade, which is what `ExchangeAccept` is for.
 */
export class ExchangeStart {
  static readonly OPCODE = 0x1A;
  target_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x1A);
    w.varint(this.target_id);
    return w.bytes();
  }

  static decode(r: Reader): ExchangeStart {
    const self = new ExchangeStart();
    self.target_id = r.varint();
    return self;
  }
}

/**
 * Put one of your own bag slots in the window.

A slot index, and the whole stack in it. Not a count: `exchange.py` keys an offer by the slot it came from precisely so that 'the same item offered twice' cannot be written down, and a count would be a second number to re-verify at settlement. Not an item vnum either -- a vnum on the wire is a client naming what it is giving, and what is actually given is read out of the slot at the moment of settlement.

Both sides' agreements expire the instant this lands (`exchange.cpp:179-180`), and the server mints a new token for the pair of offers. That is what makes a click on an accept button that was drawn a moment ago refuse rather than settle.
 */
export class ExchangeOffer {
  static readonly OPCODE = 0x1B;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x1B);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): ExchangeOffer {
    const self = new ExchangeOffer();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Take one of your own offers back out of the window (`exchange.cpp:219-242`). Names the bag slot it came from, which is the key the offer is held under; a slot that was never offered withdraws nothing. Expires both agreements, exactly as offering does.
 */
export class ExchangeWithdraw {
  static readonly OPCODE = 0x1C;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x1C);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): ExchangeWithdraw {
    const self = new ExchangeWithdraw();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Put money in the window. Once, and it cannot be revised (`exchange.cpp:256-259`): raising or lowering an offer of gold means cancelling the trade. Kept as the original has it -- the difference between money that can be edited under a counterparty's eyes and money that can only be agreed to.

An amount the sender does not have is refused rather than clamped. Clamping would be the server quietly answering a different question than the one asked, and the answer would then be drawn in the other player's window as though it had been offered.
 */
export class ExchangeGold {
  static readonly OPCODE = 0x1D;
  amount: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x1D);
    w.varint(this.amount);
    return w.bytes();
  }

  static decode(r: Reader): ExchangeGold {
    const self = new ExchangeGold();
    self.amount = r.varint();
    return self;
  }
}

/**
 * Agree to the trade **as the server last described it**.

`token` is the whole reason this message has a field. The server mints a fresh one for every pair of offers and puts it on the `ExchangeState` that describes them; an accept carrying any other token is refused and the current state is resent. Without it the swap scam is two moves and no timing: offer a sword, wait for the mark's finger to start moving, withdraw the sword and offer a rock, accept. `exchange.py` expires both agreements when either offer changes (`exchange.cpp:179-180`) -- which stops the *stored* accept from surviving -- but it cannot see that the click already in flight was given for a window that no longer exists. The token is how it sees.

The same discipline `QuestReply` follows for the same reason, and the stakes are higher here: a late click in a conversation abandons a quest, and a late click in a trade hands somebody a sword for a rock.
 */
export class ExchangeAccept {
  static readonly OPCODE = 0x1E;
  token: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x1E);
    w.varint(this.token);
    return w.bytes();
  }

  static decode(r: Reader): ExchangeAccept {
    const self = new ExchangeAccept();
    self.token = r.varint();
    return self;
  }
}

/**
 * Walk away. No fields: a player is in at most one trade, and this ends it from either side.

Nothing was moved, so nothing is undone -- an open window holds items only in the sense that it names bag slots. Both sides are told, because a window that stayed on screen after the counterparty left would be a window whose next click is refused.
 */
export class ExchangeCancel {
  static readonly OPCODE = 0x1F;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x1F);
    return w.bytes();
  }

  static decode(_r: Reader): ExchangeCancel {
    const self = new ExchangeCancel();
    return self;
  }
}

/**
 * Ask the warehouse keeper to open this account's storeroom.

Only the password crosses the wire. The keeper is the server's nearest `KEEPER_VNUM` NPC at handling time, so a client cannot name a different NPC and rely on a distance check to authorize the request. This is the same server-owned proximity rule as `UseDungeonDoor`, applied to the original keeper gate at `char.cpp:5354-5358`.

The password is checked by `safebox.password_accepted` against `logins.safebox_password`, the account-scoped column `/safebox_change_password` writes (`ClientManager.cpp:963-966`). An account that has never set one holds a null there and opens with `000000`, which is what `ClientManager.cpp:599-619` accepts for a row that is absent, null or empty.

The box is the *account's*, not the character's (`ClientManager.cpp:660-661`), which is what makes it the only sanctioned way to move an item between two of your own characters. There is one character per account in this build, so that property is not yet visible; the keying is account-side anyway, because changing it later would mean migrating everything anyone had stored.
 */
export class OpenSafebox {
  static readonly OPCODE = 0x20;
  password: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x20);
    w.string(this.password);
    return w.bytes();
  }

  static decode(r: Reader): OpenSafebox {
    const self = new OpenSafebox();
    self.password = r.string();
    return self;
  }
}

/**
 * Rent the first page (`data/quest/warehouse.quest:9-19`).

This message has no fields: opening the box records the server's keeper context, and the unlock is accepted only while that same context remains valid. A client cannot redirect the charge to a different NPC by changing an entity id.

No price on the wire -- 500 gold is the server's, out of the quest script, and it is sent *to* the client on the `Safebox` frame so a button can say what it will cost. A price a client named would be a price a client chose.

One page, and there is deliberately no message for a second: no shipped quest and no shipped code grants page two or three, so a message to buy one would be a message with no rule behind it. See `safebox.UNLOCK_PRICE`.
 */
export class SafeboxUnlock {
  static readonly OPCODE = 0x21;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x21);
    return w.bytes();
  }

  static decode(_r: Reader): SafeboxUnlock {
    const self = new SafeboxUnlock();
    return self;
  }
}

/**
 * Bag slot into a storeroom cell (`input_main.cpp:1701-1755`).

Whole slot, as the original moves a whole `LPITEM`, and into a cell the client names -- which must be empty. Both ends are indices into containers the server holds, so the worst a hostile value can do is address nothing.

Note what is *not* here: no vnum, no count, no gold. `safebox.py`'s docstring sets out why there is no gold at all -- the column exists in the original, is never loaded, is never written by play, and its client-side send is commented out.
 */
export class SafeboxDeposit {
  static readonly OPCODE = 0x22;
  slot: number = 0;
  cell: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x22);
    w.varint(this.slot);
    w.varint(this.cell);
    return w.bytes();
  }

  static decode(r: Reader): SafeboxDeposit {
    const self = new SafeboxDeposit();
    self.slot = r.varint();
    self.cell = r.varint();
    return self;
  }
}

/**
 * Storeroom cell into a bag slot (`input_main.cpp:1757-1850`).

The destination is named and must be empty (`input_main.cpp:1779-1780`): no searching for a free slot and no stacking onto a partial one. That is the original's behaviour and the safer of the two -- a withdraw that quietly lands somewhere else is a withdraw the client and the server can disagree about.
 */
export class SafeboxWithdraw {
  static readonly OPCODE = 0x23;
  cell: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x23);
    w.varint(this.cell);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): SafeboxWithdraw {
    const self = new SafeboxWithdraw();
    self.cell = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Rearrange inside the box, merging stacks where they merge (`safebox.cpp:169-236`).

`count` of zero means the whole stack, the same spelling `DropItem` uses. It is the one count on this feature's wire and it is bounded by what the source cell actually holds, so an inflated one moves the stack and no more.

Worth naming what this is not: it never leaves the box, so it can neither mint nor destroy. The original's version of this function can do both -- `safebox.cpp:198-207` removes the source on a partial merge and destroys it outright when the destination is full -- which is why `safebox.move` exists at all.
 */
export class SafeboxMove {
  static readonly OPCODE = 0x24;
  source: number = 0;
  destination: number = 0;
  count: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x24);
    w.varint(this.source);
    w.varint(this.destination);
    w.varint(this.count);
    return w.bytes();
  }

  static decode(r: Reader): SafeboxMove {
    const self = new SafeboxMove();
    self.source = r.varint();
    self.destination = r.varint();
    self.count = r.varint();
    return self;
  }
}

/**
 * Shut the storeroom. No fields, like `CloseShop`, and for the same reason: there is one box per player and this closes it.

Load-bearing in a way `CloseShop` is not. An open storeroom is a second place to put an item, which is why `exchange.cpp:64-74` refuses to open a trade while one is up -- so the server has to know when it comes down, or a player who closed the panel could never trade again.
 */
export class CloseSafebox {
  static readonly OPCODE = 0x25;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x25);
    return w.bytes();
  }

  static decode(_r: Reader): CloseSafebox {
    const self = new CloseSafebox();
    return self;
  }
}

/**
 * Ask the warehouse keeper for the gold-bar counter (`warehouse.quest:77-81`).

The source chat option is `npc.open_shop()` with no shop vnum after `game.set_safebox_level(1)` has moved the quest into `state use`. Nothing crosses the wire: the keeper is the server's nearest `KEEPER_VNUM` at handling time, the shop is the one bound to that race (vnum 7), and the `state use` gate is this account's rented page count. A client cannot name a different NPC, a shop id, a price, or a rented size.

His proto is `ON_CLICK_TALK` (`mob_proto.txt:745`), so the open uses `from_quest=True`. The storeroom is closed first because `StartShopping` refuses an open safebox (`shop_manager.cpp:98-119`); gold bars are a different chat option from `game.open_safebox()`.
 */
export class OpenGoldBarShop {
  static readonly OPCODE = 0x7B;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x7B);
    return w.bytes();
  }

  static decode(_r: Reader): OpenGoldBarShop {
    const self = new OpenGoldBarShop();
    return self;
  }
}

/**
 * Ask another player to group up (`char.cpp:4349-4431`).

One field, because every other question an invitation raises is the server's: whether the sender leads a party at all, whether the target is already in one, whether either has room, and whether they are within thirty levels of one another. `party.py` asks all five, and then asks them **again** when the answer lands, because between the two the world moves.

There is deliberately no distance rule and so no position on this message. The original has none either -- it resolves the invitee through the global character manager (`input_main.cpp:1876`) and never measures -- and the real limit is that a client can only name an entity the server has already told it about. Inventing a radius here would be inventing a number.
 */
export class PartyInvite {
  static readonly OPCODE = 0x26;
  target_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x26);
    w.varint(this.target_id);
    return w.bytes();
  }

  static decode(r: Reader): PartyInvite {
    const self = new PartyInvite();
    self.target_id = r.varint();
    return self;
  }
}

/**
 * Accept or decline **one named invitation**.

`token` is the whole reason this message has more than a boolean. `party.py` mints one per invitation and consumes it on the first answer that resolves it, so an answer carrying anything else is the same failed lookup as an answer to an invitation that was never issued, one addressed to somebody else, and one that has already expired. The alternative -- a bare yes, resolved against whatever invitation the invitee currently holds -- is the party shape of the swap `ExchangeAccept` exists to refuse: two leaders invite the same person, one prompt replaces the other while a finger is moving, and the yes lands on a party nobody read.

The token must be the one on the `PartyInvitation` the player actually saw, never a live lookup at click time. A live lookup is the bug.

`accept` false is a decline, which is a real answer rather than silence: it consumes the invitation and tells the inviter. The timeout does the same thing on its own (`char.cpp:4328-4347` calls `PartyInviteDeny`), so a decline is only ever a player getting there first.
 */
export class PartyAnswer {
  static readonly OPCODE = 0x27;
  token: number = 0;
  accept: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x27);
    w.varint(this.token);
    w.boolean(this.accept);
    return w.bytes();
  }

  static decode(r: Reader): PartyAnswer {
    const self = new PartyAnswer();
    self.token = r.varint();
    self.accept = r.boolean();
    return self;
  }
}

/**
 * Walk out. No fields: a player is in at most one party, and a member may remove only themselves (`input_main.cpp:2048-2051`).

It is also how a party is dissolved, and that is not a second message: the leader leaving disbands it (`:2003-2007`), and so does any departure that would leave one member behind (`:2033-2037`). The original's own client sends one packet for both buttons.
 */
export class PartyLeave {
  static readonly OPCODE = 0x28;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x28);
    return w.bytes();
  }

  static decode(_r: Reader): PartyLeave {
    const self = new PartyLeave();
    return self;
  }
}

/**
 * Throw somebody out (`input_main.cpp:1994-2021`). Leader only.

`slot` and `roster_revision` are the selected row's complete capability: the server rejects a changed roster before resolving the member, so a delayed click cannot name whoever shifted into that row. There is no member identity on this wire.

A leader naming themselves disbands the party, which is the original's own reading of the same packet (`:2003`).
 */
export class PartyKick {
  static readonly OPCODE = 0x29;
  roster_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x29);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): PartyKick {
    const self = new PartyKick();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Choose how the party divides what it earns (`party.cpp:1593-1603`).

Zero is by level weight, one is evenly; anything else is refused rather than clamped, because a mode the server guessed at is a mode nobody chose. Leader only here, which is a deliberate strengthening of the original -- `CInputMain::PartyParameter` (`input_main.cpp:2147-2153`) checks only that the sender has a party, so any member can reprice everybody else's kills. `party.py` argues that at length; this message simply has nowhere to say who is asking, because the session already knows.
 */
export class PartyExpMode {
  static readonly OPCODE = 0x2A;
  mode: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x2A);
    w.u8(this.mode);
    return w.bytes();
  }

  static decode(r: Reader): PartyExpMode {
    const self = new PartyExpMode();
    self.mode = r.u8();
    return self;
  }
}

/**
 * Make a character in one of this account's slots (`CInputLogin::CharacterCreate`, `input_login.cpp:409-470`).

Four fields, and the interesting thing about this message is the list of fields it does **not** have -- because the original's own `command_player_create` (`packet.h:548-559`) has them and they are the reason character creation is a classic place to cheat.

**No statistics.** The original's packet carries `Con`, `Int`, `Str` and `Dex`, four bytes a client fills in and the server then *ignores*: `NewPlayerTable2` reads all four out of `JobInitialPoints[job]` and never looks at the packet's (`input_login.cpp:388-391`). They are dead weight that survived into the wire format from `NewPlayerTable`, the older overload that does take them (`input_login.cpp:250-258`) and which nothing in this build's server calls. Here they are simply absent, so 'a client asked for ninety strength' is not a request a handler can be sloppy about -- it is a sentence with nowhere to live.

**No job.** `race` is a race, and the job is derived from it server-side (`stats.job_for_race`, out of `RaceToJob` at `input_login.cpp:312-353`). A message carrying both could pair a shaman's job with a warrior's body, which is not a hypothetical: the original *stores* the race in the column called `job` (`input_login.cpp:381`, whose comment says so) and derives the real job on every read (`CHARACTER::GetJob`, `char.cpp:1611-1621`). One field on the wire is what keeps those two from ever disagreeing.

**No sex.** Sex is a property of the race, not a second choice: `GET_SEX` (`char.cpp:6617-6636`) reads it off the same eight values. A message with both would let a client ask for the female assassin body under the male assassin's race, and something downstream would have to pick a winner.

**No empire.** The shard's kingdom is a server fact, already carried in the `Characters` frame. Repeating it in a request would make a client-authored claim part of the creation contract, even though this host is the only authority that can choose the spawn table. The handler reads `_shard_empire()` directly; there is no client field to compare and no stale kingdom assertion that can reach creation. A stale or modified client that appends bytes is rejected as trailing data before any mutation.

**No position, level, gold or experience.** The original derives every one of them, and the spawn in particular is `CREATE_START_X(empire)` jittered by +/-300 (`input_login.cpp:397-398`), server-side.

**No account id.** The session already knows who is asking. An account field would be an invitation to fill a stranger's slot.

What is left is the four decisions a player actually makes, and each of them is refused rather than clamped -- see the `NOTICE_BAD_*` block. A clamp would silently hand somebody a character they did not choose, and creation happens once.
 */
export class CreateCharacter {
  static readonly OPCODE = 0x2B;
  slot: number = 0;
  name: string = "";
  race: number = 0;
  shape: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x2B);
    w.u8(this.slot);
    w.string(this.name);
    w.u8(this.race);
    w.u8(this.shape);
    return w.bytes();
  }

  static decode(r: Reader): CreateCharacter {
    const self = new CreateCharacter();
    self.slot = r.u8();
    self.name = r.string();
    self.race = r.u8();
    self.shape = r.u8();
    return self;
  }
}

/**
 * Say something to one named player, wherever they are (`HEADER_CG_WHISPER`, `input_main.cpp:2686-2689`, handled at `:280-502`).

The recipient is a **name**, and this is the only message in the protocol that names a player by anything other than an entity id. It has to be: the whole point of a whisper is that it reaches somebody who is not in front of you, and an entity id is precisely the handle the server has already decided this client may hold. The original resolves it the same way, through `CHARACTER_MANAGER::FindPC(szNameTo)` (`:302`), and never measures a distance.

What the shape refuses. There is no position and no map on it, so a whisper cannot be a way to ask where somebody is standing. And the refusal it comes back with when it does not land says only that nobody by that name is here to hear it: `FindPC` returns null for a name that never existed and for one that logged out a second ago, and both take the `WHISPER_TYPE_NOT_EXIST` branch at `:333-361`. The one "%s is not online." `Whispered` refusal keeps that collapse on purpose, so this message is a presence test and not a character enumerator -- the same line `Reject` draws at login when it declines to say which of the username and the password was wrong.

There is no channel byte, no sender name and no rank either. The sender is the connection; a whisper that carried who it was from would be a whisper anybody could sign.
 */
export class Whisper {
  static readonly OPCODE = 0x2C;
  target_name: string = "";
  text: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x2C);
    w.string(this.target_name);
    w.string(this.text);
    return w.bytes();
  }

  static decode(r: Reader): Whisper {
    const self = new Whisper();
    self.target_name = r.string();
    self.text = r.string();
    return self;
  }
}

/**
 * Found a guild under a name (`input_main.cpp:2055-2116`, `guild.cpp:56-116`).

One field, and the founder is the connection. Every condition is asked of the sender by the server: level 40 (`guild_manage.quest:125`), 200,000 gold (`input_main.cpp:2059`), not already in a guild, and a name no other guild holds. None of the four is representable here, which is the point -- a request that carried the founder's level would found a guild at level one, and one that carried the price would found it for nothing.

Nor is there a master field. `guild.Guild.master` *is* whoever holds grade 1, and `Guilds.found` puts the founder there; a request that named its own master could name somebody else's character and hand them a purse several dozen players pay into.
 */
export class GuildCreate {
  static readonly OPCODE = 0x2D;
  name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x2D);
    w.string(this.name);
    return w.bytes();
  }

  static decode(r: Reader): GuildCreate {
    const self = new GuildCreate();
    self.name = r.string();
    return self;
  }
}

/**
 * Ask a player to join the guild you are already in (`CGuild::Invite`, `guild.cpp:1913-1992`).

Names an entity and not a guild: *which* guild is read off the sender, exactly as the original reads `ch->GetGuild()` (`input_main.cpp:2250`), so an invitation into a guild the sender does not belong to has nowhere to be written. It is also why `guild.Invite` records a guild id rather than only an inviter -- an inviter who leaves before the answer lands cannot drag anybody in behind them.

There is no grade on it. A joiner lands on `JOIN_GRADE`, the bottom of the table, and a request that chose its own rank would choose grade 1, which is the master's. The original refuses that one value (`guild.cpp:1134`) and then range-checks nothing else at all, which is how grade 200 becomes a read 240 bytes past the end of a 15-element array -- see `guild.Refusal.BAD_GRADE`. Carrying no grade closes the whole class.

And there is deliberately no distance rule, for `PartyInvite`'s reason: the original resolves the invitee by VID through the character manager (`input_main.cpp:2252-2253`) and never measures. The real limit is that a client can only name an entity the server has already told it about.
 */
export class GuildInvite {
  static readonly OPCODE = 0x2E;
  target_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x2E);
    w.varint(this.target_id);
    return w.bytes();
  }

  static decode(r: Reader): GuildInvite {
    const self = new GuildInvite();
    self.target_id = r.varint();
    return self;
  }
}

/**
 * Accept or decline **one named invitation** to a guild.

`token` is `PartyAnswer`'s field and carries `PartyAnswer`'s whole argument: `guild.Guilds` mints one per invitation and consumes it on the first answer that resolves it, so an answer naming anything else is the same failed lookup as an answer to an invitation that was never issued, one addressed to somebody else, or one that has expired.

The original answers with a **guild id** instead (`input_main.cpp:2507-2522` reads `p->dwGuild`), which is exactly the resolution this refuses: two guilds invite the same player, one prompt replaces the other while a finger is moving, and an answer that names only a guild joins whichever invitation the server still happens to hold for that pair. A guild is a great deal harder to walk out of than a party -- the master cannot leave at all -- so landing in the wrong one is not a shrug.

The token must be the one on the `GuildInvitation` the player actually read, never a live lookup at click time.

`accept` false is a real answer: it consumes the invitation. The ten-second timeout does the same thing on its own (`guild.cpp:1892-1911` calls `InviteDeny`), so a decline is only ever somebody getting there first.
 */
export class GuildAnswer {
  static readonly OPCODE = 0x2F;
  token: number = 0;
  accept: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x2F);
    w.varint(this.token);
    w.boolean(this.accept);
    return w.bytes();
  }

  static decode(r: Reader): GuildAnswer {
    const self = new GuildAnswer();
    self.token = r.varint();
    self.accept = r.boolean();
    return self;
  }
}

/**
 * Walk out (`pc.remove_from_guild`, `guild_manage.quest:75`). No fields: a player is in at most one guild, and a member may remove only themselves.

Unlike `PartyLeave` this is **not** also how a guild is dissolved, and the two being separate messages is the original's own shape rather than a nicety. A party disbands as a side effect of the leader walking out (`input_main.cpp:2003-2007`), so one packet honestly serves both buttons. A guild does not: `RemoveMember` refuses any member holding grade 1 (`guild.cpp:191-192`, again at `:211-212`), the quest offers leaving only to a non-master (`guild_manage.quest:67`), and dissolving is a different request entirely (`RequestDisband`, `guild.cpp:968-1004`). Folding them together would mean a master who clicked Leave destroyed a roster of thirty people, which is the one misclick in this protocol that cannot be undone.

So a master's leave is refused with `NOTICE_NOT_MASTER` rather than quietly promoted into a disband. `GuildDisband` is the spelling that means it.
 */
export class GuildLeave {
  static readonly OPCODE = 0x30;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x30);
    return w.bytes();
  }

  static decode(_r: Reader): GuildLeave {
    const self = new GuildLeave();
    return self;
  }
}

/**
 * Answer one server-issued guild-war candidate by its opaque token. The token is minted for one session and one menu projection, and is consumed before the normal declaration/acceptance checks run. It cannot name a guild, rule, score, map, result, or payment; all of those remain server-owned (`guild.cpp:1957-2062`).
 */
export class GuildWarChallenge {
  static readonly OPCODE = 0x43;
  token: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x43);
    w.varint(this.token);
    return w.bytes();
  }

  static decode(r: Reader): GuildWarChallenge {
    const self = new GuildWarChallenge();
    self.token = r.varint();
    return self;
  }
}

/**
 * Refuse one incoming guild-war declaration by its current opaque candidate token (`CGuild::RequestRefuseWar`, `guild_war.cpp:540-557`). The token is session-bound and must name an incoming declaration; the request carries no guild id or name. On success the server erases both declaration halves and sends the refusal result to the declarer's master (`CGuildManager::RefuseWar`, `guild_manager.cpp:547-562`).
 */
export class GuildWarRefuse {
  static readonly OPCODE = 0x66;
  token: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x66);
    w.varint(this.token);
    return w.bytes();
  }

  static decode(r: Reader): GuildWarRefuse {
    const self = new GuildWarRefuse();
    self.token = r.varint();
    return self;
  }
}

/**
 * Post one guild-board row (`CGuild::AddComment`, `guild.cpp:1006-1017`; `GUILD_SUBHEADER_CG_POST_COMMENT`, `input_main.cpp:2418-2452`). The server supplies the guild, author, row id and announcement permission; the request carries only the text. A leading `!` is an announcement and requires the server-owned `GUILD_AUTH_NOTICE` rank bit.
 */
export class GuildPostComment {
  static readonly OPCODE = 0x67;
  content: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x67);
    w.string(this.content);
    return w.bytes();
  }

  static decode(r: Reader): GuildPostComment {
    const self = new GuildPostComment();
    self.content = r.string();
    return self;
  }
}

/**
 * Delete one current guild-board row by its rendered slot (`CGuild::DeleteComment`, `guild.cpp:1019-1037`). The server rejects a changed board revision before resolving the stored row id, guild and author: grade one may delete any row in its guild, while other members may delete only their own stored-name rows.
 */
export class GuildDeleteComment {
  static readonly OPCODE = 0x6F;
  board_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x6F);
    w.varint(this.board_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): GuildDeleteComment {
    const self = new GuildDeleteComment();
    self.board_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Refresh the current guild-board rows (`CGuild::RefreshComment`, guild.cpp:1039-1086; input_main.cpp:2450-2455`). The server resolves the sender's guild and returns its stored projection; the request carries no guild, row, author or text.
 */
export class GuildRefreshComments {
  static readonly OPCODE = 0x77;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x77);
    return w.bytes();
  }

  static decode(_r: Reader): GuildRefreshComments {
    const self = new GuildRefreshComments();
    return self;
  }
}

/**
 * Dissolve the whole guild (`RequestDisband`, `guild.cpp:968-1004`).

Master only, and the master is the connection: `guild.cpp:993` returns unless the requesting pid matches the guild's own master, and `Guilds.disband` reads the actor's guild out of the membership index. There is no guild id on this message, so it cannot be aimed, and no confirmation flag, because a boolean that has to be true is a check the client performs on the server's behalf.

It is here rather than left out because without it the founder of a guild can never leave one: `GuildLeave` refuses the master, and handing the guild over is `change_master`, which has no message this round. One request that cannot be reached is a feature missing; two that between them strand a player are a dead end.
 */
export class GuildDisband {
  static readonly OPCODE = 0x31;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x31);
    return w.bytes();
  }

  static decode(_r: Reader): GuildDisband {
    const self = new GuildDisband();
    return self;
  }
}

/**
 * Handshake accepted; the world is described here.
 */
export class Welcome {
  static readonly OPCODE = 0x81;
  entity_id: number = 0;
  tick_hz: number = 0;
  map_id: string = "";
  spawn_x_mm: number = 0;
  spawn_y_mm: number = 0;
  schema_hash: number = 0;
  respawn_ticks: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x81);
    w.varint(this.entity_id);
    w.u8(this.tick_hz);
    w.string(this.map_id);
    w.svarint(this.spawn_x_mm);
    w.svarint(this.spawn_y_mm);
    w.u32(this.schema_hash);
    w.varint(this.respawn_ticks);
    return w.bytes();
  }

  static decode(r: Reader): Welcome {
    const self = new Welcome();
    self.entity_id = r.varint();
    self.tick_hz = r.u8();
    self.map_id = r.string();
    self.spawn_x_mm = r.svarint();
    self.spawn_y_mm = r.svarint();
    self.schema_hash = r.u32();
    self.respawn_ticks = r.varint();
    return self;
  }
}

/**
 * Handshake refused. The connection closes after this frame.
 */
export class Reject {
  static readonly OPCODE = 0x82;
  code: number = 0;
  reason: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x82);
    w.u8(this.code);
    w.string(this.reason);
    return w.bytes();
  }

  static decode(r: Reader): Reject {
    const self = new Reject();
    self.code = r.u8();
    self.reason = r.string();
    return self;
  }
}

/**
 * Authoritative world state, delta-encoded against the last ack.
 */
export class Snapshot {
  static readonly OPCODE = 0x83;
  tick: number = 0;
  ack_seq: number = 0;
  entities: EntityDelta[] = [];
  removed: number[] = [];
  ground_items: GroundItemVnum[] = [];
  skill_motions: SkillMotionBegun[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x83);
    w.varint(this.tick);
    w.svarint(this.ack_seq);
    w.varint(this.entities.length);
    for (const item of this.entities)
      item.encode(w);
    w.varint(this.removed.length);
    for (const item of this.removed)
      w.varint(item);
    w.varint(this.ground_items.length);
    for (const item of this.ground_items)
      item.encode(w);
    w.varint(this.skill_motions.length);
    for (const item of this.skill_motions)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Snapshot {
    const self = new Snapshot();
    self.tick = r.varint();
    self.ack_seq = r.svarint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.entities.push(EntityDelta.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.removed.push(r.varint());
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.ground_items.push(GroundItemVnum.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.skill_motions.push(SkillMotionBegun.decode(r));
    }
    return self;
  }
}

/**
 * One line of chat, delivered, and the channel that decided who got it.

`channel` arrives for one reason: colour. The original's client keeps a palette per type (`uichat.py:625-640` reading `colorinfo.py:1-9`) and this one does the same, because a party line and a shout are read differently and by the time a line lands there is nothing else in it to tell them apart -- the reach that produced it has already been spent.

It is deliberately not a claim about who *else* heard it. There is no recipient count, no roster and no rank on this message. A guild line carrying the speaker's grade would let a client draw a crown the server never granted, and a guild line carrying the guild's name would let one claim a guild it is not in; both travel on `Guild`, once, from the server that owns the roster.

`entity_id` is the speaker's, and it is **zero on the channels whose reach is wider than what the recipient can see** -- `CHAT_INFO`, `CHAT_SHOUT` and `CHAT_GUILD`. On `CHAT_SAY` the listener is inside the same interest radius and has been told about the speaker already; on `CHAT_PARTY` they hold a `Party` roster that names every member's id anyway. On the wider-reach channels they hold neither, and an id there is a handle for somebody interest management has deliberately not mentioned -- which is a position lookup given away by the quietest thing in the game. INFO is a server-authored current-player line and carries an empty name; the client renders it through the same system palette as other INFO lines. Quest `_chat` is the other current-player form: it keeps `CHAT_SAY`'s talking visual but also carries empty id and name because the original `ChatPacket` does (`char.cpp:3749-3775`). `name` is what a client draws for a real speaker.

`name` is the server's copy of the speaker's name and never the sender's, for the reason `Chat` carries no name at all.
 */
export class ChatEcho {
  static readonly OPCODE = 0x84;
  entity_id: number = 0;
  name: string = "";
  text: string = "";
  channel: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x84);
    w.varint(this.entity_id);
    w.string(this.name);
    w.string(this.text);
    w.u8(this.channel);
    return w.bytes();
  }

  static decode(r: Reader): ChatEcho {
    const self = new ChatEcho();
    self.entity_id = r.varint();
    self.name = r.string();
    self.text = r.string();
    self.channel = r.u8();
    return self;
  }
}

/**
 * Answer to a `Ping`. `server_tick` is sampled when the server handles the frame; the client pairs it with its own pending-send timestamp locally. No client-provided time is echoed back.
 */
export class Pong {
  static readonly OPCODE = 0x85;
  server_tick: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x85);
    w.varint(this.server_tick);
    return w.bytes();
  }

  static decode(r: Reader): Pong {
    const self = new Pong();
    self.server_tick = r.varint();
    return self;
  }
}

/**
 * One resolved damage event. Sent to everyone who can see either party, so the numbers a client renders are the numbers the server computed.
 */
export class CombatEvent {
  static readonly OPCODE = 0x86;
  attacker_id: number = 0;
  target_id: number = 0;
  damage: number = 0;
  flags: number = 0;
  skill: number = 0;
  combo_motion: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x86);
    w.varint(this.attacker_id);
    w.varint(this.target_id);
    w.varint(this.damage);
    w.u8(this.flags);
    w.varint(this.skill);
    w.u8(this.combo_motion);
    return w.bytes();
  }

  static decode(r: Reader): CombatEvent {
    const self = new CombatEvent();
    self.attacker_id = r.varint();
    self.target_id = r.varint();
    self.damage = r.varint();
    self.flags = r.u8();
    self.skill = r.varint();
    self.combo_motion = r.u8();
    return self;
  }
}

/**
 * One mote in flight between two entities, by fly type.

`CHARACTER::CreateFly` (`char_battle.cpp:88-98`) broadcasts `TPacketGCCreateFly` -- a type byte and two VIDs -- to everyone around the source, and `RecvCreateFlyPacket` (`PythonNetworkStreamPhaseGame.cpp:2640-2657`) hands the pair to `CFlyingManager::CreateIndexedFly`. The type indexes the table `RegisterIndexedFlyData` fills at startup (`playersettingmodule.py:419-434`), so the frame names a `.msf` flight script and nothing about what caused it: an EXP mote from a kill, a stolen drop of life, and a firework all arrive as this one message with a different byte.

Both ends are VIDs rather than points because the flight homes: `CFlyingInstance::Update` re-aims at the target's *live* position every step once `HomingStartTime` has passed (`FlyingInstance.cpp:351-356`), and a target that walked away from a coordinate would be chased to where it used to stand.
 */
export class CreateFly {
  static readonly OPCODE = 0xB0;
  fly: number = 0;
  from_id: number = 0;
  to_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB0);
    w.u8(this.fly);
    w.varint(this.from_id);
    w.varint(this.to_id);
    return w.bytes();
  }

  static decode(r: Reader): CreateFly {
    const self = new CreateFly();
    self.fly = r.u8();
    self.from_id = r.varint();
    self.to_id = r.varint();
    return self;
  }
}

/**
 * A body the server moved by force, and where it now stands.

`CHARACTER::SyncPacket` (`char.cpp:6249-6267`) sends `TPacketGCSyncPosition` with one element -- a VID and a position -- to everyone around the body, after a crush slides a victim (`char_skill.cpp:1393-1403`), `/pull_monster` drags one (`char_battle.cpp:3331-3335`), the blue dragon throws one (`BlueDragon_Skill.h:318-328`) or a stun stops one mid-walk (`char_affect.cpp:541-548`). `RecvSyncPositionPacket` hands it to `CNetworkActorManager::SyncActor` (`PythonNetworkStreamPhaseGameActor.cpp:390-411`, `NetworkActorManager.cpp:539-557`), and `CActorInstance::__Push` blends the drawn body there and knocks it down past 150 units (`ActorInstanceSync.cpp:7-53`).

The snapshot carries the same position, but not the fact that it was a shove rather than a step: without this frame a pushed body walks to where it was thrown.
 */
export class SyncPosition {
  static readonly OPCODE = 0xFF;
  entity_id: number = 0;
  x_mm: number = 0;
  y_mm: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xFF);
    w.varint(this.entity_id);
    w.svarint(this.x_mm);
    w.svarint(this.y_mm);
    return w.bytes();
  }

  static decode(r: Reader): SyncPosition {
    const self = new SyncPosition();
    self.entity_id = r.varint();
    self.x_mm = r.svarint();
    self.y_mm = r.svarint();
    return self;
  }
}

/**
 * The recipient's whole inventory, sent when they have none.

A change to one cell is answered by `ItemSet` or `ItemDel` naming that cell, the way `CHARACTER::SetItem` answers one (`char_item.cpp:386-412`). This frame is what the original has no equivalent of, because the original has nothing to establish: it ships one `HEADER_GC_ITEM_SET` per stored row as the character loads (`CItem::AddToCharacter`, `item.cpp:338-370`, into the same `SetItem`). Ninety-odd of those to say what one frame says is the one place a whole bag is cheaper, so login sends this and everything after it sends the cell.

Also the answer when `capacity` itself moves -- a belt worn or taken off resizes the grid (`BELT_INVENTORY_SLOT_START`, `length.h:685-686`) and the client must redraw it before any cell in the new range means anything.
 */
export class Bag {
  static readonly OPCODE = 0x88;
  gold: number = 0;
  capacity: number = 0;
  slots: BagSlot[] = [];
  worn: BagSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x88);
    w.varint(this.gold);
    w.varint(this.capacity);
    w.varint(this.slots.length);
    for (const item of this.slots)
      item.encode(w);
    w.varint(this.worn.length);
    for (const item of this.worn)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Bag {
    const self = new Bag();
    self.gold = r.varint();
    self.capacity = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.slots.push(BagSlot.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.worn.push(BagSlot.decode(r));
    }
    return self;
  }
}

/**
 * What one cell holds now. `TPacketGCItemSet` (`packet.h:1069-1080`) under `HEADER_GC_ITEM_SET` (`packet.h:139`), which `CHARACTER::SetItem` sends for the one cell it just wrote (`char_item.cpp:386-400`) and for nothing else.

The cost of an item action is the size of the change, not the size of the bag. A player with a full bag, a belt and a dragon-soul deck pays for one cell on every pickup, every use, every socket write and every refine -- which is what the original charges them.

Carries a `BagSlot`'s own fields rather than a copy of them, so a field added to a cell cannot be added to one of the two frames that describe one. `window` and `slot` are `TItemPos` (`length.h:754`) split in two: the body and the bag are one address space in the original and two arrays here, and a cell number alone cannot say which it belongs to.
 */
export class ItemSet {
  static readonly OPCODE = 0xBF;
  window: number = 0;
  slot: number = 0;
  vnum: number = 0;
  count: number = 0;
  name: string = "";
  kind: number = 0;
  sell_value: number = 0;
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  level_limit: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  heal_hp: number = 0;
  heal_hp_pct: number = 0;
  barred_jobs: number = 0;
  bonuses: ItemBonus[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xBF);
    w.u8(this.window);
    w.varint(this.slot);
    w.varint(this.vnum);
    w.varint(this.count);
    w.string(this.name);
    w.u8(this.kind);
    w.varint(this.sell_value);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.level_limit);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.heal_hp);
    w.varint(this.heal_hp_pct);
    w.u8(this.barred_jobs);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): ItemSet {
    const self = new ItemSet();
    self.window = r.u8();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.count = r.varint();
    self.name = r.string();
    self.kind = r.u8();
    self.sell_value = r.varint();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    self.level_limit = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.heal_hp = r.varint();
    self.heal_hp_pct = r.varint();
    self.barred_jobs = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * That cell is empty now. `TPacketGCItemDel` (`packet.h:1082-1086`), which is the branch `CHARACTER::SetItem` takes when it wrote a null (`char_item.cpp:404-412`).

The original's own del packet carries the cleared vnum, count, sockets and attributes and its reader ignores every one of them (`TPacketGCItemDelDeprecated`, `packet.h:1059-1067`); this carries the cell, because that is the whole message.
 */
export class ItemDel {
  static readonly OPCODE = 0xC0;
  window: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC0);
    w.u8(this.window);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): ItemDel {
    const self = new ItemDel();
    self.window = r.u8();
    self.slot = r.varint();
    return self;
  }
}

/**
 * What the recipient is carrying now. `CHARACTER::PointChange` sends `POINT_GOLD` as its own `TPacketGCPointChange` (`char.cpp:3491-3507`, `packet.h:1038-1044`) and never as part of a description of the bag.

Separate from `ItemSet` because the two change independently: a quest reward, a monster's purse and a stall sale move money without touching a cell, and a use or a swap moves a cell without touching money.
 */
export class Gold {
  static readonly OPCODE = 0xC1;
  gold: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC1);
    w.varint(this.gold);
    return w.bytes();
  }

  static decode(r: Reader): Gold {
    const self = new Gold();
    self.gold = r.varint();
    return self;
  }
}

/**
 * What the dealer in front of this player is selling.

Sent in answer to `ClickNpc`, and never unprompted. The whole counter each time rather than a delta, for the reason `Bag` gives: a shop is two dozen rows that change when the shard is rebuilt, and a delta would buy nothing but a way for the client's shelf list to drift from the server's -- which, since a purchase names a shelf by the server's own cell number, would be a player buying something other than what they clicked.

`npc_id` of zero means *close whatever is open*, the same convention `QuestDialog`'s zero token uses, and is what a dealer who walked out of reach or a window the server dropped comes back as. A frame with shelves always carries the dealer it belongs to, so a client cannot draw one shop's stock under another's name.

Only shelves this shard can actually deliver are listed. A shelf whose item is not in this build's game data has no definition to size a stack or persist it by, so it is left out rather than drawn and refused on click.
 */
export class Shop {
  static readonly OPCODE = 0x90;
  npc_id: number = 0;
  name: string = "";
  items: ShopSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x90);
    w.varint(this.npc_id);
    w.string(this.name);
    w.varint(this.items.length);
    for (const item of this.items)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Shop {
    const self = new Shop();
    self.npc_id = r.varint();
    self.name = r.string();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.items.push(ShopSlot.decode(r));
    }
    return self;
  }
}

/**
 * Why something the player asked for did not happen. Sent to one client. The text is composed server-side and is safe to display; the code exists so the client can react without parsing prose.

**`code` is a varint rather than a byte, because the codes are allocated in blocks and the blocks have passed 255.** They are allocated rather than continued from the highest number in the file for the reason `_validate_notice_codes` gives at length: three authors reading this file in parallel each see the same highest value and are each right when they look, and four codes collided the day their branches merged. Blocks make that impossible and they also make the space sparse, so it ran past a byte long before there were 255 distinct sentences. A code under 128 is still one byte on the wire, and a notice is a refusal -- a frame nobody sends at any rate worth counting bytes at.

**`big` is the original's second chat type, not a style hint.** The original has no notice field at all: it picks a *packet type* -- `CHAT_TYPE_NOTICE` or `CHAT_TYPE_BIG_NOTICE` (`length.h:255-257`) -- and the client routes the two to two different windows, `BINARY_SetTipMessage` -> `TipBoard` and `BINARY_SetBigMessage` -> `BigBoard` (`PythonNetworkStreamPhaseGame.cpp:1351-1358`). One bool on one message rather than a second opcode because everything else about the two is identical -- same sender, same recipient rule, same string -- and a second opcode would be the first message in this schema that differs from another only in which window draws it.

It is not the same fact as `code`. `code` is *why* (a refusal's reason, so the client can react without parsing prose); `big` is *which board*, and the original picks it per call from places that share no reason at all: `do_big_notice` (`cmd_gm.cpp:1205-1208`), `SendNoticeMap(..., bBigFont)` (`:1114-1137`) and, through that, every quest's `notice_in_map(text, big)` (`questlua_global.cpp:1157-1167`) -- which is what every OX-contest announcement uses (`OXEvent.cpp:200-245`). Folding it into the code space would mean a second code for every sentence that can be shouted.
 */
export class Notice {
  static readonly OPCODE = 0x89;
  code: number = 0;
  text: string = "";
  big: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x89);
    w.varint(this.code);
    w.string(this.text);
    w.boolean(this.big);
    return w.bytes();
  }

  static decode(r: Reader): Notice {
    const self = new Notice();
    self.code = r.varint();
    self.text = r.string();
    self.big = r.boolean();
    return self;
  }
}

/**
 * The recipient's own spirit pool -- the original's SP, what skills will spend.

Its own message rather than two more fields on `Standing`, because it changes on a different clock: spirit regenerates every three seconds while standing still, and folding it into `Standing` would resend a character's whole progression, statistics included, twenty times a minute to say one number moved.

Sent to one client, never broadcast. The same rule `Standing` follows: how much a player has left to cast with is exactly what an opponent would want to know, and it is nobody else's.

It also carries the two potion pools, because they move on exactly this clock and to exactly this one recipient. The original sends `POINT_HP_RECOVERY` and `POINT_SP_RECOVERY` as ordinary points on `HEADER_GC_CHARACTER_POINT_CHANGE` (`char.cpp:3258-3259`, `char.cpp:3491-3506`), unicast whenever `PointChange` touches them -- the potion credit (`char_item.cpp:4053`, `:4065`), each one-second drain (`char_affect.cpp:98`, `:105`, `:112`, `:119`) and `CHARACTER::Stun` zeroing both (`char_battle.cpp:378-379`). Two fields on the frame that already carries the spirit half of the same pool beats a second private frame that would be sent on the same ticks.
 */
export class Spirit {
  static readonly OPCODE = 0x8B;
  sp: number = 0;
  max_sp: number = 0;
  hp_recovery: number = 0;
  sp_recovery: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x8B);
    w.varint(this.sp);
    w.varint(this.max_sp);
    w.varint(this.hp_recovery);
    w.varint(this.sp_recovery);
    return w.bytes();
  }

  static decode(r: Reader): Spirit {
    const self = new Spirit();
    self.sp = r.varint();
    self.max_sp = r.varint();
    self.hp_recovery = r.varint();
    self.sp_recovery = r.varint();
    return self;
  }
}

/**
 * The recipient's own player-versus-player mode, as the server holds it.

Sent on join and after every `SetPvpMode`, accepted or not, so the client's display is the server's state rather than the client's last request. Sent to one client and never broadcast: whether a given player can be attacked is exactly the fact a griefer wants a map of, and a broadcast mode would be a live list of who is fightable and where.
 */
export class PvpStatus {
  static readonly OPCODE = 0x8A;
  mode: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x8A);
    w.u8(this.mode);
    return w.bytes();
  }

  static decode(r: Reader): PvpStatus {
    const self = new PvpStatus();
    self.mode = r.u8();
    return self;
  }
}

/**
 * One consented duel between two named players, as the server holds it. `TPacketGCPVP` / `HEADER_GC_PVP` (`packet.h:1364-1369`).

This is the *other* PvP system: not the recipient's own PK mode (`PvpStatus`) and not the arena ladder, but `CPVPManager`'s pairwise challenge -- two players anywhere on the map agreeing to fight (`pvp.cpp:17-345`). Three fields, exactly the original's: a source vid, a destination vid and a mode.

Unlike `PvpStatus` this one *is* broadcast, because the original broadcasts it: `CPVP::Packet` walks the whole client set and sends to every descriptor in `PHASE_GAME` or `PHASE_DEAD` (`pvp.cpp:99-108`). That is not an oversight to be tightened -- a bystander has to be able to see that two people are duelling, because the duel is the one case where two players hitting each other in a peaceful town is legitimate, and a watcher with no frame would read it as a bug or an exploit.

Which way round the pair is sent carries the meaning, and the original is precise about it (`pvp.cpp:66-98`): for `AGREE` and `REVENGE`, *src is the side that has already said yes* and dst is the side being asked, so a client that finds itself in `dst` knows it has been challenged and one that finds itself in `src` knows it is waiting. For `FIGHT` and `NONE` the pair is sent in slot order and neither end means anything. `REVENGE` rather than `AGREE` when the pair has already produced a death and the asked side holds a rematch right (`CPVP::m_bRevenge`, `pvp.cpp:84`).

Replayed in full to a joining client by `CPVPManager::SendList` (`pvp.cpp:544-600`, called from `input_login.cpp:572-573`), because a duel survives a relog: `Disconnect` is the no-op the 2014 source commented out (`pvp.cpp:256-259`).
 */
export class PvpDuel {
  static readonly OPCODE = 0xA3;
  src_id: number = 0;
  dst_id: number = 0;
  mode: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA3);
    w.u32(this.src_id);
    w.u32(this.dst_id);
    w.u8(this.mode);
    return w.bytes();
  }

  static decode(r: Reader): PvpDuel {
    const self = new PvpDuel();
    self.src_id = r.u32();
    self.dst_id = r.u32();
    self.mode = r.u8();
    return self;
  }
}

/**
 * The recipient's whole skill bar, resent in full on every change.

Deliberately not a delta, and deliberately not a subscription to cooldowns. The same trade `Bag` makes: five slots is a couple of hundred bytes, a bar changes when a skill is cast or levelled -- a few times a minute -- and the delta would buy nothing while adding a way for the client's idea of what it knows to drift from the server's.

Sent to one client and never broadcast. What an opponent has learned, how much spirit their next cast costs and how long until they can cast it again is the complete input to deciding when to engage them, and it is nobody else's. The same rule `Standing` and `Spirit` follow.

It is also the answer to every `UseSkill` and every `SkillUp`, accepted or refused: a refused cast still repaints the bar, which is how a client learns it was on cooldown without being told a reason it could have measured.
 */
export class Skills {
  static readonly OPCODE = 0x8C;
  points: number = 0;
  horse_points: number = 0;
  slots: SkillSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x8C);
    w.varint(this.points);
    w.varint(this.horse_points);
    w.varint(this.slots.length);
    for (const item of this.slots)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Skills {
    const self = new Skills();
    self.points = r.varint();
    self.horse_points = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.slots.push(SkillSlot.decode(r));
    }
    return self;
  }
}

/**
 * Every timed modifier on the recipient, resent in full when the set changes.

Sent on join, when one is applied, and when one expires -- not every tick. The client counts the remaining ticks down itself, which is why `AffectSlot.remaining` is a duration: a per-tick broadcast of a countdown is bandwidth spent restating arithmetic both sides can do.

Private, like the rest of this family. Whether an opponent's attack-speed buff has four seconds left is the single most useful fact about them, and broadcasting it would be handing it out.
 */
export class Affects {
  static readonly OPCODE = 0x8D;
  entries: AffectSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x8D);
    w.varint(this.entries.length);
    for (const item of this.entries)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Affects {
    const self = new Affects();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.entries.push(AffectSlot.decode(r));
    }
    return self;
  }
}

/**
 * One page of a conversation, and what may be done with it.

The client draws this and sends back a `QuestReply` carrying the token. It never decides that a page is the last one, never decides what an option does, and never advances a quest: a page with no choices has one button, a page with choices has those, and which of them was pressed is the entire extent of what the client contributes.

`token` of zero is the one exception and means *close whatever is open*: a script that ends with nothing more to say -- every `letter` handler, and the `Close` option on an NPC menu -- leaves a window on screen that the server has to take back. Sent as a frame rather than left to a client timeout, because a dialogue that closes itself on a guess is a dialogue that closes over the player's reading.
 */
export class QuestDialog {
  static readonly OPCODE = 0x8E;
  token: number = 0;
  title: string = "";
  final: boolean = false;
  skin: number = 1;
  lines: QuestLine[] = [];
  choices: QuestChoice[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x8E);
    w.varint(this.token);
    w.string(this.title);
    w.boolean(this.final);
    w.varint(this.skin);
    w.varint(this.lines.length);
    for (const item of this.lines)
      item.encode(w);
    w.varint(this.choices.length);
    for (const item of this.choices)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): QuestDialog {
    const self = new QuestDialog();
    self.token = r.varint();
    self.title = r.string();
    self.final = r.boolean();
    self.skin = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.lines.push(QuestLine.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.choices.push(QuestChoice.decode(r));
    }
    return self;
  }
}

/**
 * Every quest this character has open, resent in full whenever any of it changes.

Not a delta, for the reason `Bag` is not a delta: a quest log has a handful of rows, changes a few times an hour, and the bytes a delta would save are not worth a way for the client's idea of a quest to drift from the server's. Sent on join and after every event that touched a quest -- a kill that moved a counter, a state change, a reward -- and it is the *whole* log each time, so a client that missed one is corrected by the next rather than left showing a kill count that stopped moving.

Private, like `Standing` and `Bag`. What quest someone is on is a fact about their character and nobody else's business.
 */
export class QuestLog {
  static readonly OPCODE = 0x8F;
  entries: QuestEntry[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x8F);
    w.varint(this.entries.length);
    for (const item of this.entries)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): QuestLog {
    const self = new QuestLog();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.entries.push(QuestEntry.decode(r));
    }
    return self;
  }
}

/**
 * A server-created quest arrow (`target.cpp:15-27`). The client cannot complete, move or remove it; all three facts are server state.
 */
export class QuestTargetCreate {
  static readonly OPCODE = 0xC6;
  target_id: number = 0;
  x_mm: number = 0;
  y_mm: number = 0;
  description: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC6);
    w.varint(this.target_id);
    w.svarint(this.x_mm);
    w.svarint(this.y_mm);
    w.string(this.description);
    return w.bytes();
  }

  static decode(r: Reader): QuestTargetCreate {
    const self = new QuestTargetCreate();
    self.target_id = r.varint();
    self.x_mm = r.svarint();
    self.y_mm = r.svarint();
    self.description = r.string();
    return self;
  }
}

/**
 * A changed target position (`target.cpp:30-38`), emitted after the server re-reads a VID target's transform.
 */
export class QuestTargetUpdate {
  static readonly OPCODE = 0xC7;
  target_id: number = 0;
  x_mm: number = 0;
  y_mm: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC7);
    w.varint(this.target_id);
    w.svarint(this.x_mm);
    w.svarint(this.y_mm);
    return w.bytes();
  }

  static decode(r: Reader): QuestTargetUpdate {
    const self = new QuestTargetUpdate();
    self.target_id = r.varint();
    self.x_mm = r.svarint();
    self.y_mm = r.svarint();
    return self;
  }
}

/**
 * Remove a quest arrow (`target.cpp:41-47`). Local removal never answers `target.arrive`; only the server's transform sweep can.
 */
export class QuestTargetDelete {
  static readonly OPCODE = 0xC8;
  target_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC8);
    w.varint(this.target_id);
    return w.bytes();
  }

  static decode(r: Reader): QuestTargetDelete {
    const self = new QuestTargetDelete();
    self.target_id = r.varint();
    return self;
  }
}

/**
 * Every NPC the map's own regen rows placed, sent once, at join.

`SECTREE_MANAGER::SendNPCPosition` (`sectree_manager.cpp:1051-1090`) walks the per-map list `InsertNPCPosition` filled at load (`:1092-1095`, from `regen.cpp:677-687`) and sends it to one descriptor from `Entergame` (`input_login.cpp:548`). It is the map screen's marker list and nothing else: no entity ids, no live positions, and no second send when one of them moves or dies.

An empty roster is still sent as an empty list rather than skipped, because a client that received nothing cannot tell "this map has no markers" from "the frame has not arrived".
 */
export class NpcPositions {
  static readonly OPCODE = 0xC9;
  markers: NpcMarker[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC9);
    w.varint(this.markers.length);
    for (const item of this.markers)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): NpcPositions {
    const self = new NpcPositions();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.markers.push(NpcMarker.decode(r));
    }
    return self;
  }
}

/**
 * What the blacksmith says about one item, before anything is risked.

Every number on it is the server's own, read out of `refine.json` at the moment of asking: the cost, the percentage, what the item would become, and how many of each material the player is actually holding. The client draws them and decides nothing -- and in particular `affordable` and the material counts are what grey a button out, never what permits a refinement. The same recipe is read again when `Refine` arrives.

`chance` is sent because it is the player's to know. A player about to stake a Sword+8 on a thirty-percent roll is entitled to see the thirty, and showing it costs nothing: the roll is seeded from the entity, the tick and the slot, so a client that knows the odds still cannot know the outcome or choose the tick it lands on.

`will_destroy` is the field this frame exists for. An ordinary refinement that fails destroys the item outright (`char_item.cpp:920-925`), and a window that showed a price and a percentage without saying so is a window that loses people their gear. It is a field rather than a constant because the scroll paths this build does not implement fail differently -- downgrade, or survive untouched (`char_item.cpp:1184-1201`) -- and the day one arrives the panel should say what it does rather than lie.

Sent only in answer to `RefineInfo`, and never unprompted.
 */
export class RefineOffer {
  static readonly OPCODE = 0x91;
  slot: number = 0;
  npc_id: number = 0;
  item_vnum: number = 0;
  item_name: string = "";
  result_vnum: number = 0;
  result_name: string = "";
  item_kind: number = 0;
  result_kind: number = 0;
  cost: number = 0;
  affordable: boolean = false;
  chance: number = 0;
  will_destroy: boolean = false;
  materials: RefineMaterial[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x91);
    w.u8(this.slot);
    w.varint(this.npc_id);
    w.varint(this.item_vnum);
    w.string(this.item_name);
    w.varint(this.result_vnum);
    w.string(this.result_name);
    w.u8(this.item_kind);
    w.u8(this.result_kind);
    w.varint(this.cost);
    w.boolean(this.affordable);
    w.u8(this.chance);
    w.boolean(this.will_destroy);
    w.varint(this.materials.length);
    for (const item of this.materials)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): RefineOffer {
    const self = new RefineOffer();
    self.slot = r.u8();
    self.npc_id = r.varint();
    self.item_vnum = r.varint();
    self.item_name = r.string();
    self.result_vnum = r.varint();
    self.result_name = r.string();
    self.item_kind = r.u8();
    self.result_kind = r.u8();
    self.cost = r.varint();
    self.affordable = r.boolean();
    self.chance = r.u8();
    self.will_destroy = r.boolean();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.materials.push(RefineMaterial.decode(r));
    }
    return self;
  }
}

/**
 * What the roll did. The `Bag` that follows is the truth; this is the sentence.

Deliberately thin. It carries no slot, no vnum and no gold: the whole inventory is resent alongside it, so anything here that described the new state would be a second description free to disagree with the first. What it carries is the two names, because 'Sword+8 was destroyed' cannot be reconstructed from a bag that no longer contains a Sword+8.

`result_name` is empty on a failure, for the same reason `refine.Attempt.to_vnum` is zero: nothing was made, so there is nothing to name.
 */
export class RefineResult {
  static readonly OPCODE = 0x92;
  succeeded: boolean = false;
  item_name: string = "";
  result_name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x92);
    w.boolean(this.succeeded);
    w.string(this.item_name);
    w.string(this.result_name);
    return w.bytes();
  }

  static decode(r: Reader): RefineResult {
    const self = new RefineResult();
    self.succeeded = r.boolean();
    self.item_name = r.string();
    self.result_name = r.string();
    return self;
  }
}

/**
 * Both halves of an open trade, from the recipient's point of view, resent in full whenever any of it changes.

One frame describing both sides rather than one per side, because that is the shape the rule has: an accept is agreement to a *pair* of offers, and a client holding two frames that arrived separately is a client that can draw half of one state and half of another. The same argument `exchange.py` makes for holding one object instead of two that must agree.

Sent to both participants on every change, and the two frames differ: `mine` and `theirs` are swapped, so neither client has to work out which side it is. Not a delta, for `Bag`'s reason -- two dozen bytes, a handful of changes per trade, and a delta would buy nothing but a way for a client's picture of a trade to drift from the server's, which in this feature is the whole attack.

`token` is the server's name for this exact pair of offers, and it changes whenever either of them does. `ExchangeAccept` must carry it. A `partner_id` of zero means *no trade is open* -- the same convention `Shop`'s zero `npc_id` and `QuestDialog`'s zero token use -- and is what an ended, refused or cancelled trade comes back as.
 */
export class ExchangeState {
  static readonly OPCODE = 0x93;
  token: number = 0;
  partner_id: number = 0;
  partner_name: string = "";
  my_gold: number = 0;
  their_gold: number = 0;
  my_accepted: boolean = false;
  their_accepted: boolean = false;
  settled: boolean = false;
  mine: ItemView[] = [];
  theirs: ItemView[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x93);
    w.varint(this.token);
    w.varint(this.partner_id);
    w.string(this.partner_name);
    w.varint(this.my_gold);
    w.varint(this.their_gold);
    w.boolean(this.my_accepted);
    w.boolean(this.their_accepted);
    w.boolean(this.settled);
    w.varint(this.mine.length);
    for (const item of this.mine)
      item.encode(w);
    w.varint(this.theirs.length);
    for (const item of this.theirs)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): ExchangeState {
    const self = new ExchangeState();
    self.token = r.varint();
    self.partner_id = r.varint();
    self.partner_name = r.string();
    self.my_gold = r.varint();
    self.their_gold = r.varint();
    self.my_accepted = r.boolean();
    self.their_accepted = r.boolean();
    self.settled = r.boolean();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.mine.push(ItemView.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.theirs.push(ItemView.decode(r));
    }
    return self;
  }
}

/**
 * The account's storeroom, whole, whenever any of it changes.

Not a delta, for `Bag`'s reason and with one more of its own: this is the one container in the game that two of a player's characters both write to, so a client's copy of it is the copy most likely to be stale. Resending all of it makes a stale copy a frame old rather than a session old.

`npc_id` of zero means *the box is not open*, the same convention `Shop` uses -- what an unopened box, a wrong password, a keeper walked away from and a shut panel all come back as. A frame with cells always names the keeper it was opened at.

`capacity` is the number of cells the account has paid for, which is `pages` times forty-five and is zero until the first page is rented. A client draws the grid the server enforces rather than the one the constant says, exactly as `Bag.capacity` works.

**There is no gold field, and its absence is the original's.** `CSafebox` declares `m_lGold` and saves it, but the load query does not select it, no code in the game server ever changes it, and the client's own deposit send is commented out (`PythonNetworkStreamPhaseGameItem.cpp:20`) -- so in this source tree the storeroom stores items only. Adding one would be designing a feature rather than porting one; see `safebox.py`'s docstring for the citations.
 */
export class Safebox {
  static readonly OPCODE = 0x94;
  npc_id: number = 0;
  pages: number = 0;
  capacity: number = 0;
  unlock_price: number = 0;
  cells: SafeboxSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x94);
    w.varint(this.npc_id);
    w.varint(this.pages);
    w.varint(this.capacity);
    w.varint(this.unlock_price);
    w.varint(this.cells.length);
    for (const item of this.cells)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Safebox {
    const self = new Safebox();
    self.npc_id = r.varint();
    self.pages = r.varint();
    self.capacity = r.varint();
    self.unlock_price = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.cells.push(SafeboxSlot.decode(r));
    }
    return self;
  }
}

/**
 * Somebody has asked this player to group up.

Sent to the invitee only, once, and answered with the `token` it carries. The token is the server's name for *this* invitation and not for the pair of players: a second invitation from a different leader arrives with its own, and an answer that named neither would be an answer to whichever the server happened to hold. See `PartyAnswer`.

A `token` of zero means **the invitation is gone** -- answered, declined, expired, or its inviter logged out -- and is what takes the prompt off the screen. The same convention `Shop`'s zero `npc_id` and `ExchangeState`'s zero `partner_id` use, and it is load-bearing here because an invitation that stayed on screen after it expired is a prompt whose only outcome is a refusal.

`seconds` is how long the invitation stands, sent rather than hardcoded so a countdown says what the server will actually enforce. `INVITE_TIMEOUT_SECONDS` is ten (`char.cpp:4421`), and the timeout is a decline rather than an error.
 */
export class PartyInvitation {
  static readonly OPCODE = 0x95;
  token: number = 0;
  inviter_id: number = 0;
  inviter_name: string = "";
  seconds: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x95);
    w.varint(this.token);
    w.varint(this.inviter_id);
    w.string(this.inviter_name);
    w.u8(this.seconds);
    return w.bytes();
  }

  static decode(r: Reader): PartyInvitation {
    const self = new PartyInvitation();
    self.token = r.varint();
    self.inviter_id = r.varint();
    self.inviter_name = r.string();
    self.seconds = r.u8();
    return self;
  }
}

/**
 * The whole party, resent to every member whenever any of it changes.

Whole rather than a delta, for `Bag`'s reason: it is eight rows at most, it changes a handful of times in a party's life, and a delta would buy nothing but a way for one member's picture of the group to drift from the server's. A party that two clients disagree about is a party in which one of them is drawing somebody else's share.

A `leader_id` of zero means **no party** -- never joined, left, kicked, or disbanded -- and every member of a party that ends gets one, computed from the roster *before* the change so the person who left is still there to be told (`party.cpp:473-474` calls `SendPartyRemoveOneToAll` before the erase for exactly this).

`bonus_percent` is what the party is currently adding to a kill, and it is the server's own arithmetic rather than a headcount the client could index a table with: it folds `aiPartyBonusExpPercentByMemberCount` together with the five percent an hour-old party earns (`party.cpp:1523-1529`), and it is zero whenever fewer than two members are near the leader. A client that counted `near` rows and looked the answer up would be right until the hour passed.
 */
export class Party {
  static readonly OPCODE = 0x96;
  leader_id: number = 0;
  roster_revision: number = 0;
  mode: number = 0;
  leadership: number = 0;
  bonus_percent: number = 0;
  heal_ready: boolean = false;
  members: PartyMember[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x96);
    w.varint(this.leader_id);
    w.varint(this.roster_revision);
    w.u8(this.mode);
    w.u8(this.leadership);
    w.u8(this.bonus_percent);
    w.boolean(this.heal_ready);
    w.varint(this.members.length);
    for (const item of this.members)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Party {
    const self = new Party();
    self.leader_id = r.varint();
    self.roster_revision = r.varint();
    self.mode = r.u8();
    self.leadership = r.u8();
    self.bonus_percent = r.u8();
    self.heal_ready = r.boolean();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.members.push(PartyMember.decode(r));
    }
    return self;
  }
}

/**
 * Assign or remove the attacker in one party roster seat. This is the reachable slice of `HEADER_CG_PARTY_SET_STATE` (`input_main.cpp:1910-1965`).

The request carries no member id, role number, Leadership level, capacity or bonus. `slot` and `roster_revision` identify the server's current roster frame; the server resolves the member, reads the leader and skill 121, and knows this message can mean only attacker. A modified client therefore cannot assign an unimplemented role or claim the Leadership-40 capacity.
 */
export class PartyAttacker {
  static readonly OPCODE = 0x68;
  roster_revision: number = 0;
  slot: number = 0;
  assign: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x68);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    w.boolean(this.assign);
    return w.bytes();
  }

  static decode(r: Reader): PartyAttacker {
    const self = new PartyAttacker();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    self.assign = r.boolean();
    return self;
  }
}

/**
 * Assign or remove one non-leader party role in a server roster seat. It completes `HEADER_CG_PARTY_SET_STATE` (`input_main.cpp:1910-1965`).

The request names only a roster revision, slot, and constrained role choice; the server owns membership, leadership, capacity, proximity and the resulting point.
 */
export class PartyRole {
  static readonly OPCODE = 0x6B;
  roster_revision: number = 0;
  slot: number = 0;
  role: number = 0;
  assign: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x6B);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    w.u8(this.role);
    w.boolean(this.assign);
    return w.bytes();
  }

  static decode(r: Reader): PartyRole {
    const self = new PartyRole();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    self.role = r.u8();
    self.assign = r.boolean();
    return self;
  }
}

/**
 * Use one of the two party leader skills: heal everybody, or call one roster seat over. This is the whole of `HEADER_CG_PARTY_USE_SKILL` (`packet.h:61`, `TPacketCGPartyUseSkill` at `packet.h:1595-1600`), whose handler is one switch on the skill index (`input_main.cpp:2118-2144`).

One message rather than two because the original spends one opcode here and the two arms share their whole precondition: the sender must lead the party (`input_main.cpp:2124-2128`), and nothing else on the wire decides anything. The client-to-server opcode space 0x01-0x7f is also full: all 127 numbers are allocated and every one of them is dispatched, so a second number for this arm would have to come from widening the space, for an arm the original itself does not spend one on.

`skill` is `PARTY_SKILL_HEAL = 1` / `PARTY_SKILL_WARP = 2` (`packet.h:1590-1593`); anything else is ignored, which is what the original's `switch` with no `default` does.

`slot` and `roster_revision` replace the original's target VID and are read only by the warp arm (heal sends VID 0, `uiparty.py:524`). They cannot name somebody the sender has not been shown in their party, and a membership change refuses the old row before it can retarget. The host resolves the member and owns leader authority, Leadership, the death grace window, the map, the landing point, the heal cooldown and how much is restored. In particular the browser cannot send an entity id, coordinate, map, power, cost, cooldown or heal amount.
 */
export class PartyUseSkill {
  static readonly OPCODE = 0x70;
  skill: number = 0;
  roster_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x70);
    w.u8(this.skill);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): PartyUseSkill {
    const self = new PartyUseSkill();
    self.skill = r.u8();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Every slot on this account, resent in full whenever any of it changes.

Whole rather than a delta, for `Bag`'s and `Party`'s reason: it is a handful of rows that change perhaps twice in an account's life, and a delta would buy nothing but a way for the client's picture of its own slots to drift from the server's -- which, since `CreateCharacter` names a slot by index, would be a player filling a slot other than the one they clicked.

**It is also the answer to a successful `CreateCharacter`,** and there is deliberately no separate success message. The same trade `Skills` makes for `SkillUp`: what the player wants to know is not 'did that work' but 'what have I got now', and one frame that always describes the truth cannot disagree with a second frame that describes the change. A *refusal* is a `Notice` carrying one of the `NOTICE_BAD_*` codes and no `Characters` follows it, because nothing moved.

Sent to one client and never broadcast. An account's roster is the list of names one person plays under, and the original leaks it to nobody either.

`capacity` rather than a constant on both sides. A client that hardcoded four would draw four boxes against a server that accepted one, and every click on the last three would come back `NOTICE_NO_SUCH_SLOT`. Growing the shard's slot count is then a server change and a migration, not a protocol change.

The empire is shown here because it is a fact of the shard and the creation screen may display it; it is intentionally not echoed back in `CreateCharacter`. The host owns the kingdom and chooses the spawn table. So does the `classes` array, which is the same argument once more: every value a `CreateCharacter` may carry comes from a frame the server sent, so a client cannot compose a request out of constants of its own.
 */
export class Characters {
  static readonly OPCODE = 0x97;
  capacity: number = 0;
  empire: number = 0;
  may_create: boolean = false;
  may_resume: boolean = false;
  slots: CharacterSlot[] = [];
  classes: ClassOffer[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x97);
    w.u8(this.capacity);
    w.u8(this.empire);
    w.boolean(this.may_create);
    w.boolean(this.may_resume);
    w.varint(this.slots.length);
    for (const item of this.slots)
      item.encode(w);
    w.varint(this.classes.length);
    for (const item of this.classes)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Characters {
    const self = new Characters();
    self.capacity = r.u8();
    self.empire = r.u8();
    self.may_create = r.boolean();
    self.may_resume = r.boolean();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.slots.push(CharacterSlot.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.classes.push(ClassOffer.decode(r));
    }
    return self;
  }
}

/**
 * The account has authenticated but has no persisted empire yet.

The server sends this before `Characters`; the client may choose only a listed kingdom and then sends `SelectEmpire`. The mask is presentation, not authority: the server still validates the byte against the account row and refuses a forged or replayed choice. This is the browser equivalent of the legacy `SetSelectPhase` branch (`PythonNetworkStreamPhaseSelect.cpp:8-35`) and its `SendSelectEmpirePacket` (`:118-131`), whose original opcode is `HEADER_CG_EMPIRE = 90` (`Packet.h:118`).
 */
export class EmpireSelectPrompt {
  static readonly OPCODE = 0x80;
  available_mask: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x80);
    w.u8(this.available_mask);
    return w.bytes();
  }

  static decode(r: Reader): EmpireSelectPrompt {
    const self = new EmpireSelectPrompt();
    self.available_mask = r.u8();
    return self;
  }
}

/**
 * The recipient's own level and experience. Sent to one client, never broadcast: it is the one fact about a character that is theirs alone. Putting it in the entity delta would hand every player in view a live readout of everyone else's progress, which is both a leak and the input a bot needs to pick its targets.
 */
export class Standing {
  static readonly OPCODE = 0x87;
  level: number = 0;
  exp: number = 0;
  exp_to_next: number = 0;
  max_hp: number = 0;
  gained: number = 0;
  attack_min: number = 0;
  attack_max: number = 0;
  defence: number = 0;
  stat_str: number = 0;
  stat_dex: number = 0;
  stat_int: number = 0;
  stat_con: number = 0;
  stat_points: number = 0;
  attack_speed: number = 0;
  move_speed: number = 0;
  energy: number = 0;
  max_energy: number = 0;
  stat_reset_count: number = 0;
  casting_speed: number = 0;
  magic_attack_min: number = 0;
  magic_attack_max: number = 0;
  magic_defence: number = 0;
  evade_rate: number = 0;
  weapon_min: number = 0;
  weapon_max: number = 0;
  weapon_magic_min: number = 0;
  weapon_magic_max: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x87);
    w.varint(this.level);
    w.varint(this.exp);
    w.varint(this.exp_to_next);
    w.varint(this.max_hp);
    w.varint(this.gained);
    w.varint(this.attack_min);
    w.varint(this.attack_max);
    w.varint(this.defence);
    w.varint(this.stat_str);
    w.varint(this.stat_dex);
    w.varint(this.stat_int);
    w.varint(this.stat_con);
    w.varint(this.stat_points);
    w.varint(this.attack_speed);
    w.varint(this.move_speed);
    w.varint(this.energy);
    w.varint(this.max_energy);
    w.varint(this.stat_reset_count);
    w.varint(this.casting_speed);
    w.varint(this.magic_attack_min);
    w.varint(this.magic_attack_max);
    w.varint(this.magic_defence);
    w.varint(this.evade_rate);
    w.varint(this.weapon_min);
    w.varint(this.weapon_max);
    w.varint(this.weapon_magic_min);
    w.varint(this.weapon_magic_max);
    return w.bytes();
  }

  static decode(r: Reader): Standing {
    const self = new Standing();
    self.level = r.varint();
    self.exp = r.varint();
    self.exp_to_next = r.varint();
    self.max_hp = r.varint();
    self.gained = r.varint();
    self.attack_min = r.varint();
    self.attack_max = r.varint();
    self.defence = r.varint();
    self.stat_str = r.varint();
    self.stat_dex = r.varint();
    self.stat_int = r.varint();
    self.stat_con = r.varint();
    self.stat_points = r.varint();
    self.attack_speed = r.varint();
    self.move_speed = r.varint();
    self.energy = r.varint();
    self.max_energy = r.varint();
    self.stat_reset_count = r.varint();
    self.casting_speed = r.varint();
    self.magic_attack_min = r.varint();
    self.magic_attack_max = r.varint();
    self.magic_defence = r.varint();
    self.evade_rate = r.varint();
    self.weapon_min = r.varint();
    self.weapon_max = r.varint();
    self.weapon_magic_min = r.varint();
    self.weapon_magic_max = r.varint();
    return self;
  }
}

/**
 * One whisper, delivered (`TPacketGCWhisper`, `packet.h:970-976`).

Its own message rather than a `ChatEcho` carrying `CHAT_WHISPER`, and the field it lacks is the argument for that: there is no `entity_id` here at all. Every other channel is heard either by people already inside the speaker's interest radius or by people holding a roster that names them; a whisper is the one that crosses the map to somebody who holds neither. An entity id on it would be a handle for a player the server has deliberately not mentioned, and a handful of whispers would locate a stranger by which ones came back with an id the client can see. The quietest channel in the game is the last place to reopen that.

So the sender travels as a name, which is what the original sends too (`szNameFrom`, `input_main.cpp:485`). Nothing here says where they are, what map they are on, or what guild or rank they hold.

Not sent back to the sender. The original delivers to `pkDesc` alone (`:479-495`) and lets the sender's own client write the outgoing line into its whisper window; this build does the same. An echo would be a second copy of a line the sender already has, and the one thing it could add -- that it arrived -- is already said by the absence of a refusal.
 */
export class Whispered {
  static readonly OPCODE = 0x98;
  from_name: string = "";
  text: string = "";
  refusal: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x98);
    w.string(this.from_name);
    w.string(this.text);
    w.boolean(this.refusal);
    return w.bytes();
  }

  static decode(r: Reader): Whispered {
    const self = new Whispered();
    self.from_name = r.string();
    self.text = r.string();
    self.refusal = r.boolean();
    return self;
  }
}

/**
 * One entry of the viewer's guild-name table: an id and the name to draw for it.

Sent when a member of a guild this client has not been told about first comes into view, and once per guild for as long as the session lasts. That is the original's own rule and its own place: `CHARACTER::EncodeInsertPacket` calls `ch->SendGuildName(GetGuild())` on the viewer *before* it writes the packet that introduces the body (`char.cpp:799-802`, under the comment that calls it the guild-name bug fix), and `SendGuildName` returns early for a guild already in the recipient's `m_known_guild` set (`char.cpp:6806-6827`). On the wire there it is `GUILD_SUBHEADER_GC_GUILD_NAME` on `HEADER_GC_GUILD` (`packet.h:1664`), read back into `CPythonGuild`'s name map (`PythonNetworkStreamPhaseGame.cpp:3582-3610`).

**A table rather than a field on `EntityDelta`.** The name is per *guild*, not per character: five guildmates in one square are one name, and a member who walks out of view and back is no name at all. `EntityDelta.guild_id` is the per-character half and this is the lookup, which is exactly how the client reads it -- `RegisterCharacterTextTail` resolves the tail's `dwGuildID` through `CPythonGuild::GetGuildName` and draws `"Noname"` when the map has no row (`UserInterface/PythonTextTail.cpp:551-554`).

It names a guild and nothing else. No roster, no level, no gold, no member count: those are on `Guild`, which goes only to members. A name a player can already read over somebody's head is not a secret, and nothing else about a guild you are not in is on this wire.
 */
export class GuildName {
  static readonly OPCODE = 0xA7;
  guild_id: number = 0;
  name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA7);
    w.varint(this.guild_id);
    w.string(this.name);
    return w.bytes();
  }

  static decode(r: Reader): GuildName {
    const self = new GuildName();
    self.guild_id = r.varint();
    self.name = r.string();
    return self;
  }
}

/**
 * The whole guild, resent to one member whenever any of it changes.

Whole rather than a delta, for `Bag`'s and `Party`'s reason: it is thirty-two rows at most and changes a handful of times a day, and a delta would buy nothing but a way for one member's picture of the roster to drift from the server's.

Per recipient rather than one frame shared by everybody, which is where this parts company with `Party`. A party looks the same from every seat; a guild does not. `your_grade` is what the reader may do -- whether Leave or Disband is the honest button, whether the invite field should be offered at all -- and it is the server's answer rather than something the client works out by finding its own name in the roster. A client that matched on its own name would be one impersonation away from a crown.

`may_expel` is the other per-recipient authority answer. The original checks the stored `GUILD_AUTH_REMOVE_MEMBER` bit in both its online and offline removal paths (`input_main.cpp:2292, 2303`); publishing the answer lets the panel show the honest control without putting a permission on `GuildExpel`.

A `guild_id` of zero means **no guild** -- never joined, left, or disbanded -- and every member of a guild that ends gets one, computed from the roster *before* the change so the people who were in it are still there to be told. `guild.Departure.told` is that list, and `CGuild::Disband` walks the online set before clearing it for exactly this reason (`guild.cpp:976-987`).

`max_members` is sent rather than derived because it is not the count of anything the client holds: `BASE_MAX_MEMBERS` plus two a level plus a clamped bonus (`guild.cpp:1760-1768`), and a client that added it up itself would be right until the guild levelled.

What is *not* on it, and is not an oversight: no account ids and no entity ids. The roster is the only thing in this protocol that names players who are not logged in, and naming them by the persistent identity that keys everything they own would put that key on every guildmate's wire for the sake of a label. Which is also why `GuildPromote` and `GuildHandOver` name a **row of this frame's `members` array** rather than a player: an index is a complete handle for somebody the sender can already see, and it costs nobody an identity.

`gold` **is** on it, and goes to every member rather than only to the master who may withdraw it. That is the original's own choice: `RecvMoneyChange` walks `m_memberOnline` and sends the new balance to all of them (`guild.cpp:1836-1850`), and `SendGuildInfoPacket` puts it on the info packet every member gets (`:894`). It is the right one -- any member may deposit, and a bank you may pay into whose balance you may not read is a bank nobody audits.

`exp`, `next_exp` and `your_offered` are the contribution table seen from one seat. The first two are the guild's progress towards its next level (`guild.cpp:889`; `guild_exp_table` at `constants.cpp:441-464` is what the step costs); the third is this reader's own cumulative offering (`guild.cpp:936`) and is theirs alone. Other members' contributions are deliberately not published here: a per-member figure on every roster frame is a leaderboard the original does not have and would be read as one.

`grades` is the guild's whole rank table, all fifteen rows, in grade order. Whole for the roster's reason -- fifteen short strings that change a handful of times in a guild's life -- and to every member rather than to the master who may edit it, because `GuildMember.grade_name` already puts one row of it on every screen and the rest is not a secret.
 */
export class Guild {
  static readonly OPCODE = 0x99;
  guild_id: number = 0;
  name: string = "";
  level: number = 0;
  max_members: number = 0;
  your_grade: number = 0;
  your_slot: number = 0;
  roster_revision: number = 0;
  may_expel: boolean = false;
  may_use_skill: boolean = false;
  gold: number = 0;
  exp: number = 0;
  next_exp: number = 0;
  your_offered: number = 0;
  skill_points: number = 0;
  power: number = 0;
  max_power: number = 0;
  holy_armour_level: number = 0;
  holy_armour_ready: number = 0;
  dragon_eyes_level: number = 0;
  dragon_eyes_ready: number = 0;
  dragon_blood_level: number = 0;
  dragon_blood_ready: number = 0;
  dragon_benediction_level: number = 0;
  dragon_benediction_ready: number = 0;
  acceleration_level: number = 0;
  acceleration_ready: number = 0;
  dragon_rage_level: number = 0;
  dragon_rage_ready: number = 0;
  casting_aid_level: number = 0;
  casting_aid_ready: number = 0;
  members: GuildMember[] = [];
  grades: GuildGrade[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x99);
    w.varint(this.guild_id);
    w.string(this.name);
    w.varint(this.level);
    w.varint(this.max_members);
    w.u8(this.your_grade);
    w.varint(this.your_slot);
    w.varint(this.roster_revision);
    w.boolean(this.may_expel);
    w.boolean(this.may_use_skill);
    w.varint(this.gold);
    w.varint(this.exp);
    w.varint(this.next_exp);
    w.varint(this.your_offered);
    w.varint(this.skill_points);
    w.varint(this.power);
    w.varint(this.max_power);
    w.u8(this.holy_armour_level);
    w.varint(this.holy_armour_ready);
    w.u8(this.dragon_eyes_level);
    w.varint(this.dragon_eyes_ready);
    w.u8(this.dragon_blood_level);
    w.varint(this.dragon_blood_ready);
    w.u8(this.dragon_benediction_level);
    w.varint(this.dragon_benediction_ready);
    w.u8(this.acceleration_level);
    w.varint(this.acceleration_ready);
    w.u8(this.dragon_rage_level);
    w.varint(this.dragon_rage_ready);
    w.u8(this.casting_aid_level);
    w.varint(this.casting_aid_ready);
    w.varint(this.members.length);
    for (const item of this.members)
      item.encode(w);
    w.varint(this.grades.length);
    for (const item of this.grades)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): Guild {
    const self = new Guild();
    self.guild_id = r.varint();
    self.name = r.string();
    self.level = r.varint();
    self.max_members = r.varint();
    self.your_grade = r.u8();
    self.your_slot = r.varint();
    self.roster_revision = r.varint();
    self.may_expel = r.boolean();
    self.may_use_skill = r.boolean();
    self.gold = r.varint();
    self.exp = r.varint();
    self.next_exp = r.varint();
    self.your_offered = r.varint();
    self.skill_points = r.varint();
    self.power = r.varint();
    self.max_power = r.varint();
    self.holy_armour_level = r.u8();
    self.holy_armour_ready = r.varint();
    self.dragon_eyes_level = r.u8();
    self.dragon_eyes_ready = r.varint();
    self.dragon_blood_level = r.u8();
    self.dragon_blood_ready = r.varint();
    self.dragon_benediction_level = r.u8();
    self.dragon_benediction_ready = r.varint();
    self.acceleration_level = r.u8();
    self.acceleration_ready = r.varint();
    self.dragon_rage_level = r.u8();
    self.dragon_rage_ready = r.varint();
    self.casting_aid_level = r.u8();
    self.casting_aid_ready = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.members.push(GuildMember.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.grades.push(GuildGrade.decode(r));
    }
    return self;
  }
}

/**
 * The server-owned plot and persistent buildings for this member's guild.

Sent with the guild roster and again after a purchase, placement, or upgrade, so a reconnect or a late-arriving frame cannot leave the land panel drawing a client-invented object. `land_id` is zero when the guild owns no plot and clears the previous view on leave or disband. The object rows come from `GuildLand.objects`, after the same owner/prototype/footprint checks used by materialization (`server/guild_land.py`; legacy `building.cpp:816-884`). `map_index` is sent because the durable object row stores it and the loader filters objects by it (`guild_land.py`; legacy `building.cpp:816-849`). This frame is a response only: no field here is accepted as an argument by a client-to-server message.
 */
export class GuildLandState {
  static readonly OPCODE = 0xFA;
  revision: number = 0;
  land_id: number = 0;
  map_index: number = 0;
  objects: GuildBuilding[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xFA);
    w.varint(this.revision);
    w.varint(this.land_id);
    w.varint(this.map_index);
    w.varint(this.objects.length);
    for (const item of this.objects)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): GuildLandState {
    const self = new GuildLandState();
    self.revision = r.varint();
    self.land_id = r.varint();
    self.map_index = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.objects.push(GuildBuilding.decode(r));
    }
    return self;
  }
}

/**
 * Every guild plot on the map the character has just entered, with its owner (`CManager::SendLandList`, `building.cpp:945-995`, sent on entering the game at `input_login.cpp:580`). Each owning guild's name is sent first when this client has not met it (`building.cpp:963-969`). Not sent when the map has no plot (`building.cpp:985`). A response only.
 */
export class LandList {
  static readonly OPCODE = 0xFB;
  lands: LandPlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xFB);
    w.varint(this.lands.length);
    for (const item of this.lands)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): LandList {
    const self = new LandList();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.lands.push(LandPlot.decode(r));
    }
    return self;
  }
}

/**
 * Somebody has asked this player into their guild.

Sent to the invitee only, once, and answered with the `token` it carries -- not with the guild id the original answers with. See `GuildAnswer` for why that difference is the whole message.

A `token` of zero means **the invitation is gone** -- answered, declined, expired, or its inviter logged out -- and is what takes the prompt off the screen, the same convention `PartyInvitation` uses.

`guild_name` is here and `inviter_name` beside it because they answer different questions and a prompt that carried only one of them is a prompt somebody would answer wrongly: a player is agreeing to join *a guild*, and the person asking is merely whoever holds `Auth.ADD_MEMBER` in it. There is no guild id on this message -- nothing may be aimed at a guild by number -- and no member count, because a roster the invitee has not joined is not theirs to read.

`seconds` is how long the invitation stands, sent rather than hardcoded so a countdown says what the server will actually enforce. `guild.INVITE_TIMEOUT_SECONDS` is ten, and the timeout is a decline rather than an error (`guild.cpp:1892-1911` calls `InviteDeny`).
 */
export class GuildInvitation {
  static readonly OPCODE = 0x9A;
  token: number = 0;
  guild_name: string = "";
  inviter_name: string = "";
  seconds: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x9A);
    w.varint(this.token);
    w.string(this.guild_name);
    w.string(this.inviter_name);
    w.u8(this.seconds);
    return w.bytes();
  }

  static decode(r: Reader): GuildInvitation {
    const self = new GuildInvitation();
    self.token = r.varint();
    self.guild_name = r.string();
    self.inviter_name = r.string();
    self.seconds = r.u8();
    return self;
  }
}

/**
 * Open the existing guild-name form for this connection only.

This is the blank `HEADER_GC_REQUEST_MAKE_GUILD` emitted by `game_request_make_guild` (`questlua_game.cpp:37-47`), whose client handler calls `AskGuildName` (`PythonNetworkStreamPhaseGame.cpp:1991-2002`).  It is an event, not a guild mutation: there is deliberately no name, guild id, founder, level, gold, position, or NPC in it.  The form's later `GuildCreate` message carries only the human-chosen name and the server resolves its sender's live character, progress, bag, and membership before it can found anything.
 */
export class GuildFoundingPrompt {
  static readonly OPCODE = 0xF9;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xF9);
    return w.bytes();
  }

  static decode(_r: Reader): GuildFoundingPrompt {
    const self = new GuildFoundingPrompt();
    return self;
  }
}

/**
 * The server's complete current set of guild-war choices for this member.  Empty means there is no declaration or acceptance the member may make now.  Only a master receives actionable rows; the presentation is still sent to every member so everyone sees the same war situation without learning ids, rules, or scores.
 */
export class GuildWarMenu {
  static readonly OPCODE = 0xF4;
  choices: GuildWarChoice[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xF4);
    w.varint(this.choices.length);
    for (const item of this.choices)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): GuildWarMenu {
    const self = new GuildWarMenu();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.choices.push(GuildWarChoice.decode(r));
    }
    return self;
  }
}

/**
 * The active guild-war presentation.  This is a display frame, not a request: the server owns the mode, objective, arena map, and scores.  `active=false` clears a prior board.

`opponent_guild_id` is here so the score board can draw the other side's mark. `GuildWarScoreBoard.Open` stands a `ui.MarkBox` beside each name (`uiguild.py:407-429`) and a `MarkBox` is an index into the shared mark atlas, which this build does not have; what it has is `RequestEmblem`, which answers for any guild id. Publishing the id is what lets the board ask -- there is no other message that would tell a member who they are fighting by number, and a name is not something an emblem can be looked up by.

The two head counts are `WarUC`'s own pair (`war_map.cpp:312-338`), which `__GuildWar_UpdateMemberCount` hands to `GuildWarScoreBoard.UpdateMemberCount` (`game.py:1797-1805`; `uiguild.py:459-467`). They are `GetAccumulatedJoinerCount` -- how many distinct players have entered the arena for that side, never decremented when one leaves (`war_map.cpp:288-308`) -- and not a live population, which is what makes them safe to publish: they say how big the fight has been, not who is standing where. Negative one is the original's own "not reported" value, the state `__RefreshName` draws the shorter line for (`uiguild.py:469-478`), and is what a field war sends because a field war has no arena to enter.
 */
export class GuildWarArena {
  static readonly OPCODE = 0xF5;
  active: boolean = false;
  opponent: string = "";
  mode: string = "";
  objective: string = "";
  your_score: number = 0;
  opponent_score: number = 0;
  opponent_guild_id: number = 0;
  your_members: number = 0;
  opponent_members: number = 0;
  observer_count: number = 0;
  your_guild_id: number = 0;
  your_guild: string = "";
  enemies: GuildWarEnemy[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xF5);
    w.boolean(this.active);
    w.string(this.opponent);
    w.string(this.mode);
    w.string(this.objective);
    w.varint(this.your_score);
    w.varint(this.opponent_score);
    w.varint(this.opponent_guild_id);
    w.svarint(this.your_members);
    w.svarint(this.opponent_members);
    w.varint(this.observer_count);
    w.varint(this.your_guild_id);
    w.string(this.your_guild);
    w.varint(this.enemies.length);
    for (const item of this.enemies)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): GuildWarArena {
    const self = new GuildWarArena();
    self.active = r.boolean();
    self.opponent = r.string();
    self.mode = r.string();
    self.objective = r.string();
    self.your_score = r.varint();
    self.opponent_score = r.varint();
    self.opponent_guild_id = r.varint();
    self.your_members = r.svarint();
    self.opponent_members = r.svarint();
    self.observer_count = r.varint();
    self.your_guild_id = r.varint();
    self.your_guild = r.string();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.enemies.push(GuildWarEnemy.decode(r));
    }
    return self;
  }
}

/**
 * The twelve newest durable guild-board rows, refreshed after a post (`CGuild::RefreshCommentForce`, `guild.cpp:1048-1086`). Announcement rows sort before ordinary rows. `board_revision` binds a row-addressed deletion request to exactly this list; ids, names and text remain server-authored display data.
 */
export class GuildComments {
  static readonly OPCODE = 0xFC;
  board_revision: number = 0;
  comments: GuildComment[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xFC);
    w.varint(this.board_revision);
    w.varint(this.comments.length);
    for (const item of this.comments)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): GuildComments {
    const self = new GuildComments();
    self.board_revision = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.comments.push(GuildComment.decode(r));
    }
    return self;
  }
}

/**
 * Play one of the twenty-one shipped gestures, at nobody or at somebody.

Two fields, and what is *not* here is the message. There is no position, no facing, no sex, no riding flag and above all no consent bit. Every one of those is a fact about the two characters that the server already holds, and each is a check `do_emotion` performs (`cmd_emotion.cpp:129-235`): riding, distance, sex, and whether the target has allowed this actor. A message that carried any of them would be a message that could lie about it -- and the one worth being blunt about is consent, because a `kiss` is an animation played *on another player's character*. A client that could assert `consented=true` could kiss anybody on the map. There is no field here to set.

`target_id` names an entity, not a position: the client cannot claim to be standing next to somebody. The server reads both characters out of the world and measures the distance itself, so the range gate (`:193-203`) is arithmetic over server state with no client input in it at all. An id naming nobody, or naming somebody out of interest range, is simply not found.

`emote` indexes a fixed twenty-one row catalogue (`emotion_types[]`, `:26-49`). It is not a command string and not an animation name: an unknown value names no row and plays nothing, so the set of gestures a client can cause is the set the server compiled.

Zero `target_id` means untargeted, the same nobody-here convention `UseSkill` uses. The three partnered gestures refuse it (`NEED_PC`, `:171-178`); the other eighteen ignore it.
 */
export class Emote {
  static readonly OPCODE = 0x33;
  emote: number = 0;
  target_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x33);
    w.u8(this.emote);
    w.varint(this.target_id);
    return w.bytes();
  }

  static decode(r: Reader): Emote {
    const self = new Emote();
    self.emote = r.u8();
    self.target_id = r.varint();
    return self;
  }
}

/**
 * Allow, or refuse, one named request to be kissed or slapped.

`token` names *the request*, not the person who made it, and that is the whole of the message's safety. It is `PartyAnswer`'s rule with a more personal stake: two players ask the same target within a second of each other, the second prompt replaces the first while a finger is already moving, and a yes resolved against "whatever request the server is holding for this player" would grant standing consent to somebody whose name was never read. `Emotes.answer` fails the lookup instead -- a token that was never issued, was issued to somebody else, or has already been spent is `NO_SUCH_REQUEST`, and a guessed number grants nothing.

There is no actor id on this message for the same reason: naming who is being allowed would let a client allow somebody who never asked. The token already names both sides, and the server reads the actor off it.

Accepting records the standing grant `do_emotion_allow` records (`cmd_emotion.cpp:91-107`) and nothing else -- it does not play the gesture. The actor has to send `Emote` again, exactly as the original requires, because granting was never what plays an animation. If that server-owned actor has entered an arena duel since asking, the server instead consumes this prompt and refuses the grant; no extra client field or answer kind can influence it.
 */
export class EmoteAnswer {
  static readonly OPCODE = 0x34;
  token: number = 0;
  accept: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x34);
    w.varint(this.token);
    w.boolean(this.accept);
    return w.bytes();
  }

  static decode(r: Reader): EmoteAnswer {
    const self = new EmoteAnswer();
    self.token = r.varint();
    self.accept = r.boolean();
    return self;
  }
}

/**
 * Somebody nearby made a gesture. Sent to everyone who can see the actor, the actor included.

Broadcast rather than answered, because an emote is a thing bystanders are supposed to see -- `do_emotion` builds one packet and sends it to the actor's view (`cmd_emotion.cpp:241-260`). The reach here is the interest radius rather than the original's whole map, for `on_chat`'s reason: this frame names entities, and a map-wide one would leak who is on it.

Ids, not names. The client already has a name for every entity it can see, from the snapshot that made it visible, so a name here would be a second and possibly disagreeing copy of it -- and an id the receiver cannot see resolves to nothing, which is the correct outcome for a gesture aimed at somebody they cannot see either.

`target` is zero for an untargeted gesture.
 */
export class EmotePlayed {
  static readonly OPCODE = 0x9B;
  actor: number = 0;
  emote: number = 0;
  target: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x9B);
    w.varint(this.actor);
    w.u8(this.emote);
    w.varint(this.target);
    return w.bytes();
  }

  static decode(r: Reader): EmotePlayed {
    const self = new EmotePlayed();
    self.actor = r.varint();
    self.emote = r.u8();
    self.target = r.varint();
    return self;
  }
}

/**
 * Somebody wants to kiss, french-kiss or slap this player, and is asking first.

The original has no such frame: an attempt without standing permission is refused with a chat line **only the actor sees** (`cmd_emotion.cpp:226-232`), and the target is expected to have already pressed Allow Emotion in their Target window (`uitarget.py:116,364-365`) for a person they have no reason yet to think wants anything. `server/emotes.py`'s docstring records why that gap is not worth keeping. This frame is the ask, minted by the refusal.

A `token` of zero means **the request is gone** -- answered, or its actor logged out -- and is what takes the prompt off the screen, the same convention `PartyInvitation` and `GuildInvitation` use.

`actor_name` is carried, unlike `EmotePlayed`'s bare ids, because a prompt has to say who is asking even when the asker has since walked out of view, and a prompt reading "entity 4127 wants to kiss you" is a prompt answered at random.

`emote` is on it for the same reason: agreeing to be slapped and agreeing to be kissed are different agreements. Consent is recorded per pair rather than per gesture -- `s_emotion_set` holds VID pairs, not emote ids (`:89`) -- so this says what was asked for, and the player answering can see it.
 */
export class EmoteRequest {
  static readonly OPCODE = 0x9C;
  token: number = 0;
  actor: number = 0;
  actor_name: string = "";
  emote: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x9C);
    w.varint(this.token);
    w.varint(this.actor);
    w.string(this.actor_name);
    w.u8(this.emote);
    return w.bytes();
  }

  static decode(r: Reader): EmoteRequest {
    const self = new EmoteRequest();
    self.token = r.varint();
    self.actor = r.varint();
    self.actor_name = r.string();
    self.emote = r.u8();
    return self;
  }
}

/**
 * This player's own horse, whole, whenever any of it changes.

Sent to the rider and nobody else, like `Standing` and for the same reason: a horse's health and stamina are the rider's business and a broadcast would hand every client on the map a stat block belonging to somebody else. What *other* players need in order to draw a mounted character is not on this frame at all -- see the note at the bottom.

Whole rather than patched, for the `Party` roster's reason: a client that merged fields into a horse of its own would be drawing a horse the server does not have. A `level` of zero means there is no horse, the same way `Party.leader_id` of zero means there is no party.

**`walk_mm_s` and `run_mm_s` are the load-bearing fields.** They are how fast this character now moves, and they are sent rather than derived because the client can derive neither: the mounted speeds come from `c_aHorseStat` scaled through `CalculateDuration` (`utils.cpp:119-131`), and shipping that table and that formula to the client to move a horse would be shipping balance data to save two integers. `Standing.move_speed` already records what happens when the client is not told -- "a per-character value it was not told is a permanent misprediction" -- and a mounted player is exactly that case arriving: the predictor must step at the horse's speed or every stride is corrected. They are sent on dismount too, carrying the character's own speeds back, because a client that kept the horse's would run on foot at 7.4 m/s until it next mounted.

**What is not here, and what it costs.** Nothing tells *other* clients that this character is mounted, so a rider is drawn to everybody else as somebody sprinting on foot. That needs a field on `EntityDelta` -- one `mount` vnum, 0 for none, sent on change the way `weapon` is -- which is `server/snapshot.py`'s to fill in. The wire carries the rider's own half; the onlooker's half is a one-field change away and is deliberately not faked here, because a second, disagreeing source for "is that person on a horse" is worse than not answering.
 */
export class Mount {
  static readonly OPCODE = 0x9D;
  level: number = 0;
  riding: boolean = false;
  health: number = 0;
  max_health: number = 0;
  stamina: number = 0;
  max_stamina: number = 0;
  walk_mm_s: number = 0;
  run_mm_s: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x9D);
    w.u8(this.level);
    w.boolean(this.riding);
    w.varint(this.health);
    w.varint(this.max_health);
    w.varint(this.stamina);
    w.varint(this.max_stamina);
    w.varint(this.walk_mm_s);
    w.varint(this.run_mm_s);
    return w.bytes();
  }

  static decode(r: Reader): Mount {
    const self = new Mount();
    self.level = r.u8();
    self.riding = r.boolean();
    self.health = r.varint();
    self.max_health = r.varint();
    self.stamina = r.varint();
    self.max_stamina = r.varint();
    self.walk_mm_s = r.varint();
    self.run_mm_s = r.varint();
    return self;
  }
}

/**
 * Sent to the player who just toggled `/set_walk_mode`/`/set_run_mode` (`cmd_general.cpp:1004-1015`), echoing `Session.walking` back once the server has actually written it (`loop.py::_cmd_set_walk_mode`) -- the original's `TPacketGCWalkMode` (`packet.h:1871-1883`), read on the client by `RecvWalkModePacket` into `InstanceBase::SetWalkMode`.

Every tick's `EntityDelta.gait` already tells a *watcher* how fast someone else is covering ground -- that alone is enough for an onlooker, who never predicts another body's future ticks. The walker's own client is different: it predicts its own next few ticks locally, ahead of any server round trip, from whatever gait its own keys currently ask for. `Gait` only ever says what one tick did; it cannot tell the predictor to keep asking for `WALK` on every future tick even while the run key is held, so without this frame the walker's own body would re-predict `RUN` the instant it moved again and correct itself back down every single tick -- a rubber-band too small to call a teleport and too constant to call settled. This is the one persistent bit `Gait`'s per-tick snapshot cannot carry, and the client acts on it by capping the gait it *asks for*, in `predictor.pushInput`'s caller, the same place `sim/movement.step` documents 'speed comes from stats, never from the wire' -- this frame does not add a second speed to disbelieve, only the preference already sent as plain text.
 */
export class WalkMode {
  static readonly OPCODE = 0xA4;
  walking: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA4);
    w.boolean(this.walking);
    return w.bytes();
  }

  static decode(r: Reader): WalkMode {
    const self = new WalkMode();
    self.walking = r.boolean();
    return self;
  }
}

/**
 * The recipient's own running stamina, `POINT_STAMINA` under `POINT_MAX_STAMINA`, and the rate its gauge falls at while the server charges a fighting run.

One frame for what the original says three ways: the pair on `PointsPacket` (`char.cpp:1533-1534`), a `POINT_STAMINA` point change whenever the pool rises or reaches zero (`char.cpp:3127-3149`), and the `StartStaminaConsume` / `StopStaminaConsume` commands (`char.cpp:5631-5651`) the client turns into a gauge it drains on its own clock (`PythonPlayer.cpp:169-175`, `:1518-1534`). Decreases are never sent; the client counts them down from the rate. Sent to one client, never broadcast.
 */
export class Stamina {
  static readonly OPCODE = 0xF8;
  stamina: number = 0;
  max_stamina: number = 0;
  consume_per_sec: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xF8);
    w.varint(this.stamina);
    w.varint(this.max_stamina);
    w.varint(this.consume_per_sec);
    return w.bytes();
  }

  static decode(r: Reader): Stamina {
    const self = new Stamina();
    self.stamina = r.varint();
    self.max_stamina = r.varint();
    self.consume_per_sec = r.varint();
    return self;
  }
}

/**
 * Cast a line, or pull one in. **One message for both**, which is the original's own shape and the whole of what makes the minigame honest.

`CHARACTER::fishing` (`char.cpp:3834-3838`) opens with `if (m_pkFishingEvent) { fishing_take(); return; }` -- the same packet casts when nothing is out and pulls when something is, and `TPacketCGFishing` carries one field, a facing. There is no pull opcode to send early.

**There is no reaction time on this message, and that is the point.** Landing a fish is a roll against `aFishingTime` (`fishing.cpp:72-79`), a curve over 200 ms buckets that is zero for the first second, peaks at 80% around three seconds, and falls back to zero by six. A message carrying `elapsed_ms` would be a message a client sets to 3000 on every cast, and every fish the difficulty roll allowed would be landed. The server writes down the tick the fish bit and measures the interval to this message arriving; the client cannot name it, only cause it.

Nor is there a species, a length, a rod or a level. Which fish bit is rolled server-side *before the player is told anything bit* (`DetermineFish`, `fishing.cpp:359`, called from the bite event), so there is nothing yet for a client to have an opinion about; the rod and the level it gives are read out of the bag this server holds.

`heading` is the facing, the same 4096-step encoding `Input` uses. The original takes a coarser one (`p->dir * 5`, 72 steps, `input_main.cpp:2532`) and does exactly one thing with it -- turns the character -- which is all this does. It cannot move anybody: a facing is not a position, and where the line may be cast from is decided against the position the server already holds.
 */
export class Fish {
  static readonly OPCODE = 0x37;
  heading: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x37);
    w.bits(this.heading, 12);
    return w.bytes();
  }

  static decode(r: Reader): Fish {
    const self = new Fish();
    self.heading = r.bits(12);
    return self;
  }
}

/**
 * The state of this player's line, whole, whenever it changes.

Sent to the angler and nobody else, like `Mount` and `Standing`: what is on somebody else's hook is not a fact other clients need, and a broadcast would be handing every client on the map a species roll it could read before its owner did.

**`state` is the only thing that says a fish is biting, and it arrives when the fish bites.** That is what starts the player's clock, and it is why the delay before it is not on this frame: `Random::get(10, 40)` seconds (`fishing.cpp:522`) told in advance is a countdown a client can watch instead of a river.

`window_ms` is how long the reaction window lasts, sent rather than hardcoded so a bar drains at the rate the server will actually enforce -- `GuildInvitation.seconds`' reasoning. It does not say where in the window the odds are best; that curve is thirty-one numbers of balance data and is the thing a player learns by fishing.

`level` is what this cast will be judged at, and `practice` and `practice_max` are the progression behind it. All three are the server's arithmetic over the rod it found; a client that recomputed them from a rod vnum would need `ROD_CHAIN`.
 */
export class Fishing {
  static readonly OPCODE = 0x9E;
  state: number = 0;
  rod_vnum: number = 0;
  level: number = 0;
  practice: number = 0;
  practice_max: number = 0;
  window_ms: number = 0;
  fish_vnum: number = 0;
  fish_name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x9E);
    w.u8(this.state);
    w.varint(this.rod_vnum);
    w.varint(this.level);
    w.varint(this.practice);
    w.varint(this.practice_max);
    w.varint(this.window_ms);
    w.varint(this.fish_vnum);
    w.string(this.fish_name);
    return w.bytes();
  }

  static decode(r: Reader): Fishing {
    const self = new Fishing();
    self.state = r.u8();
    self.rod_vnum = r.varint();
    self.level = r.varint();
    self.practice = r.varint();
    self.practice_max = r.varint();
    self.window_ms = r.varint();
    self.fish_vnum = r.varint();
    self.fish_name = r.string();
    return self;
  }
}

/**
 * What came of one pull.

Its own frame rather than fields on `Fishing`, for the reason `RefineResult` is separate from `RefineOffer`: one is a state that stays true and the other is an event with a moment. A caught fish folded into the line's state would be a fish the panel goes on showing until the next cast, and a client with no way to tell a repeat frame from a second catch.

`length` is hundredths of a centimetre, which is the original's own unit -- it stores the number in a socket and the client prints `%.2fcm` (`fishing.cpp:637,640`). It is *not* derivable from the vnum: two carp are different fish, and the tail of the distribution that produces a record one (`GetFishLength`'s 1% arcsine branch, `:573-589`) is exactly the part worth showing.

`name` rides along for `BagSlot.name`'s reason: the alternative is shipping the item table to the client so a caught fish can be named. The vnum is there too, because the name is display text and the number is the identity.
 */
export class FishCaught {
  static readonly OPCODE = 0x9F;
  outcome: number = 0;
  vnum: number = 0;
  name: string = "";
  length: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x9F);
    w.u8(this.outcome);
    w.varint(this.vnum);
    w.string(this.name);
    w.varint(this.length);
    return w.bytes();
  }

  static decode(r: Reader): FishCaught {
    const self = new FishCaught();
    self.outcome = r.u8();
    self.vnum = r.varint();
    self.name = r.string();
    self.length = r.varint();
    return self;
  }
}

/**
 * One step of somebody's fishing act, sent to everyone who can see the angler, the angler included: the original's `TPacketGCFishing` with the five subheaders it sends by `PacketAround` (`fishing.cpp:398-423,524-529,688-693`), which `RecvFishing` turns into the matching motion on whichever body `info` names (`PythonNetworkStreamPhaseGame.cpp:3722-3759`).

Only the body's part rides here. The rod, the level and what is on the hook stay on `Fishing`, for the angler alone; the sixth subheader, `FISHING_SUBHEADER_GC_FISH`, is the one the original sends with `GetDesc()->Packet` (`fishing.cpp:496-498,630-632`), and it is that frame's `fish_vnum`.
 */
export class FishingAct {
  static readonly OPCODE = 0xFE;
  entity_id: number = 0;
  act: number = 0;
  heading: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xFE);
    w.varint(this.entity_id);
    w.u8(this.act);
    w.bits(this.heading, 12);
    return w.bytes();
  }

  static decode(r: Reader): FishingAct {
    const self = new FishingAct();
    self.entity_id = r.varint();
    self.act = r.u8();
    self.heading = r.bits(12);
    return self;
  }
}

/**
 * Restart in town. **No fields at all**, which is the whole message.

That is the original's own shape twice over. `TPacketCGWarp` is `struct command_warp { BYTE bHeader; }` -- one header byte and nothing after it (`packet.h:1400-1403`) -- and the town-return command behind `/restart_town` takes no arguments either (`cmd.cpp:333`, `do_restart` with `SCMD_RESTART_TOWN`).

**A destination cannot be cheated because a destination cannot be written.** Every one of the six places the original picks a recall point calls `GetRecallPositionByEmpire(ch->GetMapIndex(), ch->GetEmpire(), pos)` (`char_battle.cpp:451`, `char_item.cpp:4198` and `:5074`, `char_skill.cpp:1543`, `cmd_general.cpp:626`, `input_login.cpp:533`), and *both* arguments are read off the character: the map it is standing on and the kingdom it belongs to. Neither has ever come off the packet. `MoveItem` names two cells and no vnum, `Emote` names a gesture and no consent bit, `Fish` names a facing and no reaction time; this names nothing, because there is nothing about a recall a client is entitled to an opinion about. A field carrying `x_mm`/`y_mm` would be a teleport-anywhere command with a polite name, and a field carrying `map_id` would be that plus a way to ask a shard for ground it is not serving.

**Legal only while down.** `do_restart` opens with `if (false == ch->IsDead())` and returns without warping (`cmd_general.cpp:475-479`) -- the restart window is a dead player's window. A living player sending this gets `NOTICE_NOT_DEAD` and does not move, so this is not a free ride home out of a fight.

It is the *impatient* half of dying: the shard already stands a corpse back up on a timer (`Welcome.respawn_ticks`, the original's `dead_event`, `char_battle.cpp:441-462`), and this says "now, in town" instead of waiting for it. What it does not do is choose *which* town -- see `server/warp.py`.
 */
export class Recall {
  static readonly OPCODE = 0x38;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x38);
    return w.bytes();
  }

  static decode(_r: Reader): Recall {
    const self = new Recall();
    return self;
  }
}

/**
 * Restart where you fell, not in town. No fields, `Recall`'s own shape: `SCMD_RESTART_HERE` takes no arguments either (`cmd.cpp:332`).

**This is the expensive half of the same choice `Recall` offers the cheap half of.** `do_restart`'s `SCMD_RESTART_HERE` branch (`cmd_general.cpp:635-641`) calls `RestartAtSamePos()` -- which re-sends the view without moving the character at all (`char.cpp:752-787`; it is a network resync, not a warp) -- then `PointChange(POINT_HP, 50 - GetHP())` and `DeathPenalty(0)`. `bTown = 0` is the whole difference from `Recall`'s `DeathPenalty(1)`: a town restart zeroes the experience loss (`char_battle.cpp:319-322`) and this does not, so pressing this key instead of the other one is the entire lever a player has over whether dying costs anything.

**Legal only while down**, the same gate `Recall` states: a living player sending this gets `NOTICE_NOT_DEAD` and neither moves nor is charged.
 */
export class RestartHere {
  static readonly OPCODE = 0x7D;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x7D);
    return w.bytes();
  }

  static decode(_r: Reader): RestartHere {
    const self = new RestartHere();
    return self;
  }
}

/**
 * Put something on one of the thirty-six quick slots.

`CInputMain::QuickslotAdd` is one line -- `ch->SetQuickslot(pinfo->pos, pinfo->slot)` (`input_main.cpp:876-880`) -- and every decision is `CHARACTER::SetQuickslot`'s (`char_quickslot.cpp:45-98`), which this build follows exactly:

* `pos` past `QUICKSLOT_MAX_NUM` is refused (`:49`).
* a `type` that is not `ITEM`, `SKILL` or `COMMAND` is refused (`:52`, and again at the `switch`'s `default`, `:82`). Type 0 is therefore *not* a way to clear a slot; `QuickSlotDel` is.
* an `ITEM` whose `target` is neither an ordinary inventory cell nor a belt cell is refused (`:67-71`, `IsDefaultInventoryPosition`/`IsBeltInventoryPosition`).
* a `SKILL` the sender does not have is refused. The original's test is `pos >= SKILL_MAX_NUM` (`:74`) because its slot is an index into a fixed array; this build's skill book is keyed by vnum, so the equivalent test is that the vnum names a skill this character knows of.
* the same `(type, target)` already sitting on another slot is deleted first (`:55-61`), so a potion cell cannot be on two hotkeys at once.

**No client-side table.** The whole point of moving this onto the wire is that the assignment is the character's, not the browser's: it survives a relog, a different machine and a cleared cache, exactly as it does in the original, where it is a column of the player row (`char.cpp:1190`, `input_db.cpp:435`).
 */
export class QuickSlotAdd {
  static readonly OPCODE = 0x7C;
  pos: number = 0;
  type: number = 0;
  target: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x7C);
    w.u8(this.pos);
    w.u8(this.type);
    w.varint(this.target);
    return w.bytes();
  }

  static decode(r: Reader): QuickSlotAdd {
    const self = new QuickSlotAdd();
    self.pos = r.u8();
    self.type = r.u8();
    self.target = r.varint();
    return self;
  }
}

/**
 * Take whatever is on a quick slot off it.

`CInputMain::QuickslotDelete` -> `CHARACTER::DelQuickslot` (`input_main.cpp:882-886`, `char_quickslot.cpp:100-114`), which bounds-checks the position and zeroes the entry. Its own verb rather than an add of type 0 because `SetQuickslot` refuses type 0 (`char_quickslot.cpp:82-83`).
 */
export class QuickSlotDel {
  static readonly OPCODE = 0x7E;
  pos: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x7E);
    w.u8(this.pos);
    return w.bytes();
  }

  static decode(r: Reader): QuickSlotDel {
    const self = new QuickSlotDel();
    self.pos = r.u8();
    return self;
  }
}

/**
 * Exchange two quick slots.

`CInputMain::QuickslotSwap` -> `CHARACTER::SwapQuickslot` (`input_main.cpp:888-892`, `char_quickslot.cpp:116-136`): both positions are bounds-checked and the two entries trade places, including when one of them is empty -- which is how the original's taskbar moves a hotkey to a free cell (`RequestMoveGlobalQuickSlotToLocalQuickSlot`, `PythonPlayer.cpp:758-766`) rather than by an add and a delete that could half-fail.
 */
export class QuickSlotSwap {
  static readonly OPCODE = 0x7F;
  pos: number = 0;
  pos_to: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x7F);
    w.u8(this.pos);
    w.u8(this.pos_to);
    return w.bytes();
  }

  static decode(r: Reader): QuickSlotSwap {
    const self = new QuickSlotSwap();
    self.pos = r.u8();
    self.pos_to = r.u8();
    return self;
  }
}

/**
 * The whole quick-slot table, resent in full on every change and once at login.

The original answers each request with its own echo -- `HEADER_GC_QUICKSLOT_ADD`, `_DEL`, `_SWAP` (`char_quickslot.cpp:90,109,130`) -- and sends the login state as thirty-six separate `SetQuickslot` calls, one packet each (`input_db.cpp:435-436`). This is one frame instead, for the reason `Bag` and `SkillList` already give here: the table is at most thirty-six two-byte entries, it changes a few times an hour, and three separate echoes are three ways for a client's copy to drift from the server's with neither able to tell.

Only occupied slots are listed. An empty slot is the absence of an entry, so a frame that clears the bar is one byte and a client that folded a missing entry into anything but *empty* would be inventing state.

This is also what `SyncQuickslot` (`char_quickslot.cpp:12-34`) reaches the player through: when a potion is sold, dropped, traded away or dragged to another cell, the server re-points or clears the slot and resends the table. Without that the hotkey would quietly come to mean whatever landed in that cell next -- which is exactly what a client-local table cannot avoid.
 */
export class QuickSlots {
  static readonly OPCODE = 0xA6;
  slots: QuickSlotEntry[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA6);
    w.varint(this.slots.length);
    for (const item of this.slots)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): QuickSlots {
    const self = new QuickSlots();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.slots.push(QuickSlotEntry.decode(r));
    }
    return self;
  }
}

/**
 * You are somewhere else now, as of this frame.

The server's half of `CHARACTER::WarpSet` (`char.cpp:5034-5091`), which sends `TPacketGCWarp` -- `{ BYTE header; LONG x; LONG y; LONG addr; WORD port; }` (`packet.h:1391-1398`) -- and is a *reconnect*, not a teleport: the original hands the client the address of whichever game-server process owns the destination (`CMapLocation::Get`, `map_location.cpp:10-15`) and the client opens a new socket to it.

**This build cannot do the reconnect half, so it does not pretend to.** One map is served per process (`app.py:_select_map` says so in as many words), there is no second process to name and no `CMapLocation` to ask, so there is no `addr` and no `port` on this frame. What that costs is stated plainly in `server/warp.py`: crossing a map border on foot (`step_across`) stays unserved. What it does *not* cost is this message, because a recall never crosses a map in the original either -- all six callers of `GetRecallPositionByEmpire` pass `ch->GetMapIndex()`, the map the character is already standing on.

`map_id` is what replaces `addr`/`port`: the destination's identity, spelled exactly as `Welcome.map_id` spells it, so the client compares like with like and can *refuse* a frame naming ground it has not loaded rather than drawing the player onto the wrong terrain. Today the server only ever sends its own -- a destination it cannot serve is refused with a `Notice` instead of sent as a `Warp` nobody can act on -- and the field is here so that the day a second process exists, the answer has somewhere to go and no client is silently already assuming otherwise.

`x_mm`/`y_mm` are **map-local millimetres**, not the world coordinates `WarpSet` sends. The original's whole server shares one atlas and its client is handed a point in it; every artefact this build ships -- terrain, collision, placements, the minimap -- is keyed from `(0, 0)` of one map, so a world point here would misplace the player by exactly that map's `BasePosition`, which for a1 is 4,096 metres. `warp.MapFrame.to_local` is the conversion and `server/warp.py`'s docstring is why.

Its own frame rather than a flag on the snapshot, and that is the point of sending it at all: the client predicts movement, and a position that jumps 600 metres between two snapshots is indistinguishable from lag. This says *do not interpolate* -- cut the camera, drop the pending inputs, start again from here.
 */
export class Warp {
  static readonly OPCODE = 0xA0;
  map_id: string = "";
  x_mm: number = 0;
  y_mm: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA0);
    w.string(this.map_id);
    w.svarint(this.x_mm);
    w.svarint(this.y_mm);
    return w.bytes();
  }

  static decode(r: Reader): Warp {
    const self = new Warp();
    self.map_id = r.string();
    self.x_mm = r.svarint();
    self.y_mm = r.svarint();
    return self;
  }
}

/**
 * You have left this map. Load that one and come back with this token.

The half of `CHARACTER::WarpSet` that `Warp` above deliberately does not carry: the *reconnect*. `WarpSet` detaches the character from its sectree, sends `TPacketGCWarp` with `lAddr`/`wPort` and leaves the client to open a socket to the process that owns the destination (`char.cpp:5034-5091`, `map_location.cpp:10-15`). This build hosts every map it serves in one process (`server/shards.py`), so there is no address to send -- but the *client* still has to be rebuilt, because the ground, the collision grid, the props and the minimap are all one map's and were fetched before the socket was opened (`render/mapassets.ts`). So the reconnect survives even though the second process did not, and this frame is what starts it.

**Two fields, and neither is a place.** `map_id` is which ground to fetch, spelled as `Welcome.map_id` spells it. `token` is an opaque string the server minted for this one crossing; the client may store it and echo it back in `Arrive` and may do nothing else with it. There is no `x_mm`, no `y_mm` and no destination map the client gets to *choose* -- the arrival point is held server-side against the token and arrives on the `Welcome` that follows, exactly as `WarpEnd` calls `Show(m_lWarpMapIndex, m_posWarp.x, m_posWarp.y, 0)` from state the destination process was told over P2P rather than by the client (`char.cpp:5116-5134`).

The token is this build's port of `CLoginKey`: the original mints a random `DWORD` per descriptor, keeps it in a process-wide map, and lets the arriving connection authenticate with it instead of a password (`desc_manager.cpp:435-452`, `input_login.cpp:171-178`). It expires (`desc_manager.cpp:455-476` sweeps them at sixty seconds), and so does this one.
 */
export class MapChange {
  static readonly OPCODE = 0xA1;
  map_id: string = "";
  token: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA1);
    w.string(this.map_id);
    w.string(this.token);
    return w.bytes();
  }

  static decode(r: Reader): MapChange {
    const self = new MapChange();
    self.map_id = r.string();
    self.token = r.string();
    return self;
  }
}

/**
 * Play one canned effect on one body, once. The original's `TPacketGCSpecialEffect` (`length.h:635-643`, `Packet.h:2352-2384`), sent by `CHARACTER::EffectPacket` (`char.cpp:5786-5795`).

**Server-published rather than client-inferred, and that is the whole point of the message.** A hit, a death and a cast are all things the client can already see happening -- `CombatEvent` carries the blow, the corpse is in the snapshot, the cast was the client's own key press -- so this build draws those effects without being told to. Drinking a potion is not in that set: the only wire evidence of it is a `Bag` one count shorter and an entity whose `hp` went up, and neither of those is the potion (regeneration raises hp too, and dropping one item shortens the bag as well). The original does not make the client guess either -- it sends this.

Broadcast to everyone who can see the body, exactly as `EffectPacket`'s `PacketAround` does: a red flare over somebody else's character is how a player reads that an opponent has just healed, and it is deliberately not private. What is private is the *sound*: the original plays `eat_potion.wav` only when the vid is the main character's (`PythonNetworkStreamPhaseGameItem.cpp:873-878`), and that test is the client's to make from this frame, not a second frame's job.
 */
export class SpecialEffect {
  static readonly OPCODE = 0xA2;
  entity_id: number = 0;
  effect: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA2);
    w.varint(this.entity_id);
    w.u8(this.effect);
    return w.bytes();
  }

  static decode(r: Reader): SpecialEffect {
    const self = new SpecialEffect();
    self.entity_id = r.varint();
    self.effect = r.u8();
    return self;
  }
}

/**
 * Play one effect file on one body, once. The original's `TPacketGCSpecificEffect` (`packet.h:2115-2121`), sent by `CHARACTER::SpecificEffectPacket` (`char.cpp:5797-5806`) to everyone who can see the body, and played by `RecvSpecificEffect` as a temporary effect on that instance (`PythonNetworkStreamPhaseGameItem.cpp:894-909`). Its one shipped sender is `pet.spawn_effect` (`questlua_pet.cpp:129`), with `npc2_appear.mse` (`pet_system.quest:33,50,60`).
 */
export class SpecificEffect {
  static readonly OPCODE = 0xFD;
  entity_id: number = 0;
  effect_file: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xFD);
    w.varint(this.entity_id);
    w.string(this.effect_file);
    return w.bytes();
  }

  static decode(r: Reader): SpecificEffect {
    const self = new SpecificEffect();
    self.entity_id = r.varint();
    self.effect_file = r.string();
    return self;
  }
}

/**
 * One point of one body changed, told to everyone who can see it. The original's `TPacketGCPointChange` (`packet.h`), which `CHARACTER::PointChange` sends with `PacketAround` when its `bBroadcast` is set and to the player alone otherwise (`char.cpp:3504-3507`). The level sets it (`char.cpp:3067`), and so does every quarter of a level but the first (`char.cpp:3006-3022`).

This is how the 2014 client learns a level-up happened: `RecvPointChange` hands every one to `ShowPointEffect` (`PythonNetworkStreamPhaseGame.cpp:1440-1441`), which attaches `EFFECT_LEVELUP` for `POINT_LEVEL` (`PythonCharacterManager.cpp:241-243`, `playersettingmodule.py:345`) on whichever body the vid names, and `SkillUp`'s `EFFECT_SKILLUP` for `POINT_LEVEL_STEP` (`PythonCharacterManager.cpp:244-246`, `playersettingmodule.py:346`). Sent for those two points here; the private points ride `Standing`.
 */
export class PointChange {
  static readonly OPCODE = 0xC2;
  entity_id: number = 0;
  point: number = 0;
  value: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC2);
    w.varint(this.entity_id);
    w.u8(this.point);
    w.varint(this.value);
    return w.bytes();
  }

  static decode(r: Reader): PointChange {
    const self = new PointChange();
    self.entity_id = r.varint();
    self.point = r.u8();
    self.value = r.varint();
    return self;
  }
}

/**
 * Play the character in this slot. **A slot index, never a character id.**

That is the original's own shape and it is the single most load-bearing decision on this message. `CInputLogin::CharacterSelect` reads `pinfo->index`, bounds it against `PLAYER_PER_ACCOUNT`, and then takes the character id out of `d->GetAccountTable().players[index].dwID` (`input_login.cpp:215-247`) -- the id comes from the row the *server* loaded for the account it authenticated, and the packet has no field that could name a different one.

A `character_id` field here would be an authorisation bug with a polite name: any client could ask to play any character on the shard, and the only thing standing between them and it would be a check somebody remembered to write. An index into a list the server built for this session cannot express that request at all -- the worst a modified client can do is name a slot it does not own, which resolves to nothing.

There is no success frame of its own: the answer is the ordinary `Welcome`, the same one a `Join` produces, because what happens on success is that the player enters the world. A refusal is a `Notice` carrying `NOTICE_NO_SUCH_SLOT` (out of range) or `NOTICE_NO_SUCH_CHARACTER` (in range and empty), and the slot list the client is looking at is still true, so nothing is resent.
 */
export class SelectCharacter {
  static readonly OPCODE = 0x3C;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x3C);
    w.u8(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): SelectCharacter {
    const self = new SelectCharacter();
    self.slot = r.u8();
    return self;
  }
}

/**
 * I have loaded the map you sent me to. Here is the token you gave me.

`HEADER_CG_LOGIN3`'s login-key branch, which is how the original's *destination* process admits a player it has never seen: the client sends the key rather than a password and `CInputLogin::LoginByKey` looks it up (`input_login.cpp:171-178`), because the character's whole state was handed over out of band and there is nothing left to authenticate.

**One opaque field, and that is the entire anti-cheat argument.** The obvious shape for a map crossing is `Warp(map, x, y)`, and it is a teleport hack with a schema: any client that can name a destination can name *any* destination. So the client names none. Walking off an edge is detected server-side from the movement the client already sends (`shards.Shards.cross`), the server picks the destination map and the arrival point from where the character was standing, and this message can express nothing except *which crossing the server already decided on*. A modified client that invents a token is refused; one that replays an old token is refused, because the record is taken out of the table on the first use; one that holds a token and sends it late is refused after `CROSSING_TTL_SECONDS`.

Sent in place of `Login`, from the same state, and it is the only other way into the world.
 */
export class Arrive {
  static readonly OPCODE = 0x39;
  token: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x39);
    w.string(this.token);
    return w.bytes();
  }

  static decode(r: Reader): Arrive {
    const self = new Arrive();
    self.token = r.string();
    return self;
  }
}

/**
 * One byte naming one thing to do with the pet that is already out. Today that is `PET_DISMISS`, and there is nothing else on the frame.

**Summoning is not here, and that is the design.** A pet comes out by *using the item that summons it* -- `pet_system.quest:34-58` is a `when <item>.use` clause and the C++ has no summon packet at all -- so this build routes it through `UseItem`, which names a bag cell and nothing else. A dedicated `SummonPet(mob_vnum)` message would be a message a modified client sets to whichever of the sixteen it likes best, with no item spent and no item to lose; a cell number cannot say what is in the cell.

**No position, no target, no name, no stats.** Where the pet is standing is the server's (`CPetActor::_UpdateFollowAI`, `PetSystem.cpp:222-267`, moves it and nothing else does), what it is called came off the item, and it has no stats to send -- `SPetAbility` (`PetSystem.h:8-10`) is an empty struct behind a TODO. The one thing a player decides is *stop*, and that is this byte.

Dismissing is idempotent and is refused by nothing: `CPetSystem::Unsummon` (`PetSystem.cpp:403-420`) has no failure path, and a player with no pet out who sends this has asked for the state they are already in.
 */
export class PetCommand {
  static readonly OPCODE = 0x4A;
  command: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x4A);
    w.u8(this.command);
    return w.bytes();
  }

  static decode(r: Reader): PetCommand {
    const self = new PetCommand();
    self.command = r.u8();
    return self;
  }
}

/**
 * You have turned into something, or turned back. Sent to the transformed player alone.

Everybody *else* learns about it from `EntityDelta.polymorph`, which is the whole of what a bystander needs -- a shape to draw. This frame exists for the one thing a shape cannot say: **how much longer**. The original tells its own client the same thing by the same split, an affect packet with a duration on the private channel (`AddAffect(AFFECT_POLYMORPH, ..., iDuration, ...)`, `char_item.cpp:6948`) and a re-encoded character add on the public one.

`seconds` is the server's countdown and is never asked for. It is sent once, when the transformation starts, and once more at zero when it ends; the client counts down locally between the two, because a per-second frame for a thirty-five-minute effect is 2,100 frames to say nothing changed. A client whose clock drifts draws a wrong number for a few seconds and is corrected by the zero -- and the *effect* is the server's either way, so a client that faked the number would be lying to its own player.

`model` repeats what the delta already carries, deliberately: this frame is what the panel is built from, and a panel that had to find its own entity in the snapshot to learn its own name would break the first time interest management dropped the player out of his own view. The empty string means it is over.
 */
export class Polymorphed {
  static readonly OPCODE = 0xAE;
  model: string = "";
  seconds: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xAE);
    w.string(this.model);
    w.varint(this.seconds);
    return w.bytes();
  }

  static decode(r: Reader): Polymorphed {
    const self = new Polymorphed();
    self.model = r.string();
    self.seconds = r.varint();
    return self;
  }
}

/**
 * Your pet is out, or is not any more. Sent to the owner alone.

`entity_id` is the pet's own id in the world, so a panel can say which of the things on screen belongs to the person reading it, and zero means there is no pet. That id is not a capability: it names an entity the owner is already being sent in every snapshot (a pet stands next to its owner by construction, `PetSystem.cpp:139-186`), and every message that takes an entity id already checks visibility.

No position and no health. The position is in the snapshot, which is the one place entity positions live; the health does not exist -- a pet is `TYPE NPC` in `mob_proto.txt` and this build spawns it with no `Health` component at all, which is what makes it unattackable by construction rather than by a check.

Sent on every change and on nothing else, exactly as `Mount` is: a summon, a dismissal, and the dismissal the *server* decides when the summoning item leaves the bag (`CPetActor::Update`, `PetSystem.cpp:279-286`), which no client asked for and which a panel would otherwise go on advertising.
 */
export class PetSummoned {
  static readonly OPCODE = 0xAF;
  entity_id: number = 0;
  name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xAF);
    w.varint(this.entity_id);
    w.string(this.name);
    return w.bytes();
  }

  static decode(r: Reader): PetSummoned {
    const self = new PetSummoned();
    self.entity_id = r.varint();
    self.name = r.string();
    return self;
  }
}

/**
 * Delete the character in this slot. A slot and a confirmation, and **no character id** -- `SelectCharacter`'s argument, sharpened by the fact that this one is irreversible from the player's side.

The original asks for two things as well. `command_player_delete` carries `index` and `private_code[8]` (`common/tables.h:676-681`, read at `input_login.cpp:473-516`), and the DB process refuses unless the code matches **the last seven characters of the account's registered social id** -- `strncmp(packet->private_code, r.social_id + strlen(r.social_id) - 7, 7)` (`ClientManagerPlayer.cpp:966`). The client asks for it in a seven-character secret box (`introselect.py:505-524`). It is a *shared secret the account holder knows and a passer-by at the keyboard does not*, and that is the property worth porting.

The literal secret does not port: this build has never collected a national identity number and should not start. The nearest thing it holds that satisfies the same property is the account password, so that is what `confirm` carries -- typed again, into a box that says why. It is verified off the tick against the stored scrypt hash exactly as `Login` is, because a cheap comparison here would be a cheap comparison somebody could run in a loop.

What this build refuses that the original does not: a character who is the master of a guild. The original simply deletes the `guild_member` row (`ClientManagerPlayer.cpp:1124`) and leaves a guild whose master is a character that no longer exists; `guild.py` makes that state unrepresentable -- the master is the member at grade 1 and there is exactly one -- so the answer here is `NOTICE_NOT_MASTER`'s sibling, `NOTICE_CANNOT_DELETE`, and the player disbands first.

What it does *not* refuse, because the original does not either by default: a high level. `PLAYER_DELETE_LEVEL_LIMIT` defaults to `PLAYER_MAX_LEVEL_CONST + 1` and its lower bound to 0 (`ClientManager.cpp:223-231`), so a stock server has no level gate at all -- it is an operator setting, not a rule of the game.
 */
export class DeleteCharacter {
  static readonly OPCODE = 0x3D;
  slot: number = 0;
  confirm: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x3D);
    w.u8(this.slot);
    w.string(this.confirm);
    return w.bytes();
  }

  static decode(r: Reader): DeleteCharacter {
    const self = new DeleteCharacter();
    self.slot = r.u8();
    self.confirm = r.string();
    return self;
  }
}

/**
 * Make an account. Two fields, and no third.

There is no counterpart in the original's protocol at all: accounts were made on a web page outside the game tree, which is why `input_login.cpp` has a `LOGIN` and no `REGISTER`. So the shape is this project's, and the two decisions in it are worth stating.

**No character name and no class.** Registration makes an account and stops; the character is a separate decision made on the screen after it, through `CreateCharacter`. Folding them would make the two failure modes -- 'that username is taken' and 'that character name is taken' -- arrive as one answer to one form, and would mean a player who mistyped a class had to invent a second username to fix it. The original separates them for the same reason and one layer further apart.

**No email, no invitation code, no captcha token.** Every one of those is a field a client fills in, and none of them is anything this shard could check. What actually bounds bulk registration is on the server side of the wire and cannot be written into this message: a per-connection token bucket and a shard-wide one (`session.ByteBudget`), so an account costs a connection and a wait rather than a round trip.
 */
export class Register {
  static readonly OPCODE = 0x3E;
  username: string = "";
  password: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x3E);
    w.string(this.username);
    w.string(this.password);
    return w.bytes();
  }

  static decode(r: Reader): Register {
    const self = new Register();
    self.username = r.string();
    self.password = r.string();
    return self;
  }
}

/**
 * The answer to a `Register`. Whether it worked, and what to say.

Its own frame rather than a `Notice`, because the screen it belongs to is up before the world exists: there is no chat box to put a notice in, and the two outcomes drive different things on the form -- a success fills the username in and hands the player to the sign-in fields, a failure leaves everything typed where it is.

**This frame does say whether a username was taken, and that is a deliberate, stated choice rather than an oversight.** Every other answer on this path refuses to distinguish: `Login` says 'incorrect username or password' for both halves and the store burns a hash on an unknown user so the timing matches (`accounts.verify`), and `creation.REFUSAL_TEXT` gives one sentence for all three ways a character name can be illegal. The original has no registration to compare with, so there is no precedent to follow and the call is this build's.

A registration form that would not say 'that name is taken' is a form nobody can complete -- the player would type name after name with no way to tell a taken name from a rejected one. So the oracle is not removed; it is *priced*. The token buckets in `session.py` mean a name check costs a connection and a wait, which is the same mitigation every public sign-up form on the internet settles on, and it is written down here so the next reader knows it was decided rather than forgotten.
 */
export class Registered {
  static readonly OPCODE = 0xA5;
  ok: boolean = false;
  username: string = "";
  text: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA5);
    w.boolean(this.ok);
    w.string(this.username);
    w.string(this.text);
    return w.bytes();
  }

  static decode(r: Reader): Registered {
    const self = new Registered();
    self.ok = r.boolean();
    self.username = r.string();
    self.text = r.string();
    return self;
  }
}

/**
 * Ask the arena manager to put a duel to somebody standing beside him.

One server-selected manager and one chosen opponent. The manager comes from the preceding live `ClickNpc`; only the opponent is named on this request. Everything the original lets a player choose is gone. `arena_manager.quest` types the opponent's *name* into `input()` and resolves it with `find_pc_by_name` (`:44`), which finds a character anywhere on the shard; the quest then has to ask separately whether they are near (`npc.is_near_vid(opp_vid, 10)`, `:67`) and refuses if not. `opponent_id` is resolved through `aoi.visible_to` instead, so naming somebody this client cannot already see is not a refusal -- it is a lookup that finds nothing, and the two answers are indistinguishable. That is `Emote`'s rule and it is here for `Emote`'s reason: a refusal that differs by distance is a ruler for locating whoever it names.

**No rounds and no clock.** `arena.start_duel(sname, 3)` (`arena_manager.quest:91`) is the only live call and it passes three; the GM console's `/duel a b [set] [minute]` is the only thing that ever passes anything else, and it clamps what it is given (`cmd_gm.cpp:3286-3295`). A `rounds` field would be a field a client sets to zero -- and zero is not clamped, because `if (set < 0) set = 1;` never tests `== 0`, so `/duel a b 0` really does start a match one kill ends. A challenger who could write that byte could offer a best-of-three and deliver a sudden-death, after the opponent had already read the prompt. Both numbers are the server's and both are on the prompt the opponent answers.

**No stake.** Nothing in `arena.cpp`, `arena.h`, `questlua_arena.cpp` or `arena_manager.quest` wagers gold or an item, so there is nothing here to carry -- and a wager field would be the one field on this message worth forging.

**No level.** Both sides' levels are read off the server (`arena_manager.quest:22` for the challenger, `:57-66` for the opponent), which is what makes the level-25 gate a fact rather than a claim.

The manager is re-verified on arrival, but is not client-authored: the server keeps the entity selected by `ClickNpc` for this interaction.
 */
export class ArenaChallenge {
  static readonly OPCODE = 0x40;
  opponent_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x40);
    w.varint(this.opponent_id);
    return w.bytes();
  }

  static decode(r: Reader): ArenaChallenge {
    const self = new ArenaChallenge();
    self.opponent_id = r.varint();
    return self;
  }
}

/**
 * Accept, or refuse, **one named challenge**.

`EmoteAnswer`'s shape, and here the original hands over the field that had to be deleted. Its own Yes/No prompt is `TPacketCGQuestConfirm` -- `{ BYTE header; BYTE answer; DWORD requestPID; }` (`packet.h:777-781`) -- and `CInputMain::QuestConfirm` (`input_main.cpp:1666-1677`) looks the asker up by that number: `FindByPID(p->requestPID)`. The number is *checked* downstream (`CQuestManager::Confirm` refuses unless `IsConfirmWait(pc2)`, `questmanager.cpp:180-184`) rather than unrepresentable, which is exactly the distinction this build draws. A token names both sides at once, so there is no id on this message at all: a yes cannot be aimed at a challenge nobody issued, and a guessed number grants nothing.

The token names *the challenge*, not the challenger, for `PartyAnswer`'s reason with a sharper stake: two people can challenge the same player within a second, the second prompt replaces the first while a finger is already moving, and a yes resolved against "whatever challenge the server is holding for this player" would start a fight against a name that was never read. `Duels.accept` fails the lookup instead.

Accepting is the whole of what starts a match. There is no message on this protocol by which a client begins a duel, ends one, scores a round or reports a winner -- see `ArenaResult`.
 */
export class ArenaAnswer {
  static readonly OPCODE = 0x41;
  token: number = 0;
  accept: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x41);
    w.varint(this.token);
    w.boolean(this.accept);
    return w.bytes();
  }

  static decode(r: Reader): ArenaAnswer {
    const self = new ArenaAnswer();
    self.token = r.varint();
    self.accept = r.boolean();
    return self;
  }
}

/**
 * Take a seat at one running match, or leave the one you have.

`arena.add_observer` (`questlua_arena.cpp:80-90`) and `do_observer_exit` (`cmd_general.cpp:1311-1331`), folded into one message the way `Fish` folds a cast and a pull: a `duel_id` of zero is the exit, and it carries nothing else because leaving is not a choice about which match to leave -- an entity observes at most one.

A duel id and not a position. The original picks an arena by *comparing the observer point the Lua handed back* against each arena's own (`CArenaMap::AddObserver` -> `IsMyObserver`, `arena.cpp:874-892`), which is a client-visible coordinate pair standing in for an identity; the ids here are the server's own and name nothing a client can compute. Watching is a membership and nothing else: it does not move the watcher, and it gives them no permission -- `Duels.may_attack` is an unordered-pair test over the two combatants and says nothing about anybody else (`CArena::CanAttack`, `arena.cpp:679-686`).
 */
export class ArenaWatch {
  static readonly OPCODE = 0x42;
  duel_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x42);
    w.varint(this.duel_id);
    return w.bytes();
  }

  static decode(r: Reader): ArenaWatch {
    const self = new ArenaWatch();
    self.duel_id = r.varint();
    return self;
  }
}

/**
 * Somebody has challenged this player to a duel, or the challenge they were holding has gone.

`PartyInvitation` and `GuildInvitation`'s frame with the arena's own numbers on it, and it stands in for `confirm(opp_vid, ..., 30)` (`arena_manager.quest:83`) -- the original's blocking Yes/No prompt, which cannot be expressed as a synchronous call on a protocol where the server never blocks.

A `token` of zero means **the challenge is gone** -- answered, expired, or its challenger logged out -- and is what takes the prompt down, the same convention the other two use.

`rounds` and `seconds` are on it because they are the terms being agreed to and the client cannot derive either: `ArenaChallenge` deliberately carries neither, so this frame is where a player learns whether they are being asked for a best-of-three or a single kill, and how long the match may run. A prompt that said only "X wants to duel" would be a prompt answered without the terms.

`challenger_name` rides along for `EmoteRequest`'s reason: a prompt has to say who is asking even when the asker has since walked out of view, and "entity 4127 challenges you" is a prompt answered at random.
 */
export class ArenaInvitation {
  static readonly OPCODE = 0xA8;
  token: number = 0;
  challenger: number = 0;
  challenger_name: string = "";
  rounds: number = 0;
  seconds: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA8);
    w.varint(this.token);
    w.varint(this.challenger);
    w.string(this.challenger_name);
    w.u8(this.rounds);
    w.u8(this.seconds);
    return w.bytes();
  }

  static decode(r: Reader): ArenaInvitation {
    const self = new ArenaInvitation();
    self.token = r.varint();
    self.challenger = r.varint();
    self.challenger_name = r.string();
    self.rounds = r.u8();
    self.seconds = r.u8();
    return self;
  }
}

/**
 * The match this player is in, or watching, whole -- whenever any of it changes.

`HEADER_GC_DUEL_START`'s job with the score attached. The original's frame is a header, a size, and a list of opponent VIDs (`arena.cpp:289-308`); the client counts the list, calls `InsertDUELKey` for each and sets `DUEL_START`, and an *empty* list is how the duel is switched off again (`RecvDuelStartPacket`, `PythonNetworkStreamPhaseGame.cpp:906-938`, and `input_login.cpp:674-678` sends the empty one on login). A `duel_id` of zero is that empty list.

Whole, never patched, for `Guild`'s reason -- and symmetric rather than written from the recipient's point of view, because one frame reaches three kinds of reader: both combatants and any number of observers. A client finds itself by comparing `a` and `b` against its own entity id, and an observer, who is neither, does not have to be sent a different frame to be told the same thing.

The round score has no counterpart on the original's wire at all: `CArena::OnDead` announces it as chat text (`"%s %d : %d %s"`, `arena.cpp:766-770`) and the observer half of every one of those announcements is a no-op, because `SendChatPacketToObserver`'s body is commented out (`arena.cpp:1000-1022`). A number in a field rather than a sentence in a chat line is the same information a client can actually draw with.

`seconds_left` counts the *match* down, not the round: the timeout event is created once at `StartDuel` (`arena.cpp:491`) and no round win ever cancels or recreates it -- `OnDead`'s restart branch touches `m_pEvent` and never `m_pTimeOutEvent` -- so a long third round really can end a duel nobody lost.

`round_break` is how many seconds until the next round starts, and zero while one is being fought. Ten is the original's own gap (`arena.cpp:855-857`, `PASSES_PER_SEC(10)` on state 3), and it is sent rather than hardcoded so a countdown says what the server will actually do.
 */
export class ArenaDuel {
  static readonly OPCODE = 0xA9;
  duel_id: number = 0;
  identity: number = 0;
  a: number = 0;
  a_name: string = "";
  a_wins: number = 0;
  b: number = 0;
  b_name: string = "";
  b_wins: number = 0;
  rounds_to_win: number = 0;
  seconds_left: number = 0;
  round_break: number = 0;
  observer_count: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xA9);
    w.varint(this.duel_id);
    w.u8(this.identity);
    w.varint(this.a);
    w.string(this.a_name);
    w.u8(this.a_wins);
    w.varint(this.b);
    w.string(this.b_name);
    w.u8(this.b_wins);
    w.u8(this.rounds_to_win);
    w.varint(this.seconds_left);
    w.u8(this.round_break);
    w.varint(this.observer_count);
    return w.bytes();
  }

  static decode(r: Reader): ArenaDuel {
    const self = new ArenaDuel();
    self.duel_id = r.varint();
    self.identity = r.u8();
    self.a = r.varint();
    self.a_name = r.string();
    self.a_wins = r.u8();
    self.b = r.varint();
    self.b_name = r.string();
    self.b_wins = r.u8();
    self.rounds_to_win = r.u8();
    self.seconds_left = r.varint();
    self.round_break = r.u8();
    self.observer_count = r.varint();
    return self;
  }
}

/**
 * How one match ended. **The server's frame alone.**

There is no client-to-server message on this protocol that reports a winner, a round, a kill or an end -- not one field anywhere in the `0x40`-`0x42` block that a modified client could use to say it won. The outcome is derived from the only thing that produces it: `Duels.record_kill`, called from the same `on_death` a monster kill goes through, which is `CHARACTER::Dead` asking `CArenaManager::OnDead(pkKiller, this)` (`char_battle.cpp:1192`) and keeping the answer as `isDuel`.

An event, not a state, so it is not stored on the connection -- `FishCaught`'s rule. `ArenaDuel` with a zero `duel_id` is the state change that follows it, and this is the sentence about what just happened.

Three outcomes, which are the original's own three endings: a combatant reached the target (`OnDead`'s `m_dwSetPointOfA >= m_dwSetCount`, `arena.cpp:750`), the match's single timer ran out (`duel_time_out`, `arena.cpp:382-460`), or somebody stopped being there (`OnDisconnect`, `arena.cpp:947-965`, and `OnDead`'s null-pointer branches, `:729-745`). Only the first has a winner; the other two set `winner` to zero, because the original declares none for either.

`a`/`b` are not repeated here: they are `ArenaDuel`'s, and every recipient of this frame -- both combatants and every observer -- was sent that one first. The two win counts are, because they are the final score and the last `ArenaDuel` was sent before the kill that ended it.
 */
export class ArenaResult {
  static readonly OPCODE = 0xAA;
  duel_id: number = 0;
  outcome: number = 0;
  winner: number = 0;
  winner_name: string = "";
  a_wins: number = 0;
  b_wins: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xAA);
    w.varint(this.duel_id);
    w.u8(this.outcome);
    w.varint(this.winner);
    w.string(this.winner_name);
    w.u8(this.a_wins);
    w.u8(this.b_wins);
    return w.bytes();
  }

  static decode(r: Reader): ArenaResult {
    const self = new ArenaResult();
    self.duel_id = r.varint();
    self.outcome = r.u8();
    self.winner = r.varint();
    self.winner_name = r.string();
    self.a_wins = r.u8();
    self.b_wins = r.u8();
    return self;
  }
}

/**
 * Open a stall of your own: a sign, and a list of bag cells with prices on them.

`HEADER_CG_MYSHOP` (`packet.h:43`) and `TPacketCGMyShop` (`packet.h:1858-1864`) followed by `bCount` `TShopItemTable`s, which is exactly this message's shape -- a sign and an array. What each line may say is `StallListing`'s docstring, and the short version is that it names a *cell*, never an item.

**Sending this while a stall is already open closes it.** That is `CHARACTER::OpenMyShop`'s own first move (`char.cpp:560-564`, commented "if a shop is already open, close it"), and it is preserved rather than tidied into a replace because a second open is how the original's client spells "pack up". `CloseStall` exists as well, for the button that means only that.

The sign is truncated to 32 bytes rather than refused for length (`strlcpy` into `char szSign[SHOP_SIGN_MAX_LEN+1]`, `char.cpp:592-593`); only an *empty* result is refused, and so is one the shard's word list objects to (`char.cpp:597-606`).

There is no position on this message and none is read from the client: a stall stands where its owner is standing, and the owner stops being able to move the moment it opens (`CanMove` returns false while `GetMyShop()`, `char.cpp:2497`).
 */
export class OpenStall {
  static readonly OPCODE = 0x44;
  sign: string = "";
  listings: StallListing[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x44);
    w.string(this.sign);
    w.varint(this.listings.length);
    for (const item of this.listings)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): OpenStall {
    const self = new OpenStall();
    self.sign = r.string();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.listings.push(StallListing.decode(r));
    }
    return self;
  }
}

/**
 * Pack up your own stall. No fields: a player has at most one, so there is nothing to name.

`CHARACTER::CloseMyShop` (`char.cpp:719-737`). Load-bearing in a way `CloseShop` is not -- an open stall freezes its owner where they stand and locks every item in their bag (`char.cpp:2497`, `char_item.cpp:197`), so this is the only way back to playing. Idempotent, and never an error.
 */
export class CloseStall {
  static readonly OPCODE = 0x45;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x45);
    return w.bytes();
  }

  static decode(_r: Reader): CloseStall {
    const self = new CloseStall();
    return self;
  }
}

/**
 * Ask to browse somebody's stall. Names the seller's entity and nothing else.

`CHARACTER::OnClick` on a player who has one (`char.cpp:4728-4770`) -- a click, not a new verb, which is why this carries an entity id in `ClickNpc`'s own shape. The answer records the window server-side, and that is what makes `BuyFromStall` need no seller field: a purchase can only ever apply to the stall this message opened.

Browsing your own stall is allowed and is how a seller sees what is left on it -- the original says so in a comment, `if (pkChrCauser == this) // self is possible` (`char.cpp:4733`), and checks only the windows that could genuinely be open at the same time.
 */
export class EnterStall {
  static readonly OPCODE = 0x46;
  seller_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x46);
    w.varint(this.seller_id);
    return w.bytes();
  }

  static decode(r: Reader): EnterStall {
    const self = new EnterStall();
    self.seller_id = r.varint();
    return self;
  }
}

/**
 * Stop browsing. No fields, like `CloseShop`: one window per player and this shuts it, whichever it was (`CShopManager::StopShopping`, `shop_manager.cpp:185-198`).

Not load-bearing for safety -- a window left open buys nothing, because every purchase re-reads the seller's live bag and re-measures the distance -- but a buyer who walked away and clicked would otherwise be told a shelf is out of range instead of being told nothing at all.
 */
export class LeaveStall {
  static readonly OPCODE = 0x47;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x47);
    return w.bytes();
  }

  static decode(_r: Reader): LeaveStall {
    const self = new LeaveStall();
    return self;
  }
}

/**
 * Buy one shelf from the stall this player is browsing. The whole message is which shelf.

`CShop::Buy` takes exactly one argument beside the buyer -- `BYTE pos` (`shop.cpp:186`) -- and this is that argument. **Above all there is no price on it.** A private stall is the one place in the game where the *seller* sets the number, so a buyer-supplied price would be two clients disagreeing about what was owed, which is a refund exploit rather than a rounding error. The server charges what its own copy of the listing says and nothing else; the number the buyer saw came from the server in the first place, on `StallWindow`.

No seller either -- the stall is whichever one `EnterStall` last recorded for this player -- and no vnum and no count, both of which are properties of the item actually sitting in the seller's bag cell and are re-read there at the moment of sale.

A cell the stall does not list buys nothing, and neither does one whose listing no longer matches the seller's live bag: the second is `Refusal.SOLD_OUT` and it is what answers the race between two buyers reaching for the last item.
 */
export class BuyFromStall {
  static readonly OPCODE = 0x48;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x48);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): BuyFromStall {
    const self = new BuyFromStall();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Somebody has a stall open, and this is what the board says.

`HEADER_GC_SHOP_SIGN` / `TPacketGCShopSign` (`packet.h:159`, `:1851-1857`), which the original broadcasts around the seller when the stall opens (`char.cpp:687-693`), sends to each client that comes into view of one (`char.cpp:908-915`), and broadcasts again with an empty string when it closes (`char.cpp:726-733`). The same three moments here.

**An empty `sign` means the stall is gone**, exactly as it does there -- `p.szSign[0] = '\0'` is the whole of `CloseMyShop`'s packet. A client holds these keyed by entity id and draws the board when it can see the entity.

Broadcast rather than sent to one client, because a stall is a shopfront: its whole purpose is that strangers can see it. There is nothing private in it -- the sign is text its owner typed to be read, and *what is on the shelves* is not here. That needs `EnterStall`.
 */
export class StallSign {
  static readonly OPCODE = 0xAB;
  entity_id: number = 0;
  sign: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xAB);
    w.varint(this.entity_id);
    w.string(this.sign);
    return w.bytes();
  }

  static decode(r: Reader): StallSign {
    const self = new StallSign();
    self.entity_id = r.varint();
    self.sign = r.string();
    return self;
  }
}

/**
 * What is on the stall this player is browsing.

Named `StallWindow` rather than `Stall` because `pcshop.py`'s own `Stall` is the server-side stall and `tools/audit_wire.py` looks for a message's name being *constructed* in a server file to decide a frame is emitted -- two things called `Stall` and the audit answers yes for a frame nothing sends.

`SHOP_SUBHEADER_GC_START` with `TPacketGCShopStart` (`packet.h:1164`, `shop.cpp:397-444`), sent in answer to `EnterStall` and resent to every browser whenever a shelf leaves -- which is `BroadcastUpdateItem`'s job there (`shop.cpp:348`) and is done as a whole frame here for the reason `Shop` gives: a delta would buy nothing but a way for a client's shelf list to drift from the server's, and a purchase names a cell by the server's own number.

**A `seller_id` of zero means no stall is open**, the same convention `Shop`'s zero `npc_id` uses, and it is what a seller who packed up, walked out of reach or logged out comes back as.

Sold-out shelves are absent rather than greyed. The original drops them from the frame the same way -- `if (m_pkPC && !item.pkItem) continue;` (`shop.cpp:422`) -- and the listing itself stays on the server so that a click racing the frame is refused as sold out rather than as a cell that was never there.

The prices are the server's own copies. A buyer's `BuyFromStall` carries none, so these are what will be charged by construction rather than by agreement.
 */
export class StallWindow {
  static readonly OPCODE = 0xAC;
  seller_id: number = 0;
  seller_name: string = "";
  sign: string = "";
  items: StallSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xAC);
    w.varint(this.seller_id);
    w.string(this.seller_name);
    w.string(this.sign);
    w.varint(this.items.length);
    for (const item of this.items)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): StallWindow {
    const self = new StallWindow();
    self.seller_id = r.varint();
    self.seller_name = r.string();
    self.sign = r.string();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.items.push(StallSlot.decode(r));
    }
    return self;
  }
}

/**
 * Something on your stall sold. **Sent to the seller alone.**

The one thing about a sale a seller cannot read off the `Bag` frame that follows it: a bag that gained gold and lost a sword says nothing about *who* took it or what the shard withheld. The original tells them the same three things across two surfaces -- `LogManager::ItemLog(m_pkPC, item, "SHOP_SELL", ...)` records the buyer and the price (`shop.cpp:341-342`), and a chat line announces the tax when one was taken (`shop.cpp:350-351`).

An event, not a state: nothing stores it and nothing a client sends can produce one. `FishCaught`'s rule.

`price` is what the buyer paid and `tax` is what was withheld from it, so what actually arrived in the purse is the difference. Two numbers rather than one because a seller who is told only the net cannot tell a tax from a price they mistyped.
 */
export class StallSold {
  static readonly OPCODE = 0xAD;
  slot: number = 0;
  vnum: number = 0;
  name: string = "";
  count: number = 0;
  price: number = 0;
  tax: number = 0;
  buyer_name: string = "";
  socket: number = 0;
  socket1: number = 0;
  socket2: number = 0;
  bonuses: ItemBonus[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xAD);
    w.varint(this.slot);
    w.varint(this.vnum);
    w.string(this.name);
    w.varint(this.count);
    w.varint(this.price);
    w.varint(this.tax);
    w.string(this.buyer_name);
    w.varint(this.socket);
    w.varint(this.socket1);
    w.varint(this.socket2);
    w.varint(this.bonuses.length);
    for (const item of this.bonuses)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): StallSold {
    const self = new StallSold();
    self.slot = r.varint();
    self.vnum = r.varint();
    self.name = r.string();
    self.count = r.varint();
    self.price = r.varint();
    self.tax = r.varint();
    self.buyer_name = r.string();
    self.socket = r.varint();
    self.socket1 = r.varint();
    self.socket2 = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bonuses.push(ItemBonus.decode(r));
    }
    return self;
  }
}

/**
 * Ask a cube counter what it knows how to build.

The read-only half, and it is a read all the way down: nothing here spends anything, rolls anything or touches a bag. The answer is a `CubeRecipes` listing every recipe this NPC owns, with the player's own material counts filled in.

No fields: the counter is the server-owned context established by the preceding live `ClickNpc`. Which NPC a player is standing at is a fact the server already has -- `Cube_open` reads it off `ch->GetQuestNPC()` and then checks the race number itself (`cube.cpp:293-307`) -- so the client cannot name a different body from the other side of the map.

The selected counter is server-owned window state. The original stores it in `SetCubeNpc` and refuses `Cube_make` unless `IsCubeOpen()` and `GetQuestNPC()` still pass (`cube.cpp:300-332`, `:518-528`). This port records the exact NPC entity after a successful `CubeInfo`; `CubeMake` uses that same entity without naming it, and logout, death or map crossing clears it. There is still no persistent tray object here: `crafting.attempt` reads the bag at build time and takes the tray as slot indices, so bag contents cannot become a stale server-side copy.
 */
export class CubeInfo {
  static readonly OPCODE = 0x4F;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x4F);
    return w.bytes();
  }

  static decode(_r: Reader): CubeInfo {
    const self = new CubeInfo();
    return self;
  }
}

/**
 * Build. Names the bag cells on the server-owned counter, and nothing else.

**No recipe, and no reward.** Those are the two fields this message exists without. `FN_find_cube` (`cube.cpp:145-160`) walks the table in file order and takes the first recipe whose materials the tray satisfies, and `reward_value` (`:239-249`) draws uniformly from that recipe's own candidates -- both server decisions, both from a table a client has no say in. A recipe index would let a client pick the most valuable recipe its tray happens to satisfy; a reward field would let it pick the best outcome, which is worse. Neither exists to set.

`slots` are bag cell indices, not vnums and not counts, for `MoveItem`'s reason: a tray entry that said 'four Peach Blossoms' would be a client asserting what it holds. What is on the counter is whatever those cells actually contain when the message lands, counted by the server (`crafting.attempt`), and a cell named twice is refused outright rather than counted twice -- the one thing a list of indices can express that the original's array of item pointers could not.

The roll is the server's, seeded from the entity, the tick and the NPC (`crafting.seed_for`), so it is reproducible from a replay and unpredictable from a client. Materials and gold are spent before it and are **not** returned by a failure (`cube.cpp:548-552`), which is the original's rule. Before any of that, the server requires a successful `CubeInfo` for this same counter: `Cube_make` returns at `cube.cpp:518-528` when its window is not open.
 */
export class CubeMake {
  static readonly OPCODE = 0x50;
  slots: number[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x50);
    w.varint(this.slots.length);
    for (const item of this.slots)
      w.varint(item);
    return w.bytes();
  }

  static decode(r: Reader): CubeMake {
    const self = new CubeMake();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.slots.push(r.varint());
    }
    return self;
  }
}

/**
 * Everything one counter can build, answered to `CubeInfo` and never unprompted.

Every number on it is the server's own, read out of `cube.txt`'s recipes at the moment of asking, including how many of each material the player is actually holding -- counted with `Bag.count_of` across every slot, because that is what the build will count with, and a client totalling its own bag would agree today and disagree the first time a stack splits.

`npc_vnum` travels alongside `npc_id` because the panel's title is 'the Herbalist', which is a fact about the race and not about the body -- and because a second counter of the same kind standing nearby would otherwise be indistinguishable in the client's own records.
 */
export class CubeRecipes {
  static readonly OPCODE = 0xB1;
  npc_id: number = 0;
  npc_vnum: number = 0;
  npc_name: string = "";
  recipes: CubeRecipe[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB1);
    w.varint(this.npc_id);
    w.varint(this.npc_vnum);
    w.string(this.npc_name);
    w.varint(this.recipes.length);
    for (const item of this.recipes)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): CubeRecipes {
    const self = new CubeRecipes();
    self.npc_id = r.varint();
    self.npc_vnum = r.varint();
    self.npc_name = r.string();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.recipes.push(CubeRecipe.decode(r));
    }
    return self;
  }
}

/**
 * What one build did. The `Bag` that follows is the truth; this is the sentence.

`RefineResult`'s shape and for its reason: it carries no slot and no gold, because the whole inventory is resent alongside it and anything here describing the new state would be a second description free to disagree with the first. What it carries is the name, because 'a Peach Blossom Juice' cannot be reconstructed from a bag that now has one more of something.

`reward_name` is empty on a failure. The original's failure *log* names what was rolled (`cube.cpp:565-573`), but its failure message to the player does not, and telling somebody what they nearly got is a sentence with no use but to sting.

`dropped` is `AutoGiveItem`'s fallback made visible: a bag with no room does not refuse the build -- the cost is already paid by the time the reward exists -- so the overflow goes on the ground next to the player (`char_item.cpp:6345-6379`) and this says how much of it did.

The three `blend_*` fields are the second roll that rides on the first. Six of `blend.txt`'s seven elixirs are cube rewards at 20022, and `Blend_Item_set_value` rolls their strength and their duration independently at the moment of minting and writes the three numbers into the item's own sockets (`blend_item.cpp:225-227`). This build's `inventory.Slot` persists all three sockets, so the minted apply/value/duration triple is stored on the server-owned item and survives bag, trade, stall and safebox moves. `UseItem` reads those sockets; the client cannot choose or rewrite them. `blend_apply` is empty for every reward that is not one of the seven.
 */
export class CubeResult {
  static readonly OPCODE = 0xB2;
  succeeded: boolean = false;
  reward_vnum: number = 0;
  reward_name: string = "";
  reward_count: number = 0;
  gold_spent: number = 0;
  dropped: number = 0;
  blend_apply: string = "";
  blend_value: number = 0;
  blend_duration: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB2);
    w.boolean(this.succeeded);
    w.varint(this.reward_vnum);
    w.string(this.reward_name);
    w.varint(this.reward_count);
    w.varint(this.gold_spent);
    w.varint(this.dropped);
    w.string(this.blend_apply);
    w.varint(this.blend_value);
    w.varint(this.blend_duration);
    return w.bytes();
  }

  static decode(r: Reader): CubeResult {
    const self = new CubeResult();
    self.succeeded = r.boolean();
    self.reward_vnum = r.varint();
    self.reward_name = r.string();
    self.reward_count = r.varint();
    self.gold_spent = r.varint();
    self.dropped = r.varint();
    self.blend_apply = r.string();
    self.blend_value = r.varint();
    self.blend_duration = r.varint();
    return self;
  }
}

/**
 * The cube counter window was closed by the server.

`Cube_close` sends the client command `cube close` after clearing the selected counter (`cube.cpp:334-342`). Death is one of its callers: `DeathPenalty` closes the counter before the Battle Arena no-penalty return (`char_battle.cpp:275-284`). An empty frame is enough because there is only one cube window per character and no client choice is involved.
 */
export class CubeClosed {
  static readonly OPCODE = 0xBC;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xBC);
    return w.bytes();
  }

  static decode(_r: Reader): CubeClosed {
    const self = new CubeClosed();
    return self;
  }
}

/**
 * Move a dragon soul from one cell to another. Two numbers, and neither of them is an item.

One message for moving, equipping and unequipping, because in the original they are one operation: `CHARACTER::MoveItem` takes a `TItemPos` to a `TItemPos` and branches on where the destination is (`char_item.cpp:5333-5356`), and a soul dragged out of a deck cell goes through `DSManager::PullOut` on the way. The address space is that one: 0 to 959 is the storage window and 960 to 971 is the deck. Three messages here would be three chances to disagree about which window a number is in.

**No vnum.** A client cannot say what it is moving, only where from and where to, which is `MoveItem`'s rule and the reason the placement check -- a soul may only sit in the thirty-two cells of its own (type, grade) box, `IsValidCellForThisItem` (`DragonSoul.cpp:110-127`) -- is answerable at all: the server reads the type and grade off the soul that is actually there.

**No count.** Unlike `MoveItem` there is no split, because equipping takes exactly one and a storage move takes the whole stack. And no merge: the original refuses to merge two items whose sockets differ (`char_item.cpp:5363-5366`), a soul's socket is its remaining time, so two souls of one vnum merge only if their clocks match to the second -- which for anything ever worn they do not. A swap is the honest answer to every case a player can produce.

Pulling a soul out of the deck can destroy it -- `PullOut` rolls against a table and a failure gives back a shard instead (`DragonSoul.cpp:432-454`). There is no field here that touches that roll, and no separate 'unequip carefully' message that would let a client avoid it.
 */
export class DragonSoulMove {
  static readonly OPCODE = 0x51;
  source: number = 0;
  dest: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x51);
    w.varint(this.source);
    w.varint(this.dest);
    return w.bytes();
  }

  static decode(r: Reader): DragonSoulMove {
    const self = new DragonSoulMove();
    self.source = r.varint();
    self.dest = r.varint();
    return self;
  }
}

/**
 * Switch a deck on. One byte naming one of two decks.

`DragonSoul_ActivateDeck` (`char_dragonsoul.cpp:62-93`) in full, including its most surprising property: it calls `DragonSoul_DeactivateAll` **unconditionally and before** the qualification check, so an unqualified character sending this ends with nothing active rather than with whatever was on before. That is not a bug being ported faithfully for its own sake -- it is the reason there is no 'deactivate' message. Switching the other deck on is how you switch this one off, and a character who may not have either is a character with neither.

Nothing here says *which souls* to switch on. Only souls in the chosen deck with time left come on (`ActivateDragonSoul`'s two-part guard, `DragonSoul.cpp:1078-1092`), and both halves are the server's: a client that could name the souls could switch on one that has run dry, which is the same as one that never expires.
 */
export class DragonSoulDeck {
  static readonly OPCODE = 0x52;
  deck: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x52);
    w.u8(this.deck);
    return w.bytes();
  }

  static decode(r: Reader): DragonSoulDeck {
    const self = new DragonSoulDeck();
    self.deck = r.u8();
    return self;
  }
}

/**
 * Improve a soul at the server-owned alchemist context. The request carries one of three operations and the cells on the grid.

The original spends one opcode on all three -- `HEADER_CG_DRAGON_SOUL_REFINE` carries a `bSubType` and a fifteen-cell `TItemPos` grid, dispatched at `input_main.cpp:2900-2923` -- and this is the same shape with the window bit taken out of each cell: `souls` are dragon soul window cells and `stones` are ordinary bag slots, which is exactly where the two kinds of ingredient can be. A refine stone is `ITEM_MATERIAL` and `char_item.cpp:5354` refuses a non-soul into the soul window, so a stone is *always* in the bag and a soul is *always* not.

`operation` names `DS_SUB_HEADER_DO_REFINE_GRADE`, `_STEP` or `_STRENGTH` (`packet.h:2131-2144`). Three operations behind one opcode there and here, and they are genuinely different rules: grade and step consume N souls of one (type, grade) for a weighted shot at the next rung and **re-roll the result from scratch** (`DoRefineGrade`/`DoRefineStep` both build with `CreateItem` and never `CopyAttributeTo`); strength consumes one soul and one stone and carries the same attribute identities across at a new weight (`DoRefineStrength`, `:960-961`, `:983-984`), and a failure at strength 0 destroys the soul outright.

**Nothing here influences the outcome.** No probability, no material index, no target vnum, no result. Which stone is which is read off the item's own `SUB_TYPE` (`IsDragonSoulRefineMaterial`, `DragonSoul.cpp:817-824`) rather than declared; the odds come out of `dragon_soul_table.txt`; the gamble is `deterministic_roll` over a seed made from the entity, the tick and the operation, so it is reproducible from a replay and unpredictable from a client. The grid is cells, so a client cannot assert what is on it, and naming one cell twice is refused rather than counted twice -- which is what the original's own `std::set <LPITEM>` (`DragonSoul.cpp:521-541`) is there for. The legacy packet does not carry an alchemist entity id: the handler uses the quest-established NPC context (`packet.h:2131-2144`, `input_main.cpp:2900-2923`).
 */
export class DragonSoulRefine {
  static readonly OPCODE = 0x53;
  operation: number = 0;
  souls: number[] = [];
  stones: number[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x53);
    w.u8(this.operation);
    w.varint(this.souls.length);
    for (const item of this.souls)
      w.varint(item);
    w.varint(this.stones.length);
    for (const item of this.stones)
      w.varint(item);
    return w.bytes();
  }

  static decode(r: Reader): DragonSoulRefine {
    const self = new DragonSoulRefine();
    self.operation = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.souls.push(r.varint());
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.stones.push(r.varint());
    }
    return self;
  }
}

/**
 * The whole dragon soul window, resent whenever any of it changes.

Not a delta, for `Bag`'s reason and one more. `Bag`'s is that a whole inventory is small and a delta is a second description free to disagree with the first; this window is nine hundred and sixty cells, which is not small -- but it is *sparse*, and a player who has never owned a soul is described by an empty array and three bytes. Sent in a frame of its own rather than folded into `Bag` precisely so that the cost is paid by the people who have souls: `Bag` goes out on every pickup, sale and drag, and this goes out when a soul moves.

`qualified` is the one-way flag `ds.give_qualification` sets (`char_dragonsoul.cpp:50-60`, `INFINITE_AFFECT_DURATION`, and no code path anywhere revokes it). It is on the frame because a window that let an unqualified player arrange souls and then refused to switch any on would be a window that explains nothing.

`active_deck` is 0 or 1, or 255 for neither -- and 'neither' is a state the server arrives at on its own, not only a state a player chooses: `RefreshDragonSoulState` (`DragonSoul.cpp:1123-1139`) resets it the moment the last active soul runs dry, so a client that remembered which deck it picked would be wrong within the hour.
 */
export class DragonSouls {
  static readonly OPCODE = 0xB3;
  qualified: boolean = false;
  active_deck: number = 0;
  cells: SoulSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB3);
    w.boolean(this.qualified);
    w.u8(this.active_deck);
    w.varint(this.cells.length);
    for (const item of this.cells)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): DragonSouls {
    const self = new DragonSouls();
    self.qualified = r.boolean();
    self.active_deck = r.u8();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.cells.push(SoulSlot.decode(r));
    }
    return self;
  }
}

/**
 * What one refinement did. The `DragonSouls` that follows is the truth; this is the sentence.

`RefineResult`'s shape and for its reason: no cell, no vnum, no gold left in the purse, because the window is resent alongside it and anything here describing the new state would be a second description. What it carries is the two names, because 'your Lowest Rough Dragon Diamond shattered' cannot be reconstructed from a window that no longer contains one.

`destroyed` is the field this frame exists for, and it is not `succeeded`'s negation. A strength refinement that fails at strength 0 destroys the soul outright; one that fails at any higher strength gives back the *same soul one strength lower*, attributes and all (`DoRefineStrength`'s `if (bStrength != 0)` guard, `DragonSoul.cpp:975-985`). A window that reported both as 'failed' would lose people a soul without saying so, which is the same argument `RefineOffer.will_destroy` makes one system over.

Sent only in answer to `DragonSoulRefine`, and never unprompted.
 */
export class DragonSoulRefined {
  static readonly OPCODE = 0xB4;
  operation: number = 0;
  succeeded: boolean = false;
  destroyed: boolean = false;
  was_name: string = "";
  result_name: string = "";
  gold_spent: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB4);
    w.u8(this.operation);
    w.boolean(this.succeeded);
    w.boolean(this.destroyed);
    w.string(this.was_name);
    w.string(this.result_name);
    w.varint(this.gold_spent);
    return w.bytes();
  }

  static decode(r: Reader): DragonSoulRefined {
    const self = new DragonSoulRefined();
    self.operation = r.u8();
    self.succeeded = r.boolean();
    self.destroyed = r.boolean();
    self.was_name = r.string();
    self.result_name = r.string();
    self.gold_spent = r.varint();
    return self;
  }
}

/**
 * What this player has selected. Zero is nothing.

`TPacketCGTarget` is `{ BYTE header; DWORD dwVID; }` (`packet.h:1379-1382`) and this is the same message with the same one field, because there is nothing else in it that could be true. `CInputMain::Target` is two lines: look the VID up and `ch->SetTarget(...)` with whatever comes back (`input_main.cpp:1679-1693`).

**An entity id is a capability unless it is bounded, and this one is bounded.** The id is resolved through `aoi.visible_to` and not through `world.transforms`, which is `Emote`'s rule and it is here for the same reason: a bare lookup answers "too far" for a real player and "nothing there" for an invented id, and a client that can tell those apart can walk the id space and map every player on the shard without ever seeing one. Bounded by what this session can already see, the two answers are the same silence.

**Setting a target grants nothing.** It moves nobody, it opens nothing, it gives no reach and it is not a step in any other transaction: `Attack` names its own target and is validated on its own, so a client that lied here would be lying about what its own health bar is pointing at. The original is stricter than it looks about this too -- the reply carries a health percentage for a monster and a hard zero for a player (`char.cpp:4926`), so the message cannot be used to read another player's health either.

There is no second message for clearing. Zero is the clearing, because `CHARACTER_MANAGER::Find` on an unknown VID returns null and `SetTarget(NULL)` is what the original then does -- one door in, `Fish`'s rule.
 */
export class Target {
  static readonly OPCODE = 0x64;
  static readonly SUBCOMMAND = 0x00;
  target: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x64);
    w.u8(0x00);
    w.varint(this.target);
    return w.bytes();
  }

  static decode(r: Reader): Target {
    const self = new Target();
    self.target = r.varint();
    return self;
  }
}

/**
 * Where this bow is pointed, sent as the arrow leaves it.

`TPacketCGFlyTargeting` is `{ header; dwTargetVID; x; y }` (`packet.h:1328-1333`) and this is the same three values. The original's client sends it from the bow animation's own fly event, one per shot, immediately before the shoot packet (`CNormalBowAttack_FlyEventHandler::OnSetFlyTarget`, `PythonPlayerEventHandler.cpp:232-240`), and `CInputMain::FlyTarget` hands all three to `CHARACTER::FlyTarget` (`input_main.cpp:1598-1602`).

**The point is a place to draw an arrow, never a place to put damage.** `CHARACTER::FlyTarget` uses `x` and `y` only in the branch where the target vid resolves to nobody (`char_battle.cpp:3029-3032`); when there is a victim the broadcast carries *the victim's own* position (`:3020-3022`) and the shot is later resolved against the remembered vid by `CHARACTER::Shoot` (`char_battle.cpp:2985-3005`). This build keeps that division exactly, so a client that lies about the point moves an arrow's picture and no hit.

The vid is resolved through `aoi.visible_to`, which is `Target`'s rule above and is here for the same reason.
 */
export class FlyTarget {
  static readonly OPCODE = 0x64;
  static readonly SUBCOMMAND = 0x01;
  target_id: number = 0;
  x_mm: number = 0;
  y_mm: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x64);
    w.u8(0x01);
    w.varint(this.target_id);
    w.svarint(this.x_mm);
    w.svarint(this.y_mm);
    return w.bytes();
  }

  static decode(r: Reader): FlyTarget {
    const self = new FlyTarget();
    self.target_id = r.varint();
    self.x_mm = r.svarint();
    self.y_mm = r.svarint();
    return self;
  }
}

/**
 * One piece of the sender's guild symbol file, in order.

`TPacketCGGuildSymbolUpload` is a header, a guild id and the whole file behind it (`input_login.cpp:788-813`). The file is up to 64 KB (`:795`) and a client frame is bounded far below that, so it arrives here in pieces: `offset` is where `data` starts and `total` is the file's length. The session keeps the pieces of one file for this connection, drops them on any gap, and hands the whole file on when `offset + len(data)` reaches `total`.

**There is no guild id.** 2014 stored the file under whatever id the packet named; the file here is always the sender's own guild's, under the notice authority the window checks (`uiguild.py:1724-1727`).
 */
export class GuildSymbolChunk {
  static readonly OPCODE = 0x64;
  static readonly SUBCOMMAND = 0x03;
  total: number = 0;
  offset: number = 0;
  data: number[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x64);
    w.u8(0x03);
    w.varint(this.total);
    w.varint(this.offset);
    w.varint(this.data.length);
    for (const item of this.data)
      w.varint(item);
    return w.bytes();
  }

  static decode(r: Reader): GuildSymbolChunk {
    const self = new GuildSymbolChunk();
    self.total = r.varint();
    self.offset = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.data.push(r.varint());
    }
    return self;
  }
}

/**
 * Which copy of a guild's symbol this client holds.

`TPacketCGSymbolCRC` is `{ header; guild_id; crc; size }` and `GuildSymbolCRC` sends the stored file only when either differs (`input_login.cpp:818-844`). The client asks for every guild whose insignia it sees, as 2014 asks for every guild in a land list (`PythonNetworkStreamPhaseGame.cpp:4176-4218`). A symbol is public; a guild with none gets no answer, as there.
 */
export class GuildSymbolCRC {
  static readonly OPCODE = 0x64;
  static readonly SUBCOMMAND = 0x04;
  guild_id: number = 0;
  crc: number = 0;
  size: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x64);
    w.u8(0x04);
    w.varint(this.guild_id);
    w.u32(this.crc);
    w.varint(this.size);
    return w.bytes();
  }

  static decode(r: Reader): GuildSymbolCRC {
    const self = new GuildSymbolCRC();
    self.guild_id = r.varint();
    self.crc = r.u32();
    self.size = r.varint();
    return self;
  }
}

/**
 * Somebody near you has pointed a bow at something.

`CHARACTER::FlyTarget` ends in `PacketAround` of `TPacketGCFlyTargeting` -- shooter vid, target vid, x, y (`packet.h:1335-1342`, sent at `char_battle.cpp:3036`) -- so an arrow is visible to the people it flies past and not only to the two ends of it. This is that frame.

`x_mm` and `y_mm` are the server's own reading whenever `target` is set: `CHARACTER::FlyTarget` overwrites the client's point with the victim's live position before broadcasting (`char_battle.cpp:3020-3022`), so what the neighbours are told is never what the shooter asserted about a character that exists.
 */
export class Aimed {
  static readonly OPCODE = 0xBD;
  shooter: number = 0;
  target: number = 0;
  x_mm: number = 0;
  y_mm: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xBD);
    w.varint(this.shooter);
    w.varint(this.target);
    w.svarint(this.x_mm);
    w.svarint(this.y_mm);
    return w.bytes();
  }

  static decode(r: Reader): Aimed {
    const self = new Aimed();
    self.shooter = r.varint();
    self.target = r.varint();
    self.x_mm = r.svarint();
    self.y_mm = r.svarint();
    return self;
  }
}

/**
 * Somebody's selection, confirmed by the server. `TPacketGCTarget` (`packet.h:1384-1389`) with one field added.

`who` is the field the original does not have, and it is what makes this frame worth sending to more than one person: the original's is written to one descriptor and can only ever mean "yours" (`char.cpp:4963`). Here the same frame reaches the player who chose and every member of their party who can see the quarry, so a group finally has a way to focus fire. That is this build's addition and not the original's -- `grep -n Target party.cpp` is empty, and a party in 2014 had no shared target at all -- and it is added rather than invented from nothing because the field it needs is the one the original left implicit.

`target` of zero means the selection is gone: cleared by its owner, or dropped by the server because the quarry died, despawned or walked out of range. `CHARACTER::ClearTarget` sends exactly that -- `p.dwVID = 0` to everybody who was pointing at the dead thing (`char.cpp:4875-4895`).

`hp_percent` is **zero for a player, always** (`char.cpp:4926`, and again in `BroadcastTargetPacket` at `:4979`). Not a rounding of a small number and not an omission: the original will not tell you how hurt another player is, and a build that filled this in would be handing every duellist a target's health bar the game deliberately withholds. It is resent whenever the number changes, which is `BroadcastTargetPacket` called out of `PointChange(POINT_HP)` (`char.cpp:3109`).
 */
export class Targeted {
  static readonly OPCODE = 0xBB;
  who: number = 0;
  target: number = 0;
  hp_percent: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xBB);
    w.varint(this.who);
    w.varint(this.target);
    w.u8(this.hp_percent);
    return w.bytes();
  }

  static decode(r: Reader): Targeted {
    const self = new Targeted();
    self.who = r.varint();
    self.target = r.varint();
    self.hp_percent = r.u8();
    return self;
  }
}

/**
 * One selected player's currently worn items, read by the server when the existing AOI-gated `Target` selection resolves. The old `TPacketViewEquip` contains its VID and one row per `WEAR_MAX_NUM` cell (`packet.h:1976-1986`), then the client opens `EquipmentDialog` and fills each slot (`PythonNetworkStreamPhaseGame.cpp:4153-4173`). This is the same snapshot, reshaped around this build's ten actual `WearSlot`s (including the two unique cells) and its existing `BagSlot` tooltip facts.

It is a response, not a broadcast or a client cache: a target can unequip between selection and click, so the only honest frame is the one rebuilt from authoritative gear at request time.
 */
export class EquipmentView {
  static readonly OPCODE = 0xD2;
  entity_id: number = 0;
  name: string = "";
  worn: BagSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xD2);
    w.varint(this.entity_id);
    w.string(this.name);
    w.varint(this.worn.length);
    for (const item of this.worn)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): EquipmentView {
    const self = new EquipmentView();
    self.entity_id = r.varint();
    self.name = r.string();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.worn.push(BagSlot.decode(r));
    }
    return self;
  }
}

/**
 * Swing a pick at the ore vein in front of this player, or stop swinging. **One message for both**, and one field: a facing. That is `Fish`'s anti-cheat shape, applied to an original action that has no client packet of its own.

`CHARACTER::mining` (`char.cpp:3797-3803`) opens with `if (m_pkMiningEvent) { mining_cancel(); return; }`, the same entry point cancelling what it would otherwise start. The original reaches it from a quest click: `mining.quest:46-52` calls `pc.mining()`, and that binding reads the current NPC out of the quest context (`questlua_pc.cpp:1715-1720`). There is therefore no `HEADER_CG_MINING` and no original client-selected vein id to port. This browser has no server-owned quest context on a click, so it sends only the direction of the click and the server finds the standing vein in that direction.

**What is deleted from this message, and what it would have bought.**

*A duration.* How long a swing lasts is `Random::get(5, 15)` actions of two seconds each, rolled on the server when the swing starts (`char.cpp:3821`, `mining.cpp:391`) -- ten to thirty seconds. A client that named it would name ten every time, and since one swing pays one yield roll that is a threefold rise in ore per minute with nothing to detect. The count is *sent back* on `Mining` so the pick can be swung the right number of times; it is never accepted.

*A success flag, a yield and an ore vnum.* All three are decided in `mining_event` (`mining.cpp:368-379`), after the interval has elapsed, out of a roll the client has no part in -- and which ore is not even a roll: `GetRawOreFromLoad(load->GetRaceNum())` reads it off the vein's own species, so the answer was fixed the moment the vein was placed.

*The pick, its grade and the mining skill.* `GetOrePct` (`mining.cpp:150-161`) reads all three off the character the server is holding. A `pick_level` field is a `+9` field.

**There is no vein id.** A target id would let the client choose a body anywhere in the entity space and leave correctness resting on rejection checks. A facing can select only among veins the server itself has placed inside reach. It cannot name a species, an ore, a position or even assert that a vein exists. Like `Fish.heading`, it also turns the character and cannot move it.
 */
export class Mine {
  static readonly OPCODE = 0x72;
  heading: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x72);
    w.bits(this.heading, 12);
    return w.bytes();
  }

  static decode(r: Reader): Mine {
    const self = new Mine();
    self.heading = r.bits(12);
    return self;
  }
}

/**
 * This player's own swing, whole, whenever it changes.

`Fishing`'s shape and for its reason: a state that stays true, sent to the miner and to nobody else. What the *bystanders* get is a bit on `EntityDelta.flags` (`ENTITY_MINING`), which is the same split the original makes without meaning to -- `TPacketGCDigMotion` goes out with `PacketAround` (`char.cpp:3823-3828`) and carries only a body, a target and a count, because the animation is all a bystander is owed.

`swings` is that count: how many times to raise the pick, at two seconds each (`mining.cpp:391`, `PASSES_PER_SEC(2 * count)`). It is on the frame rather than hardcoded for `GuildInvitation.seconds`' reason -- the animation should run for as long as the server will actually make the player wait, and that is a number the server rolled.

`remaining_ms` is sent alongside it rather than left to be multiplied out, because the two are not redundant on a *resent* frame: a swing already half done has the same `swings` and less time left, and a client that recomputed from the count would restart its own bar every time anything else about the character changed.

Nothing here says what will come out. The ore is fixed by the vein and the yield is not rolled until the interval is up, so there is nothing yet to tell -- see `MineResult`.
 */
export class Mining {
  static readonly OPCODE = 0xC3;
  state: number = 0;
  target: number = 0;
  swings: number = 0;
  remaining_ms: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC3);
    w.u8(this.state);
    w.varint(this.target);
    w.varint(this.swings);
    w.varint(this.remaining_ms);
    return w.bytes();
  }

  static decode(r: Reader): Mining {
    const self = new Mining();
    self.state = r.u8();
    self.target = r.varint();
    self.swings = r.varint();
    self.remaining_ms = r.varint();
    return self;
  }
}

/**
 * What one swing came to. Its own frame rather than fields on `Mining`, for `FishCaught`'s reason: one is a state and the other is a moment, and a yield folded into the state would be a yield the panel goes on showing until the next swing.

The five outcomes are the original's own five sentences -- `mining_event`'s "The mining has been successful." and "The mining has failed." (`mining.cpp:376`, `:379`), its two pre-checks "You cannot mine without a Pick." (`:357`) and "Nothing to mine here." (`:365`), and `mining_cancel`'s "Mining is finished." (`char.cpp:3793`). They are kept apart rather than folded into one failure because they are four different instructions: roll again, put a pick in your hand, find another vein, and you stopped this yourself.

**The ore is on the ground, not in the bag.** `OreDrop` (`mining.cpp:130-142`) creates the item, `AddToGround`s it within 200 units of the miner and gives them fifteen seconds of exclusive claim on it -- so this frame reports what came loose and the player still has to pick it up. `name` rides along for `BagSlot.name`'s reason and `count` because a pile is one entity whatever its size.
 */
export class MineResult {
  static readonly OPCODE = 0xC5;
  outcome: number = 0;
  vnum: number = 0;
  name: string = "";
  count: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xC5);
    w.u8(this.outcome);
    w.varint(this.vnum);
    w.string(this.name);
    w.varint(this.count);
    return w.bytes();
  }

  static decode(r: Reader): MineResult {
    const self = new MineResult();
    self.outcome = r.u8();
    self.vnum = r.varint();
    self.name = r.string();
    self.count = r.varint();
    return self;
  }
}

/**
 * Ask the person in front of you to marry you. One entity id, and that is the whole message.

`marriage_manage.quest:5-190` is the original's own version and it is a *conversation*: the matchmaker asks for a name, resolves it with `find_pc_by_name`, checks that they are within ten metres (`:78`), runs eleven conditions over both characters and only then calls `confirm(u_vid, ..., 30)`. Every one of those eleven is a fact about two characters the server already holds, so none of them is a field here.

**What was deleted, and what it would have bought.** The obvious message carries the two levels, the two sexes, the empire, the gold and a ring count -- and a client that could assert any of them could marry at level 1, marry itself a second husband, or pay nothing. `marriage.Suitor` is built server-side out of the progression row, `creation.sex_for_race` and the live bag at both the ask *and* the answer, because the quest script re-reads the gold at `:177` after the confirmation comes back and so does this.

There is no proposal id either. The server mints one and hands it to the *target* on `MarriageStatus`; a proposer never learns the number, which is what makes an acceptance impossible to forge from the asking side.

Resolved through the interest index rather than a bare entity lookup, `Emote`'s rule: a lookup that answers "too far" for a real player and "no such entity" for an invented id is a map of everybody on the shard.
 */
export class ProposeMarriage {
  static readonly OPCODE = 0x5C;
  target_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x5C);
    w.varint(this.target_id);
    return w.bytes();
  }

  static decode(r: Reader): ProposeMarriage {
    const self = new ProposeMarriage();
    self.target_id = r.varint();
    return self;
  }
}

/**
 * Yes or no to **one named question** -- a proposal, a wedding ceremony, a divorce, or ending the active wedding.

One message for all four because the original has one dialog for all four: `confirm(vid, message, 30)` at `marriage_manage.quest:173` (the proposal), `:252` (the ceremony inside the hall), `:322,400` (a mutual divorce), and `:302-324` (ending the private wedding), with the same timeout every time. `marriage.Marriages` keeps them in one token space for the same reason, and the server decides from the token which of `answer`, `answer_ceremony`, `answer_divorce` and `answer_end_wedding` this is -- so a client cannot answer a divorce with a proposal's yes.

**The token names the question, not the person.** `EmoteAnswer`'s rule, and the original's own gap: `do_messenger_auth` and the quest `confirm` both resolve an answer against a *name* (`cmd_general.cpp:1271-1277`), which is a value the answering client chooses. Here the token is minted by the server, addressed to exactly one entity, consumed by the first answer that resolves it, and swept after thirty seconds -- so a yes cannot be forged for a request nobody made, and cannot be replayed once spent.

Nothing about the marriage rides along. No partner, no gold, no date, no love points: the state of a marriage is the server's, and the only thing this frame adds to it is one bit of consent.
 */
export class AnswerMarriage {
  static readonly OPCODE = 0x5D;
  token: number = 0;
  accept: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x5D);
    w.varint(this.token);
    w.boolean(this.accept);
    return w.bytes();
  }

  static decode(r: Reader): AnswerMarriage {
    const self = new AnswerMarriage();
    self.token = r.varint();
    self.accept = r.boolean();
    return self;
  }
}

/**
 * One byte naming one of five things a person can do about their own marriage.

One byte rather than five opcodes, for one reason: five verbs that share every precondition and carry no argument would otherwise be five opcodes whose handlers differ by one line. The five are the five the original's NPCs offer -- ask to complete the ceremony (`marriage_manage.quest:209-263`, NPC 9011 inside the hall), ask for a mutual divorce (`:335-424`, NPCs 11000/11002/11004), divorce alone (`:427-500`, the same three NPCs and no `confirm()` at all), and walk to the wedding hall (`marriage.warp_to_my_marriage_map()`, `:205`), and end the current private wedding after the spouse confirms (`marriage.end_wedding()`, `:302-324`).

**No target and no state.** Who the partner is, whether the marriage is a day old, what either side is holding and what it costs are all read server-side at the moment of the command -- a message that named the partner would let a client divorce a stranger, and one that carried the marriage's age would let it divorce on the wedding night. The unilateral divorce in particular carries nothing at all beyond the byte, which is exactly what it is in the original: the partner's consent, presence and even whether they are logged in are never consulted (`:427-500`).
 */
export class MarriageCommand {
  static readonly OPCODE = 0x5E;
  command: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x5E);
    w.u8(this.command);
    return w.bytes();
  }

  static decode(r: Reader): MarriageCommand {
    const self = new MarriageCommand();
    self.command = r.u8();
    return self;
  }
}

/**
 * Ask to be on somebody's friend list. A name, and nothing else.

`MESSENGER_SUBHEADER_CG_ADD_BY_NAME` (`input_main.cpp:945-978`), which is a name and a name only -- and `RequestToAdd` (`messenger_manager.cpp:114-138`), which **does not add anybody**. It sends the target a prompt and waits: the friendship is written by `AuthToAdd` after the other side answers (`:140-162`). Consent is the original's own rule, and it is why there is no consent bit on this message to forge.

A name rather than an entity id, unlike `ProposeMarriage`, because a friend list is not about who is standing next to you -- the original offers both (`ADD_BY_VID` at `:906-943`) and only the by-name form works across a map. Resolved case-insensitively, `FindPC`'s own rule (`char_manager.cpp:209-225`).

**The refusal is deliberately blunt, and this is the interesting part.** A friend list is a presence oracle: whoever can tell "that name is not online" from "that name has invitations turned off" can enumerate who is playing. The original tells them apart -- `"%s is not online."` at `:962` against "The player has rejected your request..." at `:968` -- so a blocked player is still discoverable there. Here **a name that does not exist, one that is offline, and one whose owner has invitations off are one answer**, which is the same collapse whisper already makes for `FindPC` returning null (`:333-361`). Yourself is answered separately, because you already know your own name.
 */
export class AddFriend {
  static readonly OPCODE = 0x5F;
  name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x5F);
    w.string(this.name);
    return w.bytes();
  }

  static decode(r: Reader): AddFriend {
    const self = new AddFriend();
    self.name = r.string();
    return self;
  }
}

/**
 * Yes or no to one friend request.

`do_messenger_auth` (`cmd_general.cpp:1253-1278`) -> `AuthToAdd` (`messenger_manager.cpp:140-162`). On yes, **both** directions are written in the same call (`:159-160`), so there is no moment where one side has the other and the other does not.

A token, not a name -- `AnswerMarriage`'s rule and the same correction to the same original. `do_messenger_auth` takes the requester's *name* off the command line and hashes the pair, so a client that guessed a name could accept a request that had never been sent to it. The token here is minted server-side, addressed to one player and consumed either way, exactly as `AuthToAdd` erases the pending entry before it branches on `bDeny` (`:155-161`).
 */
export class AnswerFriend {
  static readonly OPCODE = 0x60;
  token: number = 0;
  accept: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x60);
    w.varint(this.token);
    w.boolean(this.accept);
    return w.bytes();
  }

  static decode(r: Reader): AnswerFriend {
    const self = new AnswerFriend();
    self.token = r.varint();
    self.accept = r.boolean();
    return self;
  }
}

/**
 * Take somebody off your own list.

`MESSENGER_SUBHEADER_CG_REMOVE` (`input_main.cpp:982-993`), a name and nothing else, and **one-directional on purpose**: `RemoveFromList` (`messenger_manager.cpp:219-236`) erases the remover's forward entry and the target's reverse entry, never the target's own list. Unfriend somebody and they still have you. That looks exactly like a bug worth fixing and is not one -- "did they still have you" and "do you still have them" were always two questions in this data -- so `messenger.Messenger.remove` keeps it and `TestUnfriendingIsNotMutual` pins it.

No consent, no token and no notification: nobody is told they were dropped, there and here. The one thing the other side eventually notices is that they stop being told when you log in, because login notices are computed from the reverse index.
 */
export class RemoveFriend {
  static readonly OPCODE = 0x61;
  name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x61);
    w.string(this.name);
    return w.bytes();
  }

  static decode(r: Reader): RemoveFriend {
    const self = new RemoveFriend();
    self.name = r.string();
    return self;
  }
}

/**
 * Turn any of the six `EBlockAction` bits off, or back on.

`do_setblockmode` (`cmd_general.cpp:1280-1289`), which takes one byte and hands the whole of it to `SetBlockMode` (`char.cpp:5896-5908`) -- the original overwrites the entire `bBlockMode` in one call rather than toggling a bit, which is why all six flags are on one message here.

All six of the original's `EBlockAction` bits (`char.h:315-322`): `BLOCK_EXCHANGE` (`1 << 0`, read at `exchange.cpp:91`), `BLOCK_PARTY_INVITE` (`1 << 1`, `char.cpp:4356`), `BLOCK_GUILD_INVITE` (`1 << 2`, `guild.cpp:1925`), `BLOCK_WHISPER` (`1 << 3`), `BLOCK_MESSENGER_INVITE` (`1 << 4`), and `BLOCK_PARTY_REQUEST` (`1 << 5`, `char.cpp:4183-4184`).

All six are session state, not account state: `bBlockMode` lives in `CHARACTER_POINT_INSTANT` (`char.h:418,787`) and is never read from or written to the database anywhere in that source tree, so it starts clear on every login here as it does there -- restored instead from the six `game_option.*` quest flags `SetBlockMode` also writes (`char.cpp:5902-5907`).
 */
export class SetBlockMode {
  static readonly OPCODE = 0x62;
  whisper: boolean = false;
  messenger_invite: boolean = false;
  exchange: boolean = false;
  party_invite: boolean = false;
  guild_invite: boolean = false;
  party_request: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x62);
    w.boolean(this.whisper);
    w.boolean(this.messenger_invite);
    w.boolean(this.exchange);
    w.boolean(this.party_invite);
    w.boolean(this.guild_invite);
    w.boolean(this.party_request);
    return w.bytes();
  }

  static decode(r: Reader): SetBlockMode {
    const self = new SetBlockMode();
    self.whisper = r.boolean();
    self.messenger_invite = r.boolean();
    self.exchange = r.boolean();
    self.party_invite = r.boolean();
    self.guild_invite = r.boolean();
    self.party_request = r.boolean();
    return self;
  }
}

/**
 * Everything this player's own client may know about their marriage. **Sent to one player.**

`SendLoverInfo` (`marriage.cpp:43-51`, `TPacketGCLoverInfo`) plus the five client commands the original spends on the same subject -- `lover_login`, `lover_logout`, `lover_near`, `lover_far` and `lover_divorce` (`marriage.cpp:58-59,254-255,300-317,337-344`) -- collapsed into one frame that says what is true rather than five that each say what changed. A client that missed one of five would draw a partner who is permanently far away; a client that misses this one gets the next one whole.

`point` is `GetMarriagePoint` (`marriage.cpp:77-116`), the 50-100 score, and it is what the original puts in the `love_point` field of its own packet (`:202,208,418-419`) -- *not* the raw `love_point` counter, which runs to two billion and is never sent anywhere. The client draws it as the tooltip on the lover's row (`uimessenger.py:52,661-670`, `AFF_LOVE_POINT`).

**Nothing here can be sent the other way.** There is no message on this protocol that reports a marriage, a love point, a grade or a partner; every one of these is derived server-side from a `marriage.Marriage` the client has no handle on. The array is the one part a client acts on, and what it acts with is a token.

A `state` of zero -- nobody, no partner name, no score -- is what a divorce, a decline and a fresh login with no marriage all arrive as, and is what `lover_divorce` is there (`marriage.cpp:53-63`).
 */
export class MarriageStatus {
  static readonly OPCODE = 0xB8;
  state: number = 0;
  partner_name: string = "";
  partner_online: boolean = false;
  partner_near: boolean = false;
  point: number = 0;
  grade: number = 0;
  in_wedding_hall: boolean = false;
  asks: MarriageAskRow[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB8);
    w.u8(this.state);
    w.string(this.partner_name);
    w.boolean(this.partner_online);
    w.boolean(this.partner_near);
    w.u8(this.point);
    w.u8(this.grade);
    w.boolean(this.in_wedding_hall);
    w.varint(this.asks.length);
    for (const item of this.asks)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): MarriageStatus {
    const self = new MarriageStatus();
    self.state = r.u8();
    self.partner_name = r.string();
    self.partner_online = r.boolean();
    self.partner_near = r.boolean();
    self.point = r.u8();
    self.grade = r.u8();
    self.in_wedding_hall = r.boolean();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.asks.push(MarriageAskRow.decode(r));
    }
    return self;
  }
}

/**
 * This player's own friend list, whole. **Sent to one player.**

`MessengerManager::SendList` (`messenger_manager.cpp:266-327`), and whole rather than as a diff for `Guild`'s reason: the original sends the list on login and then sends one-line `SendLogin`/`SendLogout` deltas (`:329-378`), which is a second encoding of the same truth and a second way for a panel to drift. One frame per change costs a few dozen bytes and cannot disagree with itself.

**Presence in this frame is consented presence.** Every `FriendRow` got here through a request this player sent or answered, so the `online` bit is one the other side agreed to publish -- see `FriendRow`. Nobody appears in it who has not accepted, and somebody with a request outstanding appears only in `asks`, on *their own* screen, never on the asker's.

The two block flags ride along because they are what the panel's own switches draw, and because they are session state the client must not keep its own copy of: they clear on every login (`char.h:418,787`; `bBlockMode` is never persisted), so a client that remembered its last setting would draw a switch that is off on the server and on on the screen.
 */
export class FriendList {
  static readonly OPCODE = 0xB9;
  blocks_whisper: boolean = false;
  blocks_invite: boolean = false;
  blocks_exchange: boolean = false;
  blocks_party_invite: boolean = false;
  blocks_guild_invite: boolean = false;
  friends: FriendRow[] = [];
  asks: FriendAskRow[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB9);
    w.boolean(this.blocks_whisper);
    w.boolean(this.blocks_invite);
    w.boolean(this.blocks_exchange);
    w.boolean(this.blocks_party_invite);
    w.boolean(this.blocks_guild_invite);
    w.varint(this.friends.length);
    for (const item of this.friends)
      item.encode(w);
    w.varint(this.asks.length);
    for (const item of this.asks)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): FriendList {
    const self = new FriendList();
    self.blocks_whisper = r.boolean();
    self.blocks_invite = r.boolean();
    self.blocks_exchange = r.boolean();
    self.blocks_party_invite = r.boolean();
    self.blocks_guild_invite = r.boolean();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.friends.push(FriendRow.decode(r));
    }
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.asks.push(FriendAskRow.decode(r));
    }
    return self;
  }
}

/**
 * Set your guild's emblem: 768 bytes of 16x12 BGRA and nothing else.

**This is the only message in this protocol that carries attacker-chosen binary**, and everything about its shape follows from that.

*It does not name a guild.* The original's does -- `TPacketCGMarkUpload` is `{header, gid, image[16*12*4]}` (`packet.h:1740-1745`) -- and `GuildMarkUpload` (`input_login.cpp:847-879`) looks that gid up, checks the guild's *level*, and writes the pixels. It never checks who is sending. It cannot: the upload arrives on the auth/mark connection, which is in `PHASE_LOGIN` and has no character bound to it at all. The only thing standing between a player and every other guild's emblem in the shipped original is the client hiding the button unless your own name equals the guild master's (`uiguild.py:1477-1481`, a comparison of two display strings, in the client). Deleting the field is what makes 'upload for somebody else's guild' unrepresentable instead of refused: the server reads the guild off the session's own character, and there is nowhere for a modified client to put a different answer.

*It does not name a mark id, an atlas, a row or a column.* Those are `SaveMark`'s arithmetic over an id the server allocates (`MarkManager.cpp:170-241`), so a client that could state one could write into another guild's cell of the shared texture.

*It has no delete flag.* An all-transparent image is the deletion, which is the original's own rule (`input_login.cpp:869-878`) and is one fewer thing to lie about.

*The bytes are pixels, not a file.* There is no format on this wire -- no header, no palette, no compression, no length field beyond the array's own count -- because `SGuildMark` has none (`MarkImage.h:9-24`). A fixed count of raw samples is the one shape of binary upload that has no decoder for a malformed input to reach. The server still checks the count, refuses any sample outside 0-255, re-encodes every pixel through `emblem.canonical_rgba`, and serves only what it produced.

Rate-limited per connection on top of the item-action budget, because this is the largest thing a client can ask the server to fan out.
 */
export class UploadEmblem {
  static readonly OPCODE = 0x69;
  bgra: number[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x69);
    w.varint(this.bgra.length);
    for (const item of this.bgra)
      w.varint(item);
    return w.bytes();
  }

  static decode(r: Reader): UploadEmblem {
    const self = new UploadEmblem();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.bgra.push(r.varint());
    }
    return self;
  }
}

/**
 * Ask for one guild's emblem.

The original does not have this message; it has a two-stage cache-sync instead -- `GuildMarkIDXList` returns the whole guild-id/mark-id table (`input_login.cpp:881-909`) and then, per 512x512 atlas, the client sends the CRC of each of its own 80 cached blocks and gets back the LZO-compressed blocks that differ (`GetDiffBlocks`, `MarkImage.cpp:231-245`). That protocol exists to keep a 2004 client's texture memory in step with a shared atlas; this build has no atlas, so it would be a CRC ladder protecting nothing.

A guild id is safe to name here in a way it is not on `UploadEmblem`: an emblem is public by construction -- the original broadcasts the whole index to anyone who asks -- so the answer leaks nothing that walking past a member would not. The server answers with `Emblem` either way, empty for a guild with no emblem *and* for a guild id that does not exist, so this cannot be used to enumerate which guilds are real.
 */
export class RequestEmblem {
  static readonly OPCODE = 0x6A;
  guild_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x6A);
    w.varint(this.guild_id);
    return w.bytes();
  }

  static decode(r: Reader): RequestEmblem {
    const self = new RequestEmblem();
    self.guild_id = r.varint();
    return self;
  }
}

/**
 * One guild's emblem, as 768 bytes of 16x12 RGBA **this server encoded**.

Not the bytes that were uploaded. `emblem.canonical_rgba` parses the upload into 192 pixels and re-emits them: channel order swapped to what `ImageData` wants, alpha forced to 0 or 255, and any transparent pixel's colour zeroed. So no offset of this buffer is guaranteed to hold the byte that arrived at that offset, and the invisible-payload pixel the original happily stores and re-serves cannot survive the trip. That is the whole reason this frame exists rather than a relay.

An empty `rgba` means 'this guild has no emblem' -- which is also the answer for a guild id that names nothing, deliberately, so the frame is not an oracle for which ids are guilds.

Sent unprompted to the uploader's whole guild when the emblem changes, and in answer to `RequestEmblem`.
 */
export class Emblem {
  static readonly OPCODE = 0xBE;
  guild_id: number = 0;
  rgba: number[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xBE);
    w.varint(this.guild_id);
    w.varint(this.rgba.length);
    for (const item of this.rgba)
      w.varint(item);
    return w.bytes();
  }

  static decode(r: Reader): Emblem {
    const self = new Emblem();
    self.guild_id = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.rgba.push(r.varint());
    }
    return self;
  }
}

/**
 * One guild's symbol file, the 64x128 picture its insignia wears.

`TPacketGCGuildSymbolData` then the stored bytes (`input_login.cpp:831-840`), sent to a client whose `GuildSymbolCRC` names a different copy, and to every connected member when the symbol changes. `crc` is `GetCRC32` of `data` (`crc32.cpp:57-84`), sent so the client can name its copy without computing it.
 */
export class GuildSymbol {
  static readonly OPCODE = 0xCD;
  guild_id: number = 0;
  crc: number = 0;
  data: number[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xCD);
    w.varint(this.guild_id);
    w.u32(this.crc);
    w.varint(this.data.length);
    for (const item of this.data)
      w.varint(item);
    return w.bytes();
  }

  static decode(r: Reader): GuildSymbol {
    const self = new GuildSymbol();
    self.guild_id = r.varint();
    self.crc = r.u32();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.data.push(r.varint());
    }
    return self;
  }
}

/**
 * Ask for the auction board. **Carries nothing at all**, in `Recall`'s own shape, and is also the refresh button.

There is no packet to port here and that is a finding rather than a gap: the auction is reachable in the original only through chat commands (`enroll_auction`, `bid`, `impur`, `get_auctioned_item`, `cancel_auction`, all `GM_PLAYER` in `cmd.cpp:544-551`), and the source says so in its own hand -- `cmd_general.cpp:2448` carries the comment "packet\uc73c\ub85c \ud1b5\uc2e0\ud558\uac8c \ud558\uace0, \uc774\uac74 \uc0ad\uc81c\ud574\uc57c\ud55c\ub2e4", "make it communicate by packet, and this should be deleted". The whole feature is behind `//#define __AUCTION__` (`common/service.h:4`). So the message set below is this port's design, held to this project's own anti-cheat rule rather than to a shape that was never finished.

The original's browse is paged and filtered -- `get_auction_list(ch, start_idx, size, cond)` (`auction_manager.cpp:803-836`) -- and this is not, because the board is one shard's open lots and a page index on the wire is a cursor a client can lie about for nothing in return. If the board ever outgrows one frame the paging belongs here, derived from a cursor the server issued.

The server keeps no record that a panel is open. Every `AuctionBoard` is the answer to something this same client did, so there is no window state to leak, to clean up on logout, or to get out of step with what is drawn.
 */
export class OpenAuction {
  static readonly OPCODE = 0x56;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x56);
    return w.bytes();
  }

  static decode(_r: Reader): OpenAuction {
    const self = new OpenAuction();
    return self;
  }
}

/**
 * Put one bag cell on the auction board.

**It names a cell, never an item.** The original's own entry point takes the opposite -- `do_enroll_auction` reads a `DWORD item_id` off the chat line and hands it to `ITEM_MANAGER::instance().Find(item_id)` (`cmd_general.cpp:2403-2412`) -- which is a global item id, unowned and unchecked, and is precisely the field this project's first rule says to delete. What it would buy a modified client is the ability to auction *somebody else's sword*: `enroll_auction` then calls `item->RemoveFromCharacter()` (`auction_manager.cpp:941`) on whatever it was handed. Deleted here; the server lists whatever is actually in the seller's own `source_slot` and nothing else, which is `MoveItem`'s and `StallListing`'s rule again.

No count either, for `StallListing`'s reason: a stack goes up whole, exactly as `RemoveFromCharacter` takes the whole item.

**No duration.** The clock is `LISTING_DURATION_SECONDS`, which is `ClientManager.cpp:4066`'s unconditional `time(0) + 24 * 60 * 60` -- computed by the db process, never supplied by the enrolling client even there. A field for it would be a field a seller could set to a year, or a bidder's client could set to zero; there is no such field, so there is nothing to check.

The two prices are the seller's own choices and are the only numbers here, in `StallListing.price`'s sense: a starting bid below one is refused, and a `buy_now_price` of zero means no buy-now at all (`immediate_purchase`'s own `get_impur_price() == 0`, `auction_manager.cpp:988-992`).
 */
export class ListLot {
  static readonly OPCODE = 0x57;
  source_slot: number = 0;
  starting_bid: number = 0;
  buy_now_price: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x57);
    w.varint(this.source_slot);
    w.varint(this.starting_bid);
    w.varint(this.buy_now_price);
    return w.bytes();
  }

  static decode(r: Reader): ListLot {
    const self = new ListLot();
    self.source_slot = r.varint();
    self.starting_bid = r.varint();
    self.buy_now_price = r.varint();
    return self;
  }
}

/**
 * Bid on a rendered board row and the total this bidder wants to have standing on it.

`total` is a *whole escrow*, not an amount to add, which is `rebid`'s spelling rather than `bid`'s: the original's client names a target and only the difference from what is already parked is charged (`auction_manager.cpp:1077-1086`, which sends `bid_price - money` to the db process, where `AuctionManager.cpp:703` adds it back on). One entry point covers the first bid and the tenth here, because the original's split exists only to feed a gate that is backwards: `AuctionManager::Bid` refuses whenever `MyBid.GetMoney(...) != 0` and `GetMoney` returns `-1` for "never bid before" (`AuctionManager.cpp:35-48`, `:476`), so as shipped every *first* bid on every lot is refused.

**The gold leaves the bidder the moment this is accepted.** That is the original's own model -- `ch->PointChange(POINT_GOLD, -bid_price, false)` runs in the game process before the db process is even asked (`auction_manager.cpp:969`) -- and it is also what makes a bid something other than a promise. A bid that were only a promise would have to be checked against the bidder's purse again at settlement, and a bidder who had since spent the gold would have held a free option on the lot. With an escrow there is no second check to make and no field on any message that could move one: the money is already the shard's.

There is no amount-and-row pair a client can send that spends somebody else's gold, and no way to bid on behalf of anybody: the bidder is the session.
 */
export class PlaceBid {
  static readonly OPCODE = 0x58;
  board_revision: number = 0;
  slot: number = 0;
  total: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x58);
    w.varint(this.board_revision);
    w.varint(this.slot);
    w.varint(this.total);
    return w.bytes();
  }

  static decode(r: Reader): PlaceBid {
    const self = new PlaceBid();
    self.board_revision = r.varint();
    self.slot = r.varint();
    self.total = r.varint();
    return self;
  }
}

/**
 * End a lot outright at its fixed buy-now price (`immediate_purchase` / `Impur`, `auction_manager.cpp:978-1004`, db `AuctionManager.cpp:504-529`).

A revision-bound board row and nothing else -- above all no price, for `BuyFromStall`'s reason with the same edge: the number is the *seller's* choice, the server holds it, and a buyer-supplied one would be two clients disagreeing about what was owed.

A bidder who already has an escrow on this lot pays the difference rather than being refused. See `auction.buy_now`: the original's `Impur` never touches `MyBid` at all, so a player who bid and then bought the same lot ended up holding two frozen pots under one `bidder_id`, one of which no code path could return.
 */
export class BuyLotNow {
  static readonly OPCODE = 0x59;
  board_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x59);
    w.varint(this.board_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): BuyLotNow {
    const self = new BuyLotNow();
    self.board_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Take whatever a rendered auction-board row owes you. **A revision and a row, never a lot id or role.**

Four different things a player can be owed by one lot -- the item you won, the gold your lot sold for, an unbid lot you want back, and a losing bid you want returned -- and one message, because *which of them you are* is not a client's to assert. The server reads the lot, works out what this session is entitled to, and does that; `AuctionLot.claim` is the same derivation sent ahead of time so the panel can label the button.

This is not tidiness. The original has four entry points and **not one of them checks who is asking**: `actor_id` reaches both `AuctionManager::GetAuctionedItem` (`AuctionManager.cpp:531-557`) and `::CancelAuction` (`:582-602`) and is never compared to `bidder_id` or `offer_id`. Since lot ids are small sequential integers, anybody who could count could collect a stranger's winnings or cancel a lot with somebody else's gold escrowed against it. A message with no role on it cannot be pointed at another player's entitlement, whatever the client does.

The row is bound to the `AuctionBoard.revision` that displayed it. A successful claim advances that revision before the fresh board is sent, so a replayed click and a row shifted by another settlement cannot be redirected to a different lot. Settlement rows stay on the board until every outbid escrow against them has been returned; therefore even that refund can be named by a current board row, never a durable lot id.

The order the server resolves it in is fixed and documented in `auction.AuctionSystem.claim`: winner first, then seller, then a losing bidder. Idempotent -- a second claim finds nothing owed and says so.
 */
export class ClaimLot {
  static readonly OPCODE = 0x5A;
  board_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x5A);
    w.varint(this.board_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): ClaimLot {
    const self = new ClaimLot();
    self.board_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Take one item out of this account's mall and into a bag slot.

`HEADER_CG_MALL_CHECKOUT` / `CInputMain::SafeboxCheckout` with its `bMall` argument true (`input_main.cpp:1757-1850`), whose packet is exactly these two numbers: `bSafePos` and `ItemPos` (`packet.h`'s `TPacketCGSafeboxCheckout`). Both are positions in containers the server already holds, so there is nothing on this message to lie about -- no vnum, no count, no price.

**Nothing ever goes the other way.** `grep -n MALL packet.h` finds `MALL_CHECKOUT`, `MALL_OPEN`, `MALL_SET` and `MALL_DEL` and nothing that deposits, and `SafeboxItemMove` (`input_main.cpp:1852-1861`) calls `GetSafebox()->MoveItem` unconditionally and never `GetMall()`, so the mall's own cells cannot even be rearranged. One verb is the whole surface.

**And there is no purchase.** Nothing in the original's source ever writes a `window='MALL'` row; the mall is filled by whatever charges real money, outside the game entirely (`mall.py`'s docstring). This build has no payment system and this protocol has no message that could stand in for one -- what a player can reach is the storeroom, and how anything gets into it is a seam named in `mall.py` and left open.
 */
export class MallCheckout {
  static readonly OPCODE = 0x5B;
  cell: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x5B);
    w.varint(this.cell);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): MallCheckout {
    const self = new MallCheckout();
    self.cell = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Every open lot on this shard, as this viewer sees them.

Whole, never a delta, for `Shop`'s and `StallWindow`'s reason: a bid names a lot by the server's own id and every number beside it -- the standing price, the minimum raise, what this viewer has parked -- is the server's copy, so a list that had drifted would be a player bidding against a price nobody is charging.

**Sent only in answer to something this client did**: `OpenAuction`, or its own listing, bid, buy-now or claim. Nothing else pushes one, so the panel can open on any frame it receives and the server needs no record that a window is open. What reaches a player unprompted is `AuctionNews`, which is an event and does not open anything.

`seconds_left` is a duration rather than a deadline; see `AuctionLot`.
 */
export class AuctionBoard {
  static readonly OPCODE = 0xB5;
  revision: number = 0;
  lots: AuctionLot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB5);
    w.varint(this.revision);
    w.varint(this.lots.length);
    for (const item of this.lots)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): AuctionBoard {
    const self = new AuctionBoard();
    self.revision = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.lots.push(AuctionLot.decode(r));
    }
    return self;
  }
}

/**
 * This account's item mall, whole.

Sent on join and again after every checkout, in `Safebox`'s own shape. There is no open message and no password, and both absences are decisions rather than oversights.

The original opens the mall with `/mall_password` (`do_mall_password`, `cmd_general.cpp:917-946`), which reads the same account-scoped password column the safebox does -- `HEADER_GD_MALL_LOAD` and `HEADER_GD_SAFEBOX_LOAD` are one handler with a boolean flipped (`ClientManager.cpp:2167-2186`). `/mall_password` is here and reads that column -- `logins.safebox_password` -- through the same `safebox.password_accepted`. It has no frame of its own because the mall arrives with the bag rather than on request: the storeroom keeps its prompt because it also has an NPC to stand in front of and a page to rent. The ten-second reopen cooldown (`GetMallLoadTime()`, `cmd_general.cpp:930-934`) rate-limits a database load that does not happen here -- these rows come in with the bag.

An empty array is the normal case and is not an error: see `MallSlot` on where the items would come from.
 */
export class MallWindow {
  static readonly OPCODE = 0xB6;
  cells: MallSlot[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB6);
    w.varint(this.cells.length);
    for (const item of this.cells)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): MallWindow {
    const self = new MallWindow();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.cells.push(MallSlot.decode(r));
    }
    return self;
  }
}

/**
 * Something happened to a lot you have money or an item in. **Sent to one player, unprompted.**

`StallSold`'s counterpart, and needed for a sharper reason than that one: an auction is the one place in this build where a player's gold can be *stuck*. An outbid bidder's escrow stays parked until they reclaim it (`bid_cancel`, `auction_manager.cpp:1090-1119`), the original returns it automatically nowhere, and a player who was never told they had been outbid would have no reason to go and look.

An event, not a state: nothing stores it, it opens no panel, and the board it describes is fetched with `OpenAuction` like any other. The original's own version of this is a chat line.
 */
export class AuctionNews {
  static readonly OPCODE = 0xB7;
  lot: number = 0;
  event: number = 0;
  name: string = "";
  amount: number = 0;
  other_name: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xB7);
    w.varint(this.lot);
    w.varint(this.event);
    w.string(this.name);
    w.varint(this.amount);
    w.string(this.other_name);
    return w.bytes();
  }

  static decode(r: Reader): AuctionNews {
    const self = new AuctionNews();
    self.lot = r.varint();
    self.event = r.varint();
    self.name = r.string();
    self.amount = r.varint();
    self.other_name = r.string();
    return self;
  }
}

/**
 * Use what is in one bag cell on what is in another. Two cells and nothing else.

`HEADER_CG_ITEM_USE_TO_ITEM` (`packet.h:45`) dispatches through `CInputMain::ItemToItem` (`input_main.cpp:816-820`) to `CHARACTER::UseItem(Cell, DestCell)`, whose `TPacketCGItemUseToItem` (`packet.h:644-649`) is exactly this: a source `TItemPos` and a destination one, `BYTE header` aside. `UseItemEx`'s switch on the source cell's item type (`char_item.cpp:1602` onward) has a branch for a marriage ring, for a handful of `ITEM_UNIQUE` combinations, and for `ITEM_TREASURE_KEY` -- only the last of which this build wires: 279 `special_item_group.txt` chests are imported and rolled (`drops.open_group`), and two of them, `50006` and `50007`, are `ITEM_TREASURE_BOX` locks that only a matching `ITEM_TREASURE_KEY` (`50008`, `50009`) can open. A source cell holding anything else is refused the same way an unrecognised `UseItem` is.

**No vnum, no item id, and above all no result.** `slot` and `dest` are bag cell indices, the same two numbers `MoveItem` already carries and for the identical reason: a field naming what is in a cell is a field a modified client could lie about, and a field naming what a locked box pays is a field that would let a client pick the best row in the table instead of the one the server rolled. Which chest opens is read off `dest`'s own item at the moment this arrives; what it pays is `drops.open_group`, seeded from the entity, the tick and both cells, so a replayed opening pays what was disputed rather than a fresh roll.

`slot` names the key and `dest` the lock, not the other way round -- the same source/destination order `MoveItem` uses, and the order `TPacketCGItemUseToItem` itself declares (`Cell` before `TargetCell`, `packet.h:646-648`).
 */
export class UseItemToItem {
  static readonly OPCODE = 0x74;
  slot: number = 0;
  dest: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x74);
    w.varint(this.slot);
    w.varint(this.dest);
    return w.bytes();
  }

  static decode(r: Reader): UseItemToItem {
    const self = new UseItemToItem();
    self.slot = r.varint();
    self.dest = r.varint();
    return self;
  }
}

/**
 * Offer one live bag item to one live NPC/BUILDING. This is a dedicated browser gesture, deliberately not a variant of `UseItemToItem`: its two fields can represent only a bag cell and an entity candidate, never a cell/cell target, a target-kind bit, an item vnum, or a result.

The original's `CHARACTER::ReceiveItem` passes the target's `GetRaceNum()` and held item to `CQuestManager::TakeItem` (`char_item.cpp:6583-6666`); that method installs the current item before it invokes the NPC take event (`questmanager.cpp:610-628`). The furnace clauses then compare `npc.race` and `item.vnum` (`guild_building_melt.quest:121-142`). Here `slot` is re-read from the sender's live bag and `npc_id` is re-resolved as an in-range NPC/BUILDING before that same context is exposed to the quest.
 */
export class UseItemToNpc {
  static readonly OPCODE = 0x79;
  slot: number = 0;
  npc_id: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x79);
    w.varint(this.slot);
    w.varint(this.npc_id);
    return w.bytes();
  }

  static decode(r: Reader): UseItemToNpc {
    const self = new UseItemToNpc();
    self.slot = r.varint();
    self.npc_id = r.varint();
    return self;
  }
}

/**
 * Rename one rank and say whether it may invite (`ChangeGradeName`, `guild.cpp:783-829`; `ChangeGradeAuth`, `:831-869`).

**It names a grade index, never a permission set.** That is the whole anti-cheat argument for the rank half of this feature and it is worth spelling out, because the obvious design is the exploit: a message carrying "my authority is X" is a message a modified client sends with X set to everything, and no amount of server-side checking recovers from a protocol that lets a player describe their own permissions. Here a client can say only *which row of the table* to edit and what that row should contain, and the server decides whether the sender may edit the table at all by reading the sender's own stored grade. A member's authority is entirely a function of their grade (`guild.h:232`), and a grade is changed only by `GuildPromote`, which is master-only.

Master only (`input_main.cpp:2327, 2353`), and grade 1 is refused outright: it cannot be renamed (`guild.cpp:785`) and cannot be re-authorised (`:833`), because the master's rank is the definition of the master and a rank table that could take `ADD_MEMBER` away from grade 1 is one a guild can lock itself out of.

The four authority columns of the grade page (`guildwindow_gradepage.py:23-38`) each travel as one named boolean, not as the original's raw `auth` byte (`guild.cpp:846`) that is stored unmasked, so bits 4-7 arrive from a client and become permissions nobody granted the day a fifth bit is defined. Named booleans carry no undefined bit, and the panel states the rank's whole authority at once: `may_invite`, `may_kick`, `may_notice` and `may_skill` together are the complete new `Auth` for the row, so the server sets exactly them (masked to the four defined bits) rather than preserving anything -- the client already knows the current state from `GuildGrade` and sends it back whole. The server still decides whether the sender may edit the table at all by reading the sender's own stored grade.
 */
export class GuildRank {
  static readonly OPCODE = 0x49;
  grade: number = 0;
  name: string = "";
  may_invite: boolean = false;
  may_kick: boolean = false;
  may_notice: boolean = false;
  may_skill: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x49);
    w.u8(this.grade);
    w.string(this.name);
    w.boolean(this.may_invite);
    w.boolean(this.may_kick);
    w.boolean(this.may_notice);
    w.boolean(this.may_skill);
    return w.bytes();
  }

  static decode(r: Reader): GuildRank {
    const self = new GuildRank();
    self.grade = r.u8();
    self.name = r.string();
    self.may_invite = r.boolean();
    self.may_kick = r.boolean();
    self.may_notice = r.boolean();
    self.may_skill = r.boolean();
    return self;
  }
}

/**
 * Move one member to another rank (`ChangeMemberGrade`, `guild.cpp:1134-1176`, `input_main.cpp:2456-2474`).

**It names a roster slot, not a player.** `slot` indexes the `members` array of the last `Guild` frame this client was sent, which is the same order the server holds (`guild.Guild.members()`, join order, master first, kept by `guild_members.seat`). So there is no account id here and no character name: `GuildMember` deliberately carries neither -- see its own doc -- and a promotion that named a player by identity would be a message that can aim at somebody the sender cannot see and, worse, a message that needs an identity to be published on thirty-two other people's wires for it to be usable at all.

`roster_revision` is the server-issued revision beside that frame's rows. A row plus a stale revision is refused before it becomes an identity, so a membership change cannot retarget a queued click.

Master only, and there is no `auth` field: a member's permissions are their rank's, so this message *is* the whole of granting anything, and it can grant only what the rank table already says. Grade 1 cannot be assigned here (`guild.cpp:1136`, `input_main.cpp:2469`) -- handing the guild over is `GuildHandOver`, which is a different sentence because it is a different act. And the range is checked, which the original does not: `ChangeMemberGrade` refuses grade 1 and nothing else, so a client sending 200 stores 200 and every later `HasGradeAuth` reads 240 bytes past the end of a 15-element array (`guild.h:232`) -- see `guild.Refusal.BAD_GRADE`.
 */
export class GuildPromote {
  static readonly OPCODE = 0x4B;
  roster_revision: number = 0;
  slot: number = 0;
  grade: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x4B);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    w.u8(this.grade);
    return w.bytes();
  }

  static decode(r: Reader): GuildPromote {
    const self = new GuildPromote();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    self.grade = r.u8();
    return self;
  }
}

/**
 * Select or clear the member in one displayed roster row as a guild general (`GUILD_SUBHEADER_CG_CHANGE_MEMBER_GENERAL`, `input_main.cpp:2484-2505`; `guild.cpp:1088-1127`). The request names only the roster revision, row and desired state; the server refuses a changed roster before resolving the persistent member, master authority and one-general cap.
 */
export class GuildGeneral {
  static readonly OPCODE = 0x71;
  roster_revision: number = 0;
  slot: number = 0;
  assign: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x71);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    w.boolean(this.assign);
    return w.bytes();
  }

  static decode(r: Reader): GuildGeneral {
    const self = new GuildGeneral();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    self.assign = r.boolean();
    return self;
  }
}

/**
 * Throw the member in one displayed roster row out of the sender's guild (`input_main.cpp:2268-2315`; `guild.cpp:184-200`).

**It names a roster row, never a player.** The original packet carries a persistent player id (`input_main.cpp:2276`), but this client neither receives nor stores one on `GuildMember`. `slot` indexes the `members` array of the last `Guild` frame, in the same stable join order used by `GuildPromote`. The server turns that row into the account identity at handling time. A modified client therefore cannot aim outside the roster it was shown.

There is no permission, guild id, war state, target grade, or online flag on this request. The original reads the actor's stored `GUILD_AUTH_REMOVE_MEMBER` bit for both online and offline targets (`input_main.cpp:2292, 2303`), freezes removal during a war (`:2270-2274`), and `RequestRemoveMember` refuses grade 1 (`guild.cpp:184-200`). Every one is server state here too.

`roster_revision` binds the row to the roster frame which supplied it. A membership change makes an old row unrepresentable as a current target, without publishing a player identity.
 */
export class GuildExpel {
  static readonly OPCODE = 0x65;
  roster_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x65);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): GuildExpel {
    const self = new GuildExpel();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Make another member the master (`guild.cpp:2069-2081`, `change_guild_master.quest:45`).

Its own message rather than `GuildPromote` with grade 1, for the reason `GuildDisband` is not `GuildLeave`: this is the second irreversible button in this protocol. The sender stops being the master in the same call, drops to grade 15 (`db/GuildManager.cpp:1189-1196`), and cannot take it back -- only the new master can hand it anywhere. Folding it into the demotion message would mean a slip of one row in a rank dropdown gives away a guild bank.

It names a roster slot and its server-issued revision for `GuildPromote`'s reason, carries no confirmation flag for `GuildDisband`'s (a boolean that has to be true is a check the client performs on the server's behalf), and carries no guild id because the guild is read off the sender.

The original's own caller adds a level requirement on the new master -- `change_guild_master.quest:45` passes 40 through a quest function whose other four limits are all zero. Not ported: it is a parameter of one script rather than a property of guilds, and `guild.py` says so where the rule lives.
 */
export class GuildHandOver {
  static readonly OPCODE = 0x4C;
  roster_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x4C);
    w.varint(this.roster_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): GuildHandOver {
    const self = new GuildHandOver();
    self.roster_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Move gold between a player's purse and the guild's (`RequestDepositMoney`, `guild.cpp:1779-1804`; `RequestWithdrawMoney`, `:1806-1832`).

**There is no recipient field, and that absence is the feature.** A withdrawal pays `guild.Guild.master` -- read off the guild at the moment of the withdrawal, exactly as `RecvWithdrawMoneyGive` hands the gold to `GetMasterCharacter()` (`guild.cpp:1852-1860`) -- so "pay it to somebody else" has nowhere to be written. The guild bank is the only container in this game whose contents were put there by people other than the one taking them out, which is why the payee is derived rather than asked for.

**There is no guild id either.** Which guild is read off the sender's membership, as every other guild request in this protocol does, so a request cannot be aimed at a bank the sender does not belong to.

One message with a direction rather than two opcodes, because the two halves are the same request read from opposite ends and the original itself gates both on one clock -- `CanDeposit` (`char.cpp:6611`) covers deposit *and* withdrawal, five minutes per character either way (`char.cpp:6606`).

`amount` is what the player asked for and not what will move: deposits clamp to `DEPOSIT_LIMIT` (`input_main.cpp:2215`, a `std::min`) and withdrawals to `WITHDRAW_LIMIT` (`:2238`), and the clamp happens before affordability is tested so a rich player's oversized deposit is trimmed rather than refused. Any member may deposit, at any rank -- the original checks nothing but membership -- and only the master may withdraw (`guild.cpp:1814`), tested against the stored grade at the moment of the withdrawal rather than against anything the session remembers.

The original's handlers for both halves are **switched off**: `input_main.cpp:2213` and `:2236` are bare early returns above the bodies, under a comment saying guild money cannot be moved "for now". The rules here are the code behind those two returns.
 */
export class GuildBank {
  static readonly OPCODE = 0x4D;
  amount: number = 0;
  withdraw: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x4D);
    w.varint(this.amount);
    w.boolean(this.withdraw);
    return w.bytes();
  }

  static decode(r: Reader): GuildBank {
    const self = new GuildBank();
    self.amount = r.varint();
    self.withdraw = r.boolean();
    return self;
  }
}

/**
 * Burn your own character experience to raise the guild's level (`CGuild::OfferExp`, `guild.cpp:903-966`, `input_main.cpp:2368-2391`).

This is the *only* way a guild gains experience anywhere in the original: no share of what members kill, no daily tick, no quest reward. Somebody stands at the guild manager and spends their own levelling progress, and `guild_member.offered_exp` -- cumulative, never reduced (`guild.cpp:936`) -- is the contribution table that results. Worth stating because "kills raise the guild's level" is the intuitive design and is not this game's.

`amount` is the **character** experience offered, not the guild experience it buys. The conversion is a hundred to one (`guild.cpp:932-936`) and is the server's arithmetic: a message that carried the guild experience would be a client asserting how much its own spending is worth. The request is floored to a multiple of 100 first (`input_main.cpp:2378` does `offer /= 100; offer *= 100;`), so 199 offered spends 100 and buys 1, and 99 offered is refused rather than quietly costing 99 for nothing.

No guild id and no member slot: the guild is the sender's, and the contribution is credited to the sender. Both are read off the connection, so an offering cannot be made in somebody else's name -- which matters more than it looks, since the contribution table is what a master reads before deciding who to promote.
 */
export class GuildOffer {
  static readonly OPCODE = 0x4E;
  amount: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x4E);
    w.varint(this.amount);
    return w.bytes();
  }

  static decode(r: Reader): GuildOffer {
    const self = new GuildOffer();
    self.amount = r.varint();
    return self;
  }
}

/**
 * Spend one guild-earned point on a guild skill. The vnum selects only one of the seven imported slots; guild, points and level are server state.
 */
export class GuildSkillUp {
  static readonly OPCODE = 0x54;
  skill: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x54);
    w.u8(this.skill);
    return w.bytes();
  }

  static decode(r: Reader): GuildSkillUp {
    const self = new GuildSkillUp();
    self.skill = r.u8();
    return self;
  }
}

/**
 * Use a guild skill. The vnum selects an imported guild row; cost, cooldown, level, targets and guild remain server-owned.
 */
export class GuildUseSkill {
  static readonly OPCODE = 0x55;
  skill: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x55);
    w.u8(this.skill);
    return w.bytes();
  }

  static decode(r: Reader): GuildUseSkill {
    const self = new GuildUseSkill();
    self.skill = r.u8();
    return self;
  }
}

/**
 * Restore shared Dragon Ghost by spending this player's gold (`GUILD_SUBHEADER_CG_CHARGE_GSP`, `input_main.cpp:2393-2407`; `CGuild::ChargeSP`, `guild.cpp:1702-1725`).

`amount` is the **requested Ghost points**, never gold, never the remaining pool, never the resulting power, and never a guild id. The original Python binding is `SendGuildChargeGSPPacket(iGSP)` (`PythonNetworkStreamModule.cpp:1487-1494`) and the UI types a Ghost amount (`uiguild.py:1871-1901`); gold is `amount * 100` (`constinfo.py:40`, `input_main.cpp:2396`). The handler checks the requested price against the live purse *before* `ChargeSP` clamps the restored points to the remaining pool, so an oversized request that the player cannot afford in full is refused even when a smaller refill would fit. Membership is read off the connection; any member may pay.

The cheats this shape deletes: asserting a gold charge, a resulting power total, a guild id, or a restoration that was never paid for.
 */
export class GuildChargePower {
  static readonly OPCODE = 0x7A;
  amount: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x7A);
    w.varint(this.amount);
    return w.bytes();
  }

  static decode(r: Reader): GuildChargePower {
    const self = new GuildChargePower();
    self.amount = r.varint();
    return self;
  }
}

/**
 * Buy the vacant guild plot the sender is standing inside. **No plot id, map or coordinates cross the wire**: `guild_building.quest:17` derives `land_id` from `pc.get_map_index()` and the character's live position before it reads price, owner or guild-level limit, and the server repeats that lookup when this intent arrives.
 */
export class GuildBuyLand {
  static readonly OPCODE = 0x3A;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x3A);
    return w.bytes();
  }

  static decode(_r: Reader): GuildBuyLand {
    const self = new GuildBuyLand();
    return self;
  }
}

export class GuildPlaceBuilding {
  static readonly OPCODE = 0x3B;
  vnum: number = 0;
  x: number = 0;
  y: number = 0;
  rotation: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x3B);
    w.varint(this.vnum);
    w.svarint(this.x);
    w.svarint(this.y);
    w.svarint(this.rotation);
    return w.bytes();
  }

  static decode(r: Reader): GuildPlaceBuilding {
    const self = new GuildPlaceBuilding();
    self.vnum = r.varint();
    self.x = r.svarint();
    self.y = r.svarint();
    self.rotation = r.svarint();
    return self;
  }
}

/**
 * Upgrade one row in the current server-published guild-land state. The request carries a rendered row and its revision, never the durable building object id.
 */
export class GuildUpgradeBuilding {
  static readonly OPCODE = 0x3F;
  land_revision: number = 0;
  slot: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x3F);
    w.varint(this.land_revision);
    w.varint(this.slot);
    return w.bytes();
  }

  static decode(r: Reader): GuildUpgradeBuilding {
    const self = new GuildUpgradeBuilding();
    self.land_revision = r.varint();
    self.slot = r.varint();
    return self;
  }
}

/**
 * Go through the dungeon door you are standing at, or -- if you are already inside one -- come back out. **No fields at all**, which is the whole message.

**The field that is not here is the destination.** `CInputMain::Warp` in the original reads an `x` and a `y` off `TPacketCGWarp` (`packet.h:1400-1403`) and hands them to `CHARACTER::WarpSet` once a distance test against the character's own position has passed (`input_main.cpp:1274-1290`). That test is the only thing between a client-supplied coordinate and arriving there, and a test is precisely what this build has decided not to rely on: `input_main.cpp:1279` is the line this architecture exists to delete. So the client says only *that* it is using a door, and which door is the server's reading of the character's own position -- the nearest entity carrying `ENTITY_DUNGEON_DOOR` within talking range, the same resolution `ClickNpc` already makes. A modified client cannot name a map it may not enter, a coordinate inside one, or a door it is not standing at, because none of the three has a field.

**One message for going in and for coming out**, which is `Mine`'s shape and `Fish`'s: `CHARACTER::mining`'s first statement cancels the swing it would otherwise start (`char.cpp:3799-3803`), and one opcode both casts and pulls a fishing line (`char.cpp:3834-3838`). Here the server already knows which of the two this is -- a character on a dungeon floor is leaving it, a character standing at a door is entering -- so a second message would only give a client something to be wrong about. Coming out is `CHARACTER::ExitToSavedLocation` (`char.cpp:5020-5028`), which reads `m_posWarp` and `m_lWarpMapIndex` off the character and has never taken an argument; the field that is not here on *that* half is the return point, and it would be worth more to a cheat than the entry coordinate -- a way out that named where it came out is a free scroll of return to anywhere, usable from inside a dungeon.
 */
export class UseDungeonDoor {
  static readonly OPCODE = 0x63;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x63);
    return w.bytes();
  }

  static decode(_r: Reader): UseDungeonDoor {
    const self = new UseDungeonDoor();
    return self;
  }
}

/**
 * Where the recipient stands with respect to dungeons: the door in front of them, or the floor they are on.

One frame for both halves because a client only ever has one of them: you are either outside looking at a way in, or inside looking at what you have done since you arrived. Sent on change rather than on a timer -- walking into and out of a door's range is a change, entering and leaving are changes, and a kill inside is a change.

**`instance` is the original's own private-map index, and sending it is not decoration.** `SECTREE_MANAGER::CreatePrivateMap` numbers a clone `origin * 10000 + slot` (`sectree_manager.cpp:908-985`), and every shipped dungeon script tests that number rather than the map: `pc.get_map_index() >= 660000 and < 670000` is how `deviltower_zone.quest:44` asks "am I in a Devil's Tower instance" as opposed to "am I on the Devil's Tower map". Telling the client the number costs nothing a modified client could spend, because it is an answer and there is no message that takes one.

Nothing here is anybody else's: a floor's kill counts and headcount go to the people standing on it, the rule `Standing` and `Spirit` already follow.
 */
export class DungeonState {
  static readonly OPCODE = 0xBA;
  inside: boolean = false;
  name: string = "";
  instance: number = 0;
  members: number = 0;
  mob_kills: number = 0;
  stone_kills: number = 0;
  elapsed_s: number = 0;
  door: number = 0;
  min_level: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xBA);
    w.boolean(this.inside);
    w.string(this.name);
    w.varint(this.instance);
    w.varint(this.members);
    w.varint(this.mob_kills);
    w.varint(this.stone_kills);
    w.varint(this.elapsed_s);
    w.varint(this.door);
    w.varint(this.min_level);
    return w.bytes();
  }

  static decode(r: Reader): DungeonState {
    const self = new DungeonState();
    self.inside = r.boolean();
    self.name = r.string();
    self.instance = r.varint();
    self.members = r.varint();
    self.mob_kills = r.varint();
    self.stone_kills = r.varint();
    self.elapsed_s = r.varint();
    self.door = r.varint();
    self.min_level = r.varint();
    return self;
  }
}

/**
 * Choose O or X for one question the server has already issued. The message carries exactly the server's opaque question token and the one-bit choice: no question text, question index, claimed correctness, reaction time, position or prize. The original judges the same binary choice by reading which rectangle the character occupies (`OXEvent.cpp:264-305`); a browser button makes that choice explicit while leaving every fact that could pay out on the server.
 */
export class OXAnswer {
  static readonly OPCODE = 0x78;
  token: number = 0;
  answer: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x78);
    w.varint(this.token);
    w.boolean(this.answer);
    return w.bytes();
  }

  static decode(r: Reader): OXAnswer {
    const self = new OXAnswer();
    self.token = r.varint();
    self.answer = r.boolean();
    return self;
  }
}

/**
 * The map's own outdoor environment, sent once after join and never again; there is deliberately no client-to-server counterpart and no clock on either side. A 2014 map's lighting is the `Environment` row of its own `setting.txt` (`MapOutdoorLoad.cpp:47-63`): `metin2_map_t3`/`_t4` name `moonlight05.msenv`, the rest a daylight file. Nothing switches it while a map is loaded -- `CPythonBackground::ChangeToDay`/`ChangeToNight` (`PythonBackground.cpp:789-797`) only write `m_iDayMode`, which no code reads and no Python binding exposes, and `HEADER_GC_TIME` (`input_login.cpp:584-587`) is a login clock sync kept by `SetServerTime` for durations (`PythonNetworkStreamPhaseGame.cpp:3883-3893`), not for lighting.
 */
export class Environment {
  static readonly OPCODE = 0xCA;
  night: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xCA);
    w.boolean(this.night);
    return w.bytes();
  }

  static decode(r: Reader): Environment {
    const self = new Environment();
    self.night = r.boolean();
    return self;
  }
}

/**
 * The deployment-selected weather pass. It is sent after join and has no client-to-server counterpart: the original background exposes only `EnableSnowEnvironment` / `DisableSnowEnvironment` (`PythonBackground.cpp:811-818`), and its snow pool emits flakes only while enabled (`GameLib/SnowEnvironment.cpp:24-85`). Zero is clear; one is snow. A browser cannot select either value.
 */
export class Weather {
  static readonly OPCODE = 0xCB;
  kind: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xCB);
    w.u8(this.kind);
    return w.bytes();
  }

  static decode(r: Reader): Weather {
    const self = new Weather();
    self.kind = r.u8();
    return self;
  }
}

/**
 * The server-selected outdoor BGM state. The old server puts a map's BGM name and factor into its main-character packet (`char.cpp:1454-1497`) and the old client multiplies that factor by its local slider (`root/game.py:202-210`). This frame carries only a closed track number from the browser package and a server factor; there is no client request because a browser must not name a media path or decide what map music it hears. It is sent after every join and arrival, and again when the operator changes the legacy xmas_song flag.
 */
export class FieldMusic {
  static readonly OPCODE = 0xCC;
  track: number = 0;
  volume_percent: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xCC);
    w.u8(this.track);
    w.u8(this.volume_percent);
    return w.bytes();
  }

  static decode(r: Reader): FieldMusic {
    const self = new FieldMusic();
    self.track = r.u8();
    self.volume_percent = r.u8();
    return self;
  }
}

/**
 * A server-issued browser anti-bot challenge reusing the legacy semantic opcode value 206 (`client/src/UserInterface/Packet.h:337-339`). This is not native packet compatibility: the legacy binary layout carries a one-byte duration, a 2048-byte captcha, and a fixed 256-byte quiz (`Packet.h:2612-2619`), while this browser message carries only the duration and length-delimited quiz text read by the legacy Python window (`root/uiautoban.py:64-85`). The frame is server-to-client only; answers remain ordinary chat commands exactly as `uiautoban.py:116-126` sends them.
 */
export class AutoBanQuiz {
  static readonly OPCODE = 0xCE;
  duration_seconds: number = 0;
  quiz: string = "";

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xCE);
    w.u8(this.duration_seconds);
    w.string(this.quiz);
    return w.bytes();
  }

  static decode(r: Reader): AutoBanQuiz {
    const self = new AutoBanQuiz();
    self.duration_seconds = r.u8();
    self.quiz = r.string();
    return self;
  }
}

/**
 * The complete read-only answer to the existing SAY command `/minfo` (`cmd.cpp:497`, `cmd_general.cpp:1664-1690`). The legacy command emits one heading and three chat lines; this browser-specific GC snapshot carries the same three throne names as structured data so its panel never parses presentation text. There is deliberately no corresponding CG message: the request remains ordinary SAY and cannot name an empire, ruler, balance, candidate or vote.

`treasury_visible` reproduces the only private branch in the source: the seated ruler sees the treasury of their own empire, and everyone else sees none. Hidden money is encoded as zero as well as being marked invisible, so a modified browser cannot recover it by ignoring a display flag. The underlying arrays are the four-slot `TMonarchInfo` (`common/tables.h:1268-1274`), but slot zero is not an empire and exactly three seats cross this wire.
 */
export class MonarchInfo {
  static readonly OPCODE = 0xCF;
  treasury_visible: boolean = false;
  treasury: number = 0;
  seats: MonarchSeat[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xCF);
    w.boolean(this.treasury_visible);
    w.varint(this.treasury);
    w.varint(this.seats.length);
    for (const item of this.seats)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): MonarchInfo {
    const self = new MonarchInfo();
    self.treasury_visible = r.boolean();
    self.treasury = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.seats.push(MonarchSeat.decode(r));
    }
    return self;
  }
}

/**
 * One OX statement, sent only after the operator asks it. The bank never crosses the wire: `COXEventManager::Quiz` selects one row and broadcasts only that row (`OXEvent.cpp:233-260`). `token` binds a later click to this round; it is issued by the server and has no client-chosen part. The correct answer is deliberately absent until `OXResult`, matching the original timer which reveals it only after the answer window (`OXEvent.cpp:199-218`).
 */
export class OXQuestion {
  static readonly OPCODE = 0xD0;
  token: number = 0;
  text: string = "";
  remaining_ms: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xD0);
    w.varint(this.token);
    w.string(this.text);
    w.varint(this.remaining_ms);
    return w.bytes();
  }

  static decode(r: Reader): OXQuestion {
    const self = new OXQuestion();
    self.token = r.varint();
    self.text = r.string();
    self.remaining_ms = r.varint();
    return self;
  }
}

/**
 * The human-visible outcome of one answered or missed question. The correct answer may appear here because the round is closed: the original announces `Yes (O)` or `No (X)` immediately after checking everybody (`OXEvent.cpp:205-218`). `survivors` is the remaining attender count, not a prize and not authority.
 */
export class OXResult {
  static readonly OPCODE = 0xD1;
  token: number = 0;
  outcome: number = 0;
  effect: number = 0;
  correct_answer: boolean = false;
  survivors: number = 0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xD1);
    w.varint(this.token);
    w.u8(this.outcome);
    w.u8(this.effect);
    w.boolean(this.correct_answer);
    w.varint(this.survivors);
    return w.bytes();
  }

  static decode(r: Reader): OXResult {
    const self = new OXResult();
    self.token = r.varint();
    self.outcome = r.u8();
    self.effect = r.u8();
    self.correct_answer = r.boolean();
    self.survivors = r.varint();
    return self;
  }
}

/**
 * Advance the reset-scroll dialogue the server has just issued. No fields: in particular no slot, item id, present statistic, level, price or proposed result. `reset_scroll.quest:3-29` reads the scroll from the character, asks twice, removes that live item, then calls `pc.reset_point`; `questlua_pc.cpp:723-726` supplies the current character and level. This packet therefore cannot name a different scroll or assert a new sheet; the remembered offer is re-read from the bag when it is accepted.
 */
export class StatusReset {
  static readonly OPCODE = 0x15;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0x15);
    return w.bytes();
  }

  static decode(_r: Reader): StatusReset {
    const self = new StatusReset();
    return self;
  }
}

/**
 * Open the first reset confirmation. It carries no client-computable quote because the server has already found the one reset scroll in the cell selected by `UseItem`; the browser only decides whether to send the fieldless continuation. The shipped quest asks this exact first question before it enters the final confirmation (`reset_scroll.quest:3-18`).
 */
export class StatusResetOffer {
  static readonly OPCODE = 0xF0;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xF0);
    return w.bytes();
  }

  static decode(_r: Reader): StatusResetOffer {
    const self = new StatusResetOffer();
    return self;
  }
}

/**
 * Open the final irreversible reset confirmation. It has no item, statistic, price or result: the scroll is still the cell remembered from `UseItem` and the result is still server-derived. The original does not remove 71002/76001 until both answers have accepted (`reset_scroll.quest:12-25`), so this distinct frame makes the browser show both questions instead of turning a scroll click into a one-click permanent action.
 */
export class StatusResetConfirm {
  static readonly OPCODE = 0xF1;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xF1);
    return w.bytes();
  }

  static decode(_r: Reader): StatusResetConfirm {
    const self = new StatusResetConfirm();
    return self;
  }
}

/**
 * A quest coroutine is suspended in `input()`. The page contains the script-authored speech that preceded the call and the token which is the only authority a reply returns. The original emits `[INPUT]` when it enters `SUSPEND_STATE_INPUT` (`questlua.cpp:699-706`) and its client sends the edit line only when that dialogue closes (`uiquest.py:353-360`). A zero token closes a stale prompt.
 */
export class QuestInputPrompt {
  static readonly OPCODE = 0xE0;
  token: number = 0;
  title: string = "";
  max_bytes: number = 0;
  lines: QuestLine[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xE0);
    w.varint(this.token);
    w.string(this.title);
    w.varint(this.max_bytes);
    w.varint(this.lines.length);
    for (const item of this.lines)
      item.encode(w);
    return w.bytes();
  }

  static decode(r: Reader): QuestInputPrompt {
    const self = new QuestInputPrompt();
    self.token = r.varint();
    self.title = r.string();
    self.max_bytes = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.lines.push(QuestLine.decode(r));
    }
    return self;
  }
}

/**
 * One blocking quest yes/no question. The target receives a nonzero token, text and remaining duration; the requester receives a tokenless frame with `waiting` true and no answer buttons. This is the browser form of `ConfirmWithMsg`, which sends message, timeout and requester PID (`char.cpp:6293-6305`), with the PID replaced by an opaque token so it cannot return on the answer. Token zero closes a non-waiting prompt and represents the tokenless waiting face.
 */
export class QuestConfirmPrompt {
  static readonly OPCODE = 0xE1;
  token: number = 0;
  text: string = "";
  remaining_ms: number = 0;
  waiting: boolean = false;

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xE1);
    w.varint(this.token);
    w.string(this.text);
    w.varint(this.remaining_ms);
    w.boolean(this.waiting);
    return w.bytes();
  }

  static decode(r: Reader): QuestConfirmPrompt {
    const self = new QuestConfirmPrompt();
    self.token = r.varint();
    self.text = r.string();
    self.remaining_ms = r.varint();
    self.waiting = r.boolean();
    return self;
  }
}

/**
 * Open the quest item chooser. `cells` are the server's view of the eligible bag rows and are display advice only; the reply still carries one cell and the resumed script re-reads that live cell. The original client filters for metin stones of grade at most two (`uiselectitem.py:63-80`) and sends zero on Cancel (`:43-46`). Token zero closes a stale chooser.
 */
export class QuestItemPrompt {
  static readonly OPCODE = 0xE2;
  token: number = 0;
  cells: number[] = [];

  encode(): Uint8Array {
    const w = new Writer();
    w.u8(0xE2);
    w.varint(this.token);
    w.varint(this.cells.length);
    for (const item of this.cells)
      w.varint(item);
    return w.bytes();
  }

  static decode(r: Reader): QuestItemPrompt {
    const self = new QuestItemPrompt();
    self.token = r.varint();
    {
      const count = r.collectionLength();
      for (let i = 0; i < count; i++)
        self.cells.push(r.varint());
    }
    return self;
  }
}

export const Opcode = {
  Hello: 0x01,
  Join: 0x02,
  Login: 0x07,
  SelectEmpire: 0x76,
  Input: 0x03,
  Chat: 0x04,
  Attack: 0x06,
  PickUp: 0x08,
  UseItem: 0x09,
  DropItem: 0x0A,
  DropGold: 0x73,
  MoveItem: 0x32,
  EquipItem: 0x0B,
  Unequip: 0x0C,
  SellItem: 0x0D,
  BuyItem: 0x16,
  CloseShop: 0x17,
  SpendPoint: 0x0F,
  SetPvpMode: 0x0E,
  UseSkill: 0x10,
  SkillUp: 0x11,
  ClickNpc: 0x12,
  QuestReply: 0x13,
  QuestInfo: 0x14,
  QuestInputAnswer: 0x6C,
  QuestConfirmAnswer: 0x6D,
  QuestItemAnswer: 0x6E,
  Ping: 0x05,
  RefineInfo: 0x18,
  Refine: 0x19,
  ExchangeStart: 0x1A,
  ExchangeOffer: 0x1B,
  ExchangeWithdraw: 0x1C,
  ExchangeGold: 0x1D,
  ExchangeAccept: 0x1E,
  ExchangeCancel: 0x1F,
  OpenSafebox: 0x20,
  SafeboxUnlock: 0x21,
  SafeboxDeposit: 0x22,
  SafeboxWithdraw: 0x23,
  SafeboxMove: 0x24,
  CloseSafebox: 0x25,
  OpenGoldBarShop: 0x7B,
  PartyInvite: 0x26,
  PartyAnswer: 0x27,
  PartyLeave: 0x28,
  PartyKick: 0x29,
  PartyExpMode: 0x2A,
  CreateCharacter: 0x2B,
  Whisper: 0x2C,
  GuildCreate: 0x2D,
  GuildInvite: 0x2E,
  GuildAnswer: 0x2F,
  GuildLeave: 0x30,
  GuildWarChallenge: 0x43,
  GuildWarRefuse: 0x66,
  GuildPostComment: 0x67,
  GuildDeleteComment: 0x6F,
  GuildRefreshComments: 0x77,
  GuildDisband: 0x31,
  Welcome: 0x81,
  Reject: 0x82,
  Snapshot: 0x83,
  ChatEcho: 0x84,
  Pong: 0x85,
  CombatEvent: 0x86,
  CreateFly: 0xB0,
  SyncPosition: 0xFF,
  Bag: 0x88,
  ItemSet: 0xBF,
  ItemDel: 0xC0,
  Gold: 0xC1,
  Shop: 0x90,
  Notice: 0x89,
  Spirit: 0x8B,
  PvpStatus: 0x8A,
  PvpDuel: 0xA3,
  Skills: 0x8C,
  Affects: 0x8D,
  QuestDialog: 0x8E,
  QuestLog: 0x8F,
  QuestTargetCreate: 0xC6,
  QuestTargetUpdate: 0xC7,
  QuestTargetDelete: 0xC8,
  NpcPositions: 0xC9,
  RefineOffer: 0x91,
  RefineResult: 0x92,
  ExchangeState: 0x93,
  Safebox: 0x94,
  PartyInvitation: 0x95,
  Party: 0x96,
  PartyAttacker: 0x68,
  PartyRole: 0x6B,
  PartyUseSkill: 0x70,
  Characters: 0x97,
  EmpireSelectPrompt: 0x80,
  Standing: 0x87,
  Whispered: 0x98,
  GuildName: 0xA7,
  Guild: 0x99,
  GuildLandState: 0xFA,
  LandList: 0xFB,
  GuildInvitation: 0x9A,
  GuildFoundingPrompt: 0xF9,
  GuildWarMenu: 0xF4,
  GuildWarArena: 0xF5,
  GuildComments: 0xFC,
  Emote: 0x33,
  EmoteAnswer: 0x34,
  EmotePlayed: 0x9B,
  EmoteRequest: 0x9C,
  Mount: 0x9D,
  WalkMode: 0xA4,
  Stamina: 0xF8,
  Fish: 0x37,
  Fishing: 0x9E,
  FishCaught: 0x9F,
  FishingAct: 0xFE,
  Recall: 0x38,
  RestartHere: 0x7D,
  QuickSlotAdd: 0x7C,
  QuickSlotDel: 0x7E,
  QuickSlotSwap: 0x7F,
  QuickSlots: 0xA6,
  Warp: 0xA0,
  MapChange: 0xA1,
  SpecialEffect: 0xA2,
  SpecificEffect: 0xFD,
  PointChange: 0xC2,
  SelectCharacter: 0x3C,
  Arrive: 0x39,
  PetCommand: 0x4A,
  Polymorphed: 0xAE,
  PetSummoned: 0xAF,
  DeleteCharacter: 0x3D,
  Register: 0x3E,
  Registered: 0xA5,
  ArenaChallenge: 0x40,
  ArenaAnswer: 0x41,
  ArenaWatch: 0x42,
  ArenaInvitation: 0xA8,
  ArenaDuel: 0xA9,
  ArenaResult: 0xAA,
  OpenStall: 0x44,
  CloseStall: 0x45,
  EnterStall: 0x46,
  LeaveStall: 0x47,
  BuyFromStall: 0x48,
  StallSign: 0xAB,
  StallWindow: 0xAC,
  StallSold: 0xAD,
  CubeInfo: 0x4F,
  CubeMake: 0x50,
  CubeRecipes: 0xB1,
  CubeResult: 0xB2,
  CubeClosed: 0xBC,
  DragonSoulMove: 0x51,
  DragonSoulDeck: 0x52,
  DragonSoulRefine: 0x53,
  DragonSouls: 0xB3,
  DragonSoulRefined: 0xB4,
  Targeting: 0x64,
  Aimed: 0xBD,
  Targeted: 0xBB,
  EquipmentView: 0xD2,
  Mine: 0x72,
  Mining: 0xC3,
  MineResult: 0xC5,
  ProposeMarriage: 0x5C,
  AnswerMarriage: 0x5D,
  MarriageCommand: 0x5E,
  AddFriend: 0x5F,
  AnswerFriend: 0x60,
  RemoveFriend: 0x61,
  SetBlockMode: 0x62,
  MarriageStatus: 0xB8,
  FriendList: 0xB9,
  UploadEmblem: 0x69,
  RequestEmblem: 0x6A,
  Emblem: 0xBE,
  GuildSymbol: 0xCD,
  OpenAuction: 0x56,
  ListLot: 0x57,
  PlaceBid: 0x58,
  BuyLotNow: 0x59,
  ClaimLot: 0x5A,
  MallCheckout: 0x5B,
  AuctionBoard: 0xB5,
  MallWindow: 0xB6,
  AuctionNews: 0xB7,
  UseItemToItem: 0x74,
  UseItemToNpc: 0x79,
  GuildRank: 0x49,
  GuildPromote: 0x4B,
  GuildGeneral: 0x71,
  GuildExpel: 0x65,
  GuildHandOver: 0x4C,
  GuildBank: 0x4D,
  GuildOffer: 0x4E,
  GuildSkillUp: 0x54,
  GuildUseSkill: 0x55,
  GuildChargePower: 0x7A,
  GuildBuyLand: 0x3A,
  GuildPlaceBuilding: 0x3B,
  GuildUpgradeBuilding: 0x3F,
  UseDungeonDoor: 0x63,
  DungeonState: 0xBA,
  OXAnswer: 0x78,
  Environment: 0xCA,
  Weather: 0xCB,
  FieldMusic: 0xCC,
  AutoBanQuiz: 0xCE,
  MonarchInfo: 0xCF,
  OXQuestion: 0xD0,
  OXResult: 0xD1,
  StatusReset: 0x15,
  StatusResetOffer: 0xF0,
  StatusResetConfirm: 0xF1,
  QuestInputPrompt: 0xE0,
  QuestConfirmPrompt: 0xE1,
  QuestItemPrompt: 0xE2,
} as const;

export const SubCommand = {
  Targeting: {
    Target: 0x00,
    FlyTarget: 0x01,
    GuildSymbolChunk: 0x03,
    GuildSymbolCRC: 0x04,
  },
} as const;
